var faqData = {
  'A70 Max': {
    nav: [`pre-Sale Questions`, `Quick Start`, `Maintenance & Care`],
    nav_desc: [
      `What You Need to Know Before Buying`,
      `Your First Steps Made Simple(For Beginners) `,
      `Keep Your Machine in Top Shape`,
    ],
    quantions: [
      // Category 1: Pre-Sale Questions
      [
        {
          Q: `Can the machine engrave or cut metal?`,
          A: `Yes, it can engrave certain metals, including oxidized aluminum, brass, stainless steel, and iron. It can also cut thin stainless steel sheets up to 0.05mm.`,
        },
        {
          Q: `Can the machine engrave curved surfaces?`,
          A: `Yes, it can engrave regularly curved surfaces such as cups and insulated bottles. We recommend using our rotary accessories: R1-B (V2), R2-B (V2), R6, R8, or R8 PRO.`,
          video_url: ['https://youtu.be/zJSUY9wM60c'],
        },
        {
          Q: `What are the recommended settings for engraving or cutting leather?`,
          A: `Please consult the 70W Engraving Parameter Table for detailed settings. (The table is available on the included USB drive, on the AtomStack official website, or via our customer service team.)<br/>

  Important<br/>

  Tip: To prevent edge scorching or ignition when cutting leather, we suggest a “fast multi-pass cutting” approach: use high speed with high power, or low speed with low power.<br/>

  `,
        },
        {
          Q: `What advantages does this device have over other machines of the same power?`,
          A: `The A70 series is the world’s first 70W blue light laser engraver, offering a 30–50% increase in overall cutting capability. It supports high-speed creative engraving up to 24,000mm/min (400mm/s) and completes auto-focusing in just 8 seconds for faster startup.<br/>

  Product Highlights:<br/>

  Powerful Cutting: Can cut 1–26mm dark acrylic, 1–12mm MDF, 1–25mm pine,and 0.05mm stainless steel sheets.<br/>

  Large Working Area:<br/>

  A70 PRO: 500×400mm (max material 600×645mm)<br/>

  A70 MAX: 850×800mm<br/>

  New Motion Structure: Low-center-of-gravity dual-axis guides on all three axes ensure stable, quiet, high-speed operation, ideal for heavy-duty work.<br/>

  Offline Operation: Second-generation smart motherboard and touchscreen allow operation without a computer or phone.<br/>

  High-Flow Air Assist: Up to 60L/min airflow ensures clean cuts with no yellowing and extends laser module life.<br/>

  Versatile Applications: Suitable for copper, ceramics, black acrylic, woodworking, arts & crafts, DIY, signage, metal marking, and fashion design.Dual Focusing Modes: Supports manual and automatic focusing, completing in 8 seconds.<br/>

  Automatic Flame Alarm: Stops operation and triggers an alert if flames or sparks are detected.<br/>

  Smart Cooling System: Dual-layer air hood automatically activates during cutting for better smoke extraction and cooling.<br/>

  Power-Loss Resume: Allows continuation of unfinished projects after a power outage.<br/>

  Extensive Accessory Support: Compatible with cameras, rollers, extension rods, conveyor belts; A70 PRO supports a dedicated enclosure.`,
        },
        {
          Q: `Is there a suitable enclosure available?`,
          A: `Currently, no compatible enclosure is available.`,
        },
        {
          Q: `Are there suitable honeycomb panels?`,
          A: `A70 MAX: can use two F8 honeycomb panels spliced together<br/>

A70 PRO: can use an F4 honeycomb panel<br/>

`,
        },
        {
          Q: ` Can rotary devices be used?`,
          A: `Yes, the following rotary devices are supported: R1-B (V2), R2-B (V2), R6, R8, and R8 PRO.<br/>

Simply connect the rotary’s sequential cable to the engraver’s Y-axis motor plug.<br/>

Important Note: All AtomStack products use a sequential cable with a white connector. V2-series rotaries (R1 V2, R2 V2) manufactured before July 12, 2024, did not include this cable—please contact customer service to obtain one.`,
        },
        {
          Q: `Does it include air assist? What are the flow rate and noise level?`,
          A: `Yes, the machine comes with a dual-pump air assist. Airflow: ~60L/min; noise level: <60dB.`,
        },
        {
          Q: `Is it compatible with laser modules from other AtomStack models or other brands?`,
          A: `No, it is not compatible at this time.<br/>

[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_00c19a04-a6d9-45f6-add4-584b542abf2d.png?v=1763973345:Fig. 1]`,
        },
        {
          Q: `Can the laser module be used on other brands of engravers?`,
          A: `No, it is not compatible at this time.<br/>

[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_00c19a04-a6d9-45f6-add4-584b542abf2d.png?v=1763973345:Fig. 1]`,
        },
        {
          Q: `Can it be connected to a router?`,
          A: `The machine supports connection via the mobile App (using either the machine hotspot or Wi-Fi). App operation is stable.<br/>

However, remote control via IP address in LightBurn is unstable and may affect engraving performance.<br/>

(The mobile App can be downloaded from the app store or the AtomStack official website; the connection password is 12345678.)<br/>

`,
        },
      ],
      // Category 2: Quick Start
      [
        {
          Q: `How to install the machine?`,
          A: `Before operation, carefully read the Safety Statements and Warnings at the beginning of this manual.`,
          video_url: ['https://youtu.be/Rs_fsbWDQS8', 'https://youtu.be/G30fGjS-zKc'],
        },
        {
          Q: `How to connect the machine?`,
          A: `When using LightBurn or LaserGRBL, set the baud rate to 115200.<br/>

The correct COM port can be found in Device Manager, typically labeled as USB-SERIAL CH340 (COM*). Select the port corresponding to the displayed number.<br/>

<br/>

[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_fb0037b7-9816-4bcc-b8d4-94955e35009a.png?v=1764041816:Fig. 1]`,
          video_url: ['https://youtu.be/fHhCyWwuK08'],
        },
        {
          Q: ` How to connect the camera?`,
          A: `Recommended camera coverage: 400 × 400 mm.A70 Series Limitation:<br/>

The camera cannot fully cover the A70 series working area. Only a 400 × 400 mm area can be used when operating the A70.<br/>

Operation & Engraving Area:<br/>

Absolute coordinates must be used when operating the camera.<br/>

PRO machines: 500 × 400 mm engraving area<br/>

MAX machines: 850 × 800 mm engraving area<br/>

`,
          video_url: ['https://youtu.be/qrC4iJ_FlsE'],
        },
        {
          Q: `How to Connect the Rotary Attachment (R1-B(V2), R2-B(V2), R6, R8, R8 PRO)?`,
          A: `All AtomStack machines require sequential connection cables (daisy-chaining).<br/>

For elevated setups, use the supplied threaded extension feet.<br/>

<br/>

[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_b26ca13f-fa93-430a-90fe-badd4a6b875e.png?v=1764042270:Fig. 1]`,
          video_url: ['https://youtu.be/zJSUY9wM60c'],
        },
        {
          Q: `How to Use Auto Focus and Manual Focus?`,
          A: `Auto focus is recommended. Alternatively, use the focus module for manual adjustment.<br/>

Recommended Focus Heights:<br/>

Engraving: 20 mm<br/>

Cutting ≤ 20 mm thickness: 15 mm<br/>

Cutting > 20 mm thickness (maximum depth): 8 mm<br/>

Software Focus Command: [ESP500] (LightBurn / LaserGRBL)<br/>

<br/>

[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_37ccddb0-9162-47e9-a42e-915a531bb13e.png?v=1764048538:Fig. 1]`,
          video_url: ['https://youtu.be/HhFqlER4kRE'],
        },
        {
          Q: `How to Set and Position the Origin?`,
          A: `Refer to the origin setting, positioning, and crosshair calibration video tutorials.<br/>

Movement Guidelines:<br/>

Click Home to return the machine to the 0,0 absolute coordinate before setting the work origin.<br/>

Do not move the machine manually; all movement must be controlled via software.<br/>

If the machine is moved manually, re-home it before positioning or resuming work.<br/>

Crosshair Usage:<br/>

The center of the crosshair represents the initial laser emission position.<br/>

For any deviation, refer to the crosshair calibration video.<br/>

`,
          video_url: ['https://youtu.be/otsELzA1mCs', 'https://youtu.be/IUibPdqX4Mk'],
        },
        {
          Q: `How to Use Software Coordinate Systems?`,
          A: `Current Position (Relative): The laser starts from its current location. The laser head can be manually moved to the desired starting point.<br/>

User Origin (Offset): A user-defined starting position for the job. See the origin setting video for setup instructions.<br/>

Absolute Coordinates: Uses the 0,0 position after homing as the reference. The laser starts the job based on coordinates defined in the design file relative to the machine's 0,0.<br/>

`,
          video_url: ['https://youtu.be/otsELzA1mCs '],
        },
        {
          Q: `How to Test Software Engraving Parameters?`,
          A: `Requires a genuine license of LightBurn (version 1.3.01 or above) or AtomStack Studio to access this feature.`,
          video_url: ['https://youtu.be/2qoXsp_kKCw', 'https://youtu.be/fHhCyWwuK08'],
        },
      ],
      // Category 3: Maintenance & Care
      [
        {
          Q: `How to Clean the Laser Window and Focusing Lens?`,
          A: `Dirty window lenses can cause the laser to focus on the lens itself, potentially damaging both the window lens and the internal focusing lens.<br/>

Cleaning Procedure and Tools:<br/>

Cleaning Agent: Use 99% anhydrous ethanol or a professional optical lens cleaner. Avoid solvents containing ammonia or acetone.<br/>

Wiping Technique: Use a lint-free cloth or optical-grade cotton swab, wiping in a single, continuous direction (e.g., spiral from the center outward). Avoid back-and-forth motions to prevent scratches.<br/>

Tool Caution: Do not use regular cotton swabs, as they may shed fibers.<br/>

Post-Cleaning Check: Inspect the lens under strong light to ensure no residue, film, or fibers remain.<br/>

Maintenance Notes:<br/>

Frequency: Daily for high-use machines; weekly for low-use machines.<br/>

Important: The focusing lens is non-removable. Do not attempt to pry or disassemble it. Removing the outer window lens exposes the inner focusing lens.<br/>

<br/>

[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_8a635657-a8a8-4da8-ae5b-b3528a9af82f.png?v=1764051791:Fig. 1]`,
          video_url: ['https://youtu.be/6lzFNbED9Hc'],
        },
        {
          Q: `How to Clean the Laser Fan and Driver Board?`,
          A: `Laser Fan: Dust accumulation reduces cooling efficiency, causing overheating, shortened laser lifespan, or permanent damage.<br/>

Driver Board: Dust can cause components to overheat, short circuit, or burn out.<br/>

Recommended Cleaning Method:<br/>

Use compressed air or a soft brush to remove dust. Avoid applying excessive force or using liquids.<br/>

`,
          video_url: ['https://youtu.be/ZoJFD4k1RIM'],
        },
        {
          Q: `How to Clean and Maintain the Machine Frame?`,
          A: `Cleaning prevents dust or debris from entering rails or sliders, which could affect movement or cause abnormal noise.<br/>

Procedure:<br/>

Wipe the frame with 99% anhydrous ethanol.<br/>

After cleaning, apply grease evenly to the rails.<br/>

Recommended Grease and Frequency:<br/>

Grease: White Lithium Grease, Grade 2/3<br/>

Temperature < 15°C: Grade 2<br/>

Temperature ≥ 15°C: Grade 3<br/>

Frequency: Every 500 hours of operation<br/>

`,
          video_url: ['https://youtu.be/NNuQZsqwEXI'],
        },
        {
          Q: `How to Clean the Air Assist?`,
          A: `Air assist is essential for cutting performance. Dust blocking the pump intake can cause the pump to overheat and fail.<br/>

Frequency: High-use machines – monthly; Low-use machines – every 3 months.<br/>

`,
          video_url: ['https://youtu.be/0k50eGC9v4s'],
        },
        {
          Q: `How to Prepare for Long-Term Storage?`,
          A: `Store the machine in a dry location.<br/>

Avoid prolonged exposure to humid environments.<br/>

Power on periodically to check functionality.<br/>

`,
        },
        {
          Q: `What is the Recommended Operating Temperature?`,
          A: `Optimal Working Temperature: 0°C – 35°C`,
        },
        {
          Q: `How to Clean or Replace a Dirty or Damaged Laser Window/Focusing Lens?`,
          A: `Solution:<br/>

Window Lens: Remove and clean with 99% anhydrous alcohol or optical lens cleaner. Avoid ammonia or acetone-based solvents. Replace if stains cannot be removed.<br/>

Focusing Lens: Non-removable; never attempt to disassemble. If it cannot be cleaned or is damaged, the laser must be replaced.<br/>

Note: Regular cleaning prevents damage. Contact support with lens photos, machine serial number, and laser engraving code if replacement is needed.<br/>

<br/>

[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_224ec316-1f01-478f-839e-c94039066de3.png?v=1764054392:Fig. 1]<br/>

[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_875f387d-34a9-43c1-ae77-6c7afc69032e.png?v=1764054441:Fig. 2]`,
          video_url: ['https://youtu.be/6lzFNbED9Hc'],
        },
        {
          Q: `How to Troubleshoot Laser Cutting Power Decline?`,
          A: `Solution:<br/>

Normal Power Decay: Adjust power or speed to compensate.<br/>

Environment: Keep temperature ≤35°C. Avoid continuous full-power operation over 4 hours; cool down 15 minutes every 2 hours.<br/>

Software Settings: Follow parameter table; do not change maximum S value (1000).<br/>

Window/Focusing Lens: Clean or replace (see section 1).<br/>

Laser Dust: Clean fan and driver board with a soft brush.<br/>

Air Guide Hood: Check beam pattern (7 rectangular spots expected).<br/>

Persistent Issue: Replace laser; provide serial number, laser code, and inspection video.<br/>

<br/>

[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._3_bda9a17c-5070-4020-9155-9e47024f4b00.png?v=1764054813:Fig. 1]<br/>

[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_224ec316-1f01-478f-839e-c94039066de3.png?v=1764054392:Fig. 2]<br/>

[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_875f387d-34a9-43c1-ae77-6c7afc69032e.png?v=1764054441:Fig. 3]`,
          video_url: ['https://youtu.be/ZoJFD4k1RIM', 'https://youtu.be/HhFqlER4kRE'],
        },
        {
          Q: `How to Troubleshoot When the Laser Moves but Does Not Fire?`,
          A: `Solution:<br/>

Check software parameters.<br/>

Avoid reflective materials; paint black if needed.<br/>

Check laser cable connection, unplug and replug.<br/>

Measure 3PIN voltage to determine power supply, mainboard, or laser module fault.<br/>

Check driver board LED to identify tube or driver board issues.<br/>

<br/>

[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_401775d8-90a8-4ecd-9817-c4e6f7e6dac3.png?v=1764055431:Fig. 1]`,
          video_url: [
            'https://youtu.be/R7wosm3dEdI',
            'https://youtu.be/-6xZna8qMU8',
            'https://youtu.be/BXZju0WW4hQ',
            'https://youtu.be/GxpTrYe8z00',
          ],
        },
        {
          Q: `How to Troubleshoot Operations That Stop Mid-Operation and Resume After Restart?`,
          A: `Solution:<br/>

Reinsert TYPE-C cable.<br/>

On Windows 11, avoid running software in the background.<br/>

Check software progress, clean USB ports, try different cable/USB port.<br/>

Measure power output (20–25V & 30–37V).<br/>

Re-flash firmware.<br/>

If issue persists, replace mainboard.<br/>

<br/>

[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_59e1b61f-6ef3-44b8-94b1-08e4b39d43d9.png?v=1764056042:Fig. 1]`,
          video_url: ['https://youtu.be/9GVAxLu9GFs', 'https://youtu.be/R7wosm3dEdI'],
        },
        {
          Q: `How to Troubleshoot When the Laser Stops at a Certain Position While Moving?`,
          A: `Solution: Check mainboard connection cable; if laser fires after moving back, replace the cable.`,
        },
        {
          Q: `How to Troubleshoot Auto-Focus Failure?`,
          A: `Solution:<br/>

Check Z-axis movement via AtomStack Studio or LightBurn.<br/>

Adjust Z-axis structure or replace Z-axis motor if needed.<br/>

Inspect upper/lower limit switches; replace if faulty.<br/>

If Z-axis motor vibrates but laser doesn’t move, replace motor.<br/>

If movement only works one direction, check mainboard or connection cable.<br/>

<br/>

[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_ed9ff22d-2d6f-4bc1-9cb4-d1bb8f2d3878.png?v=1764059671:Fig. 1]<br/>

[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_02d107ac-b6e1-4453-b6c5-14f8fbeeabe6.png?v=1764059671:Fig. 2]<br/>

[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._3_99b09a48-cb14-4f47-b8a9-03eddf515141.png?v=1764059671:Fig. 3]<br/>

[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._4_7deaabf0-6fb9-4989-a9b8-a0d1ac87a212.png?v=1764059671:Fig. 4]<br/>

[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._5_1b140d81-93d8-426e-9629-bbc98dd1f048.png?v=1764059671:Fig. 5]`,
          video_url: [
            'https://youtu.be/nd8iuCfyDBo',
            'https://youtu.be/xiM_dekfmIU',
            'https://youtu.be/_KO5VjtipI0',
            'https://youtu.be/xiM_dekfmIU',
            'https://youtu.be/nd8iuCfyDBo',
            'https://youtu.be/R7wosm3dEdI',
            'https://youtu.be/rSGkKO_S2A0',
          ],
        },
        {
          Q: `How to Troubleshoot Abnormal X/Y Axis Movement?`,
          A: `Solution:<br/>

Test movement in software to identify faulty axis.<br/>

Check and reconnect motor cable.<br/>

Swap motors with the other axis to diagnose motor or driver fault.<br/>

If both axes fail, check mainboard connection cables; refresh firmware or replace mainboard if needed.<br/>

<br/>

[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_a26a8c1f-a3db-4e0c-90c8-9d94b41dd3c2.png?v=1764060965:Fig. 1]<br/>

[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_ef972445-958a-4518-aeaf-8d08d7913b55.png?v=1764060965:Fig. 2]<br/>

[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._3_c45a2136-f3d3-4b74-89e8-8670a8810881.png?v=1764060965:Fig. 3]`,
          video_url: [
            'https://youtu.be/nd8iuCfyDBo',
            'https://youtu.be/nd8iuCfyDBo',
            'https://youtu.be/R7wosm3dEdI',
            'https://youtu.be/rSGkKO_S2A0',
          ],
        },
        {
          Q: `How to Troubleshoot Connection Failure to the Computer?`,
          A: `Solution:<br/>

Verify COM port and baud rate (115200, GRBL).<br/>

Install USB drivers (CH340/FTDI).<br/>

Test with AtomStack Studio.<br/>

Mac users: use a dock to connect Type-C to USB-A.<br/>

Check cables and firmware; replace mainboard if necessary.<br/>

<br/>

[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_70dd00b1-ceb9-4272-bf3b-41c654214552.png?v=1764061563:Fig. 1]<br/>

[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_29b1ba66-7c2c-43df-b061-f0ee43d1cadc.png?v=1764061563:Fig. 2]<br/>

[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._3_d0015e0a-7f30-4606-bc78-71b306140584.png?v=1764061563:Fig. 3]<br/>

[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._4_2c1bd2d1-f046-4bd9-ae9b-370ef7795297.png?v=1764061563:Fig. 4]<br/>

[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._5_8c8ac32a-24ed-4a05-bcca-e17b2c2eee77.png?v=1764061564:Fig. 5]`,
          video_url: ['https://youtu.be/R7wosm3dEdI '],
        },
        {
          Q: `How to Troubleshoot Irregular Engraving Patterns?`,
          A: `Solution:<br/>

Engrave squares/circles to identify faulty axis.<br/>

Inspect rails, pulleys, belts, and laser mount.<br/>

Adjust structure and retest.<br/>

Ensure X-axis and bottom beam are parallel.<br/>

Check step values ($100/$101).<br/>

Re-flash firmware if step values are correct.<br/>

If unresolved, replace mainboard.<br/>

`,
          video_url: [
            'https://youtu.be/bwJMCS_O-zE',
            'https://youtu.be/_z_IGAiNxzc',
            'https://youtu.be/R7wosm3dEdI',
          ],
        },
        {
          Q: `How to resolve Crosshair and Laser Spot Misalignment?`,
          A: `Solution: Recalibrate if misalignment exceeds 1mm.`,
          video_url: ['https://youtu.be/IUibPdqX4Mk'],
        },
        {
          Q: `How to Troubleshoot Frequent Flame Alarms?`,
          A: `Solution:<br/>

Disable flame detection for flammable materials; supervise cutting.<br/>

For dense patterns, increase speed or split into multiple passes.<br/>

Persistent low-power alarms may indicate faulty flame detection board; replace.<br/>

`,
          video_url: ['https://youtu.be/kj5YqY8iAmE', 'https://youtu.be/1yhYDuFlY6E'],
        },
        {
          Q: `How to Troubleshoot Continuous Rotary Axis Spinning?`,
          A: `Solution: Disable “Power-on Auto-Home” and “Return to Endpoint” functions; avoid absolute coordinate mode.<br/>

[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_5bc5110b-38f1-44ef-a319-a923738a0160.png?v=1764138676:Fig. 1]<br/>

[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_252aa5b2-4d21-4bbb-bda9-2382a9255fb3.png?v=1764138676:Fig. 2]`,
        },
        {
          Q: `How to Troubleshoot Collisions During Edge Detection or Engraving?`,
          A: `Solution:<br/>

Check file size and coordinates.<br/>

Verify auxiliary positioning and software control.<br/>

Refresh firmware or replace mainboard if needed.<br/>

`,
          video_url: ['https://youtu.be/9GVAxLu9GFs', 'https://youtu.be/R7wosm3dEdI'],
        },
        {
          Q: `How to Troubleshoot When the Fan Does Not Spin?`,
          A: `Solution:<br/>

Remove obstructions; clean dust; check blade movement.<br/>

Check fan terminal connection.<br/>

Test fan independently; replace fan or driver board if needed.<br/>

`,
          video_url: ['https://youtu.be/GxpTrYe8z00'],
        },
        {
          Q: `How to Troubleshoot When the Power Switch Indicator Is Not Lit?`,
          A: `Solution:<br/>

Indicator lights only during engraving/cutting.<br/>

Check switch function and cable connection.<br/>

If normal, replace driver board.<br/>

<br/>

[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_665cacc8-76fd-4851-a13f-669e5684e947.png?v=1764139290:Fig. 1]`,
          video_url: ['https://youtu.be/Wb0vrRkKQr4', 'https://youtu.be/GxpTrYe8z00'],
        },
        {
          Q: `How to Tighten a Loose Laser Mount?`,
          A: `Solution: Tighten screws or replace X-axis slider.`,
          video_url: ['https://youtu.be/_z_IGAiNxzc', 'https://youtu.be/h136ouvOzZ4'],
        },
        {
          Q: `How to Troubleshoot Incorrect Homing Direction?`,
          A: `Solution: Adjust $23 parameter or reset ($RST=*); re-flash firmware if needed.<br/>

[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_d7259c29-f41e-4d09-8c45-c4503fae8f79.png?v=1764140571:Fig. 1]<br/>

[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_32f0ddfb-48b3-4869-996d-ffb46ac553ce.png?v=1764140571:Fig. 2]`,
          video_url: ['https://youtu.be/9GVAxLu9GFs'],
        },
        {
          Q: `How to Troubleshoot When the USB Drive Cannot Be Read?`,
          A: `Solution:<br/>

Test USB on computer; replace if faulty.<br/>

Format to FAT32.<br/>

If still fails, USB port/mainboard may need replacement.<br/>

`,
          video_url: ['https://youtu.be/R7wosm3dEdI'],
        },
        {
          Q: `How to Troubleshoot Mobile App Connection Issues?`,
          A: `Solution:<br/>

Verify connection procedure.<br/>

Update App to latest version.<br/>

Ensure phone detects laser Wi-Fi (Engraver_***).<br/>

Test other phones; if unsuccessful, replace mainboard.<br/>

`,
          video_url: ['https://youtu.be/2gEosgOEtZo', 'https://youtu.be/R7wosm3dEdI'],
        },
        {
          Q: `How to Troubleshoot When the APP Engraving Interrupted, U Disk Not Detected?`,
          A: `Solution: Replace USB drive.`,
        },
        {
          Q: `How to Troubleshoot When the Control Screen is Black?`,
          A: `Solution:<br/>

Check machine startup.<br/>

Check HDMI connection.<br/>

Touchscreen with sound but no display may indicate mainboard/HDMI issue; no sound may indicate screen fault.<br/>

`,
          video_url: ['https://youtu.be/24KQlGrgTlE'],
        },
        {
          Q: `How to Troubleshoot When the Laser Cannot Be Moved Manually After Powering On?`,
          A: `Solution:<br/>

Disable “Power Resume” feature.<br/>

Check mainboard cables; refresh firmware or replace mainboard if needed.<br/>

`,
          video_url: ['https://youtu.be/kj5YqY8iAmE', 'https://youtu.be/R7wosm3dEdI'],
        },
        {
          Q: `How to Troubleshoot Weak and Noisy Air Assist?`,
          A: `Solution:<br/>

Check for bent or obstructed tubing.<br/>

Test max airflow; clean inside dust.<br/>

Replace pump if still weak.<br/>

`,
          video_url: ['https://youtu.be/j-uBp4ZGrGc', 'https://youtu.be/W3jZZid4ZdM'],
        },
        {
          Q: `How to Troubleshoot When the Air Assist Won't Turn On?`,
          A: `Solution:<br/>

Ensure power and operation running.<br/>

Check pump and power supply.<br/>

Measure 12V output; replace speed controller if faulty.<br/>

`,
          video_url: [
            'https://youtu.be/W3jZZid4ZdM',
            'https://youtu.be/9ALA-U2AnoQ',
            'https://youtu.be/_hnlEV2_Ka0',
          ],
        },
        {
          Q: `How to Troubleshoot No Laser Power Output?`,
          A: `Solution:<br/>

Verify input voltage switch matches local voltage.<br/>

Measure DC output; replace power supply if abnormal.<br/>

Check fuse and wiring.<br/>

<br/>

[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_2002de7d-a016-45a7-aa3d-4a2cbc65711d.png?v=1764143145:Fig. 1]<br/>

[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_95d65b02-ef09-48db-b5d1-5a71a2996c00.png?v=1764143145:Fig. 2]`,
        },
        {
          Q: `How to Troubleshoot Software Alarm 9?`,
          A: `Solution:<br/>

Check limit switches.<br/>

Ensure Z-axis auto-focus completes; see section 6.<br/>

if multiple alarms persist, refresh firmware or replace mainboard.<br/>

`,
          video_url: ['https://youtu.be/R7wosm3dEdI'],
        },
        {
          Q: `How to Troubleshoot Common Machine Alarms?`,
          A: `Alarm 1: Limit switch triggered<br/>

Alarm 2: Soft limit triggered ($20)<br/>

Alarm 3: Operation interrupted<br/>

Alarm 8: Limit switch continuously triggered<br/>

Alarm 11: Machine tilt<br/>

Alarm 12: Flame detection<br/>

[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_786fba4d-593b-4096-bd8d-62c0b09f04eb.png?v=1764143875:Fig. 1]`,
        },
        {
          Q: `How to Update Software, Firmware, and the Mobile App?`,
          A: `AtomStack Studio: Automatic/manual updates.<br/>

Firmware: Update via App or serial number request; copy to USB root.<br/>

App: Download latest version from AtomStack.com or update in-app.<br/>

`,
        },
      ],
    ],
  },
  Kraft: {
    nav: [`pre-Sale Questions`, `Quick Start`, `Maintenance & Care`],
    nav_desc: [
      `What You Need to Know Before Buying`,
      `Your First Steps Made Simple(For Beginners) `,
      `Keep Your Machine in Top Shape`,
    ],
    quantions: [
      [
        {
          Q: `Is Kraft safe to use?`,
          A: `Kraft features a fully enclosed design and has passed IEC/EN60825-1 Class 1 certification, meeting Class 1 laser safety standards.<br/>

        A safety lock automatically stops the laser when the door is opened, preventing injury.<br/>

        The viewing window uses a filtered material, so safety goggles are not required when the door is closed.`,
          video_url: [],
        },
        {
          Q: `Can Kraft engrave metal?`,
          A: `Yes. Kraft’s dual-laser system (red + blue) works with most materials.<br/>

        For metals, we recommend using red light or the dual-light mode.<br/>

        Please refer to the Kraft engraving parameter sheet for specific settings. You can access it via:<br/>

        Scanning the QR code on the machine.<br/>

        Visiting [link:https://atomstack.com/pages/product-support]<br/>

        Contacting our customer service.`,
          video_url: [],
        },
        {
          Q: `Does Kraft come with air assist?`,
          A: `No. To use air assist, you need the F70 fire-suppression pump.<br/>

        The F70 provides standard air assist and automatic fire suppression.<br/>

        To enable auto fire suppression, fill the water tank and connect both power outputs to Kraft’s air assist and fire pump ports.<br/>

        Refer to the manual for setup instructions.`,
          video_url: [],
        },
        {
          Q: `Can Kraft use a rotary attachment?`,
          A: `Yes. Recommended rotary attachments are R6, R8, and R8 Pro, all with auto-detection.<br/>

        With AtomStack Studio: R6 works automatically; R8 requires entering material diameter or circumference.<br/>

        With LightBurn: Set up according to the rotary type.See Kraft Rotary Accessory Guide for details.`,
          video_url: [],
        },
        {
          Q: `What is Kraft’s engraving area?`,
          A: `Standard: 500 × 320 mm<br/>

        With R5 conveyor expansion: up to 500 × 800 mm (H3 riser required)`,
          video_url: [],
        },
        {
          Q: `Can Kraft be expanded for larger materials?`,
          A: `Yes. Using the R5 conveyor, the working area can reach 500 × 800 mm.<br/>

        An H3 riser is required for proper setup.`,
          video_url: [],
        },
        {
          Q: `What is the maximum material thickness Kraft can engrave?`,
          A: `With the baseboard installed: up to 55 mm<br/>

        Baseboard removed: theoretically unlimited thickness, as long as all four support feet are level and stable<br/>

        With H3 riser: adds up to 100 mm`,
          video_url: [],
        },
        {
          Q: `Can Kraft use other brands of lasers?`,
          A: `No. Laser installation and wiring are specific to Kraft. However, the 40W laser and 20W+1.2W red-blue dual-laser are interchangeable.`,
          video_url: [],
        },
        {
          Q: `Can Kraft engrave leather? What are the parameters?`,
          A: `Yes. Leather can be engraved using blue light, infrared, or dual-light mode.<br/>

        Refer to the parameter sheet for settings (QR code, [link:https://atomstack.com/pages/product-support] , or customer service).`,
          video_url: [],
        },
        {
          Q: `Does Kraft come with a honeycomb board?`,
          A: `Yes, a honeycomb board is included.`,
          video_url: [],
        },
        {
          Q: `Can Kraft be controlled via touchscreen?`,
          A: `Yes, using the CR1 touchscreen. Note: do not connect other powered displays (HDMI monitors, TVs, etc.) to Kraft’s HDMI port.`,
          video_url: [],
        },
        {
          Q: `Does Kraft have Wi-Fi and a mobile app?`,
          A: `Yes. You can connect Kraft via the app. Refer to the unboxing and setup video for instructions.`,
          video_url: [`https://youtu.be/p_WDoDDHwYA`],
        },
        {
          Q: `Which software is compatible with Kraft?`,
          A: `AtomStack Studio, LightBurn, and the AtomStack app.`,
          video_url: [],
        },
        {
          Q: `Can Kraft’s laser be upgraded?`,
          A: `Currently, Kraft supports two compatible lasers:<br/>

        20W + 1.2W red-blue dual laser<br/>

        40W variable-power laser`,
          video_url: [],
        },
        {
          Q: `Are there compatible air purifiers for Kraft?`,
          A: `Yes, we recommend the AtomStack D4 purifier.<br/>

        Fan flange diameter: 75 mm<br/>

        Included exhaust hose: 76 mm diameter, 2 m length (can be shortened to 160 mm)`,
          video_url: [],
        },
        {
          Q: `What is Kraft’s noise level?`,
          A: `Ambient: 48.3 dB<br/>

        Horizontal engraving: 72 dB<br/>

        Vertical engraving: 81.9 dB`,
          video_url: [],
        },
        {
          Q: `What are Kraft’s advantages compared to other models?`,
          A: `World’s first dual-laser synchronous engraver combining a 20W blue diode laser with a 1.2W infrared laser.<br/>

        Three laser modes with one-click switching.<br/>

        Large working area: 500 × 320 mm, expandable to 500 × 800 mm with conveyor.<br/>

        Built-in 16MP 4K camera for 0.5 mm precise positioning; compatible with AtomStack Studio and LightBurn.<br/>

        Rich accessory ecosystem: fire pump, rotary devices, risers, air purifiers.<br/>

        Power loss recovery: resumes engraving after interruptions to prevent material waste.<br/>

        Fully enclosed design with Class 1 laser safety, safety lock, and filtered viewing window.`,
          video_url: [],
        },
      ],

      [
        {
          Q: `1. Kraft control interface introduction`,
          A: `[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/1_d091799c-2951-4fa8-a908-6399ed53b330.png?v=1767686993:]<br/>

          （1）Laser Mode Switch Button: Allows switching between Blue Laser Mode, Infrared Mode, and Dual Blue & Infrared Mode.<br/>

          Press and hold for 5 seconds to reset the network configuration.<br/>

          （2）Auto Focus Button: Initiates the auto-focusing function.<br/>

          （3）Alarm Indicator: A red light indicates an alarm state; a green light indicates normal operation.<br/>

          （4）Power Switch: Turns the engraver on or off.<br/>

          （5）Air Assist Power Port: Supplies power to the air assist system and enables control of its on/off state.<br/>

          Output voltage: 24V.<br/>

          （6）Power Input Port: Connects to the included 24V 9A power adapter.<br/>

          （7）Air Assist Hose Port: Connects to the air assist hose.<br/>

          （8）Type-C Port: Connects to a computer via a Type-C cable.<br/>

          （9）Touchscreen Port: Connects to a touchscreen using an HDMI cable.<br/>

          Note: Please do not connect HDMI cables from other powered devices, including monitors or televisions.<br/>

          （10）USB Drive Port: Allows USB flash drive insertion. Note: A USB drive must be inserted when using the touchscreen or mobile app.<br/>

          （11）USB Dongle Port: The engraving machine will not start unless the USB dongle is inserted.<br/>

          （12）Accessory Port: Connects to accessories such as rotary or conveyor feeders, with automatic recognition capability.<br/>

          （13）Fire Extinguishing Air Pump Power Output Port: Connects to an air assist system with automatic fire extinguishing capability.<br/>

          （14）Wi-Fi Antenna: Enhances Wi-Fi signal strength.<br/>

          （15）Smoke Exhaust Fan: The fan flange has a diameter of 75 mm and connects to the included exhaust hose (diameter 76 mm, compressed length 160 mm, extended length 2 meters).`,
          video_url: [],
        },
        {
          Q: `Kraft unboxing and setup`,
          A: `Please carefully read the safety statements and warnings at the beginning of the manual before use. 。<br/>

        Note:<br/>

        (1)When using AtomStack Studio software, no additional settings are required to connect and use the device.<br/>

        [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_1_0f50f6b1-5f5b-424e-97b1-8ab2a9aef518.png?v=1767687283:Figure 1]<br/>

        When connecting with LightBurn software, the baud rate needs to be changed to 460800 (see Figure 1).<br/>

        Alternatively, you can import the provided “configuration file” from the USB drive into the software.<br/>

        Some versions may have the baud rate setting window hidden; this can be resolved by importing our configuration file.<br/>

        Refer to the LightBurn configuration file import tutorial video for guidance.<br/>

        (2)When connecting to a computer's USB port, macOS users should not plug in the Type-C cable directly.<br/>

        Instead, a docking station (see F igure 2) must be used to convert the connection to Type-A.<br/>

        [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_2.png?v=1767687284:Figure 2]`,
          video_url: [`https://youtu.be/p_WDoDDHwYA`, `https://youtu.be/owtluqIgUGA`],
        },
        {
          Q: `Layer mode description`,
          A: `(1)AtomStack Studio，as figure 3：<br/>

    [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_3.png?v=1767687991:Figure 3]<br/>

    Image Mode: Automatically generates a file after importing an image.<br/>

    Line Mode: Used when engraving vector graphics.<br/>

    Fill Mode: Fills the area between lines — this is the engraving mode.<br/>

    Cut Mode: Cuts through the object — this is the cutting mode.<br/>

    LightBurn，as figure 4：<br/>

    [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_4.png?v=1767687991:Figure 4]<br/>

    Image Mode:<br/>

    After importing an image, the system defaults to Image Mode, which is used for engraving.<br/>

    Fill Mode:<br/>

    Fills the area between lines and is used for engraving.<br/>

    Fill + Line Mode:<br/>

    Fills the area between lines and also cuts along the lines. This mode performs both engraving and cutting.<br/>

    Line Mode:<br/>

    Used for engraving vector files or for cutting operations.`,
          video_url: [],
        },
        {
          Q: `Kraft focus adjustment`,
          A: `Note: Kraft supports both automatic and manual focusing methods.<br/>

    Automatic Focusing Methods:<br/>

    Use the autofocus button on the machine;<br/>

    AtomStack Studio Click the focus button in the software(se Figure 5);<br/>

    Enter [ESP500] in the macro command area of LightBurn(se Figure 6);<br/>

    Manual Focusing Method:<br/>

    Use the included fixed-focus spacer and adjust the focus to 40 mm by turning the manual focus knob located at the back of the Z-axis (see Figure 7)， the distance between the bottom plane of the laser head and material<br/>

    [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_5.png?v=1767688463:Figure 5]<br/>

    [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_6.png?v=1767688463:Figure 6]<br/>

    [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_7.png?v=1767688463:Figure 7]`,
          video_url: [`https://youtu.be/wbhrViu3EGE`],
        },
        {
          Q: `Kraft infrared and blue laser switching & dual laser mode`,
          A: `Note: When using Dual Laser Mode, make sure the focal distance is accurately set to 40 mm.If the focus is incorrect, the infrared laser may not achieve optimal engraving results.`,
          video_url: [`https://youtu.be/FDSFReD3tO0`],
        },
        {
          Q: `Kraft laser replacement`,
          A: ``,
          video_url: [`https://youtu.be/leUQfQl34Lw`],
        },
        {
          Q: `How to Use the Camera on Kraft`,
          A: `Note: When using the camera feature, you need to set Start From to Absolute Coords.In AtomStack Studio, refer to Figure 6;<br/>

    In LightBurn, refer to Figure 7.In LightBurn, refer to Figure 7.<br/>

    [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_8.png?v=1767688730:Figure 8]<br/>

    [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_9.png?v=1767688730:Figure 9]`,
          video_url: [`https://youtu.be/1q3v3KF3Af0`],
        },
        {
          Q: `Kraft conveyor feeder application`,
          A: `Note: When using the conveyor, you must install the H3 riser to elevate the Kraft machine chassis.`,
          video_url: [`https://youtu.be/HCWcF6x3X7Q`],
        },
        {
          Q: `Kraft rotaries application`,
          A: `Notes:<br/>

        (1)Supported rotary devices with automatic recognition are compatible with models R6, R8, and R8 Pro.<br/>

        When using, you need to install the H3 riser to elevate the Kraft machine chassis.<br/>

        (2)Insert the rotary device’s automatic recognition cable (USB connectors at both ends, see Figure 10) into the accessory port of the Kraft engraver (the port marked as number 12 on the panel).<br/>

        The rotary device will then be automatically recognized, and no step length adjustment is required.<br/>

        [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_10.png?v=1767689118:Figure 10]<br/>

        (3)When using the AtomStack Studio software, the rotary roller (R6) requires no parameter settings,<br/>

        the chuck (R8) requires setting the material’s circumference or diameter, as shown in Figure 11：<br/>

        [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_11.png?v=1767689118:Figure 11]<br/>

        （4）When using LightBurn, rotary settings as follows:<br/>

        Rotation Type: Select Roller for R6, Select Chuck for R8<br/>

        Rotation Axis: Choose the Y-axis<br/>

        Parameter Settings:<br/>

        For R8:<br/>

        Set mm per rotation to 160 (fixed value)<br/>

        Enter either the material’s diameter or circumference<br/>

        For R6:<br/>

        Set mm per rotation to 50 (fixed value)<br/>

        Set roller diameter to 16 mm (fixed value)<br/>

        Enter either the material’s diameter or circumference<br/>

        Refer to Figure 12 for details.<br/>

        [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_12.png?v=1767689118:Figure 12]`,
          video_url: [`https://youtu.be/kKcwHmaSVI8`],
        },
        {
          Q: `Kraft air assist application (with Fire Suppression Function)`,
          A: `Note: When using the included air assist system, make sure to connect to the correct ports — distinguish between the air pump power port and the fire suppression power port (refer to the \`Panel Functions Introduction\` section).<br/>

    Before using the fire suppression function, ensure the air assist water tank is filled with water.`,
          video_url: [`https://youtu.be/LXLHSATvD0w`],
        },
        {
          Q: `Introduction to the Software Coordinate System`,
          A: `Current Position:<br/>

      Uses the laser head’s current location as the starting point for engraving.<br/>

      You can manually move the laser head to any desired position before starting.<br/>

      User Origin:<br/>

      The starting point is manually set by the user as the laser’s working origin.<br/>

      Refer to the Origin Setting Video for instructions .<br/>

      Absolute Coordinates:<br/>

      Uses the machine’s (0, 0) coordinate as the fixed starting point.`,
          video_url: [],
        },
        {
          Q: `Tutorial: Engraving Parameter Testing in the Software`,
          A: `Note: This feature is only available with a licensed version of LightBurn (version 1.3.01 or above) or AtomStack Studio.`,
          video_url: [`https://youtu.be/sUPmUo3cLwE`],
        },
      ],
      [
        {
          Q: `Kraft Machine Chassis Cleaning and Maintenance`,
          A: `Cleaning Method:<br/>

    Use 99% pure anhydrous ethanol as the cleaning agent and wipe gently with a lint-free cloth.<br/>

    Avoid rubbing back and forth to prevent scratches.<br/>

    When cleaning the exhaust fan, the fan must be disassembled carefully—do not use force.<br/>

    Refer to the Kraft Machine Housing Cleaning and Maintenance Video for the screw removal procedure.<br/>

    Maintenance Method:<br/>

    After cleaning the linear shafts on the X and Y axes, evenly apply grease on them.<br/>

    (Regarding grease selection, it is recommended to use white oil grade 2/3. For environments below 15°C, use grade 2; for environments above 15°C, use grade 3.)<br/>

    Cleaning Frequency:<br/>

    For users with frequent usage, cleaning is recommended once a week.<br/>

    For users with less frequent usage, cleaning is recommended once a month.`,
          video_url: [`https://youtu.be/qOaaI53eYK4`],
        },
        {
          Q: `Kraft laser cleaning`,
          A: `Notes:<br/>

    (1)Air Guide Hood Cleaning Method:<br/>

    Before cleaning the protective glass, first remove the small screws on the air guide hood using an L1.5 hex screwdriver (see Figure 13), then take off the air guide hood.<br/>

    Use 99% pure anhydrous ethanol and a lint-free cloth or optical-grade lint-free cotton to wipe it clean.<br/>

    Recommended Tools:<br/>

    Lint-free cloth or optical-grade lint-free cotton.<br/>

    Post-Cleaning Check:<br/>

    Ensure the holes of the air guide hood are not blocked and free from any stains.<br/>

    Cleaning Frequency:<br/>

    For high-frequency users, clean once daily. For low-frequency users, clean once weekly.<br/>

    [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_13.png?v=1767691220:Figure 13]<br/>

    (2)Protective glass<br/>

    Cleaning Method:<br/>

    Use 99% pure anhydrous ethanol or a professional optical lens cleaner (avoid solvents containing ammonia or acetone).<br/>

    When wiping, use a lint-free cloth and wipe gently in a single direction (e.g.spiral from the center outward) to avoid scratches caused by back-and-forth rubbing.<br/>

    Recommended Tools:<br/>

    Use lint-free cloth or optical-grade lint-free cotton swabs (avoid regular cotton swabs that shed fibers).<br/>

    Post-Cleaning Check:<br/>

    Inspect the glass surface by shining a strong light from the side to ensure no residual watermarks or fibers remain.<br/>

    Cleaning Frequency:<br/>

    High-frequency users are advised to clean daily, and low-frequency users weekly.<br/>

    Precautions:<br/>

    The lens must not be disassembled. Do not attempt to pry open or dismantle it yourself, as this will damage the laser’s sealed structure.<br/>

    A dirty protective glass can cause laser focus damage on the lens surface, which may also lead to lens damage.<br/>

    (3)Laser Module Fan<br/>

    Cleaning Method:<br/>

    Before cleaning, open the laser fan cover and remove the fan.<br/>

    Use 99% pure anhydrous ethanol and a lint-free cloth to gently wipe off any dirt or debris on the fan.<br/>

    Recommended Tools:<br/>

    Use a lint-free cloth or optical-grade lint-free cotton swabs (avoid regular cotton swabs that shed fibers).<br/>

    Cleaning Frequency:<br/>

    For high-frequency users: clean once a week.<br/>

    For low-frequency users: clean once a month.<br/>

    Precautions:<br/>

    Do not disassemble the driver board.<br/>

    Do not use corrosive liquids for cleaning.`,
          video_url: [`https://youtu.be/H8cfU-eOHr8`],
        },
        {
          Q: `Kraft air assist cleaning`,
          A: `Notes:<br/>

    Reason for Cleaning:<br/>

    The air assist is an essential accessory for cutting. If dust clogs the air pump’s intake port, it can cause abnormal overheating, which may damage the pump.<br/>

    Cleaning Method:<br/>

    Use 99% pure anhydrous ethanol as the cleaning agent. Gently wipe the vent holes of the air pump with a lint-free cloth.<br/>

    Cleaning Frequency:<br/>

    For high-frequency users: clean once a week.<br/>

    For low-frequency users: clean once a month.<br/>

    Precautions:<br/>

    As the Kraft air assist system also includes an automatic fire suppression function, make sure to clean the water tank during maintenance as well.`,
          video_url: [`https://youtu.be/UuUYoA9wr7M`],
        },
        {
          Q: `What is the recommended operating temperature for Kraft?`,
          A: `The recommended operating temperature is 0°C to 35°C.`,
          video_url: [],
        },
        {
          Q: `What should I be aware of if the Kraft machine will not be used for an extended period？`,
          A: `Store the machine in a dry environment, and avoid exposing it to humidity for long durations.It is also recommended to power on the machine periodically.`,
          video_url: [],
        },
        {
          Q: `Kraft laser protective glass or focusing lens is dirty or damaged.`,
          A: `Solution:<br/>

    (1) Clean the protective glass:<br/>

    Cleaning method: Use 99% pure anhydrous ethanol to clean. Use a dust-free cloth to wipe gently to avoid scratches caused by friction.<br/>

    When cleaning the exhaust fan, you need to disassemble the fan. Do not disassemble it violently.<br/>

    For screw removal operations, refer to the Kraft enclosure cleaning and maintenance video.<br/>

    Cleaning frequency: Users with high frequency of use are recommended to clean it once a week, and users with low frequency of use are recommended to clean it once a month.<br/>

    Reference video: Kraft laser cleaning video.<br/>

    Note: If the stains on the protective glass cannot be wiped off or it is damaged, it needs to be replaced in time.<br/>

    (2) The focusing lens cannot be disassembled. If the focusing mirror is dirty, please wipe it according to the protective glass cleaning method.<br/>

    If it is damaged, you can only replace the laser.<br/>

    It is strictly forbidden to try to pry or disassemble it by yourself, otherwise it will damage the laser sealing structure.<br/>

    If it is damaged and the laser needs to be replaced, please provide the customer service staff with a clear picture of the broken (damaged) protective glass or focusing lens, the machine's serial number (as shown in Figure 14), and the laser laser engraving code (as shown in Figure 15) so that the customer service staff can handle it.<br/>

    [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure14.png?v=1767691220:Figure 14]<br/>

    [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_15.png?v=1767691219:Figure 15]`,
          video_url: [`https://youtu.be/H8cfU-eOHr8`],
        },
        {
          Q: `The cutting performance of the Kraft laser has significantly deteriorated, and the engraving quality is poor.`,
          A: `Solution:<br/>

    (1) Check the focal distance: If you did not refocus after switching to materials of different thicknesses, press the auto-focus button to refocus automatically;<br/>

    or use the included fixed-focus piece and adjust the knob behind the Z-axis (see figure) to set the focal distance to 40 mm.<br/>

    (2) Confirm usage duration: Laser modules naturally degrade over time with extended use.<br/>

    Try increasing the power or reducing the speed to compensate for the loss.<br/>

    (3) Check software parameter settings: Ensure the engraving parameters set in the software match or are close to the recommended values for the material, as specified in the parameter table.<br/>

    How to view the Kraft parameter table:<br/>

    ①Enter to view by scanning the QR code on the engraving machine.<br/>

    ②Enter the official website to view [link:https://atomstack.com/pages/product-support].<br/>

    ③Contact customer service staff to request it.<br/>

    (4) Check the laser mode selected in Kraft: The 1.2W infrared laser has no cutting capability and should not be selected for cutting tasks.<br/>

    (5) Check S-value max: If you are using LightBurn software, note that the S-value max is fixed at 1000 and cannot be modified (see Figure 16).<br/>

    [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_16.png?v=1767691219:Figure 16]<br/>

    Check the power adapter: If the adapter voltage is abnormal, use a multimeter set to the DC voltage range to measure whether the adapter's output is between 20V and 24V (see Figure 17).<br/>

    [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_17.png?v=1767691220:Figure 17]<br/>

    (7) Checl the voltage at the laser module connector:<br/>

    Disconnect the laser connector, then run a cutting program at 100% power and 1 mm/min speed.<br/>

    Using a multimeter set to the DC voltage range, measure the following:<br/>

    Between Pin 2 (24V) and Pin 3 (GND), the voltage should be between 20V and 25V.<br/>

    Between Pin 4 (GND) and Pin 5 (Blue Light PWM), the voltage should be between 1V and 6V.<br/>

    Refer to the Kraft laser connector voltage measurement video for guidance.<br/>

    (8) If all of the above checks are normal, the laser module is likely experiencing a power failure and needs to be replaced.<br/>

    Please provide the full troubleshooting process, the machine's serial number (see Figure 18), and the laser module's laser-engraved code (see Figure 19) to customer service for assistance.<br/>

    If the measured voltage at the laser connector is below 20V, the issue lies with the motherboard or connection cable.<br/>

    In that case, please submit a troubleshooting video and the machine's serial number to customer service.<br/>

    When replacing components, refer to the Kraft laser replacement video, Kraft motherboard replacement video, and Kraft motherboard cable replacement video.<br/>

    [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure18.png?v=1767691219:Figure 18]<br/>

    [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_19.png?v=1767691219:Figure 19]`,
          video_url: [
            `https://youtu.be/t5eae1vGkjE`,
            `https://youtu.be/leUQfQl34Lw`,
            `https://youtu.be/1Gd5fKsAlLA`,
            `https://youtu.be/pzhm-CW99CQ`,
          ],
        },
        {
          Q: `The blue laser of the Kraft module works normally, but the infrared laser does not emit a beam.`,
          A: `Solution:<br/>

    (1) Check if the laser is not emitting a laser beam only during the initial seconds:<br/>

    The infrared laser requires a preheating time of 2–20 seconds.<br/>

    Ensure that the mode has been switched to Infrared or Dual-laser mode, and allow time for the laser to warm up.<br/>

    (2) Check the engraving material:<br/>

    The infrared laser is mainly used for engraving materials like metal and leather.<br/>

    It does not work on wood and similar materials.<br/>

    (3) Check the focal distance:<br/>

    Infrared laser focus is highly sensitive. If you haven’t refocused after changing materials, do so now.<br/>

    Use auto-focus first and confirm the focal distance is set to 40 mm.<br/>

    (4) Focal distance verification:<br/>

    If the focal distance is confirmed to be 40 mm but there's still no visible laser, try this:<br/>

    Set the power to 20%, press the “Fire” button, then slowly adjust the Z-axis knob or move the material up/down to see if the surface burns or sparks.<br/>

    If sparks or burning appear at a certain height, that is your effective focal distance.<br/>

    Continue using it at that height and report the issue to customer service along with:<br/>

    Your troubleshooting results, the newly found focal distance, your machine's Serial Number (see Figure 18)<br/>

    Refer to the Kraft infrared laser focus verification video for guidance.<br/>

    (5) If all checks above are normal, the laser module may be faulty.<br/>

    Please provide the following to customer service:<br/>

    A video of your troubleshooting process, the machine’s Serial Number (see Figure 20), the laser module’s engraved code (see Figure 21).<br/>

    They will assist you with further steps.<br/>

    [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_20.png?v=1767691220:Figure 20]<br/>

    [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_21.png?v=1767691219:Figure 21]`,
          video_url: [`https://youtu.be/6GDNnk7yFV8`],
        },
        {
          Q: `During auto-focus, the Kraft laser head touches the material surface directly and cannot complete the focusing process.。`,
          A: `Solution:<br/>

    Check if the motherboard is functioning properly:<br/>

    In the software, click the Z-axis control buttons (refer to AtomStack Studio in Figure 22 or LightBurn in Figure 23) and observe whether the Z-axis moves up and down according to the commands.<br/>

    If the Z-axis moves normally in both directions, the motherboard control is functioning correctly.<br/>

    If the Z-axis can only move in one direction (either up or down), check the Z-axis cable connection:<br/>

    Ensure the cable is properly inserted.<br/>

    Inspect the connector for damage, bent pins, or broken pins.<br/>

    If no issues are found with the cable or connector, the problem is likely due to a faulty motherboard or a defective connection cable.<br/>

    In that case, replacement of the motherboard or cable is necessary.<br/>

    [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_22.png?v=1767691218:Figure 22]<br/>

    [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_23.png?v=1767691219:Figure 23]<br/>

    (2) Check for issues with the lower limit switch:<br/>

    While the laser is in standby mode, manually press the trigger block and observe whether the software displays a \`limit switch triggered\` warning:<br/>

    ● If a trigger warning appears, the issue may lie in the motherboard firmware. Try reflashing the firmware.<br/>

    If that doesn't resolve the issue, the motherboard may need to be replaced.<br/>

    Refer to the Kraft Manual Limit Trigger Test Video and Kraft motherboard Firmware Flashing Video for guidance.<br/>

    ● If the trigger block cannot be pressed down (stuck) during inspection, it may be jammed or misaligned.<br/>

    Adjust it according to the Kraft Lower Limit Trigger Block Adjustment Video.<br/>

    ● If no warning appears after pressing the trigger block, inspect the lower limit switch on the driver board:<br/>

    Power off the machine, disconnect the laser cable. Remove the laser module by unscrewing the two screws securing the trigger block.<br/>

    Check if the trigger pin on the driver board’s lower limit switch is damaged.<br/>

    If damaged, the laser module must be replaced.<br/>

    [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_26.png?v=1767691220:Figure 26]<br/>

    [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_27.png?v=1767691219:Figure 27]<br/>

    (3) Check the motor operation status:<br/>

    If the motor behaves abnormally during auto-focus—such as erratic movement, unusual noise, or vibration without actual movement—this indicates a motor driver failure on the motherboard or a faulty connection cable.<br/>

    In this case, the motherboard and connection cable need to be replaced.<br/>

    Refer to the following videos: Kraft motherboard Replacement and Kraft Cable Replacement.`,
          video_url: [
            `https://youtu.be/9pjnFzSlFsA`,
            `https://youtu.be/757s6JzbKsY`,
            `https://youtu.be/CCYbB1pKtY0`,
          ],
        },
        {
          Q: `Kraft auto-focus Failure`,
          A: `Solution:<br/>

    (1) Check if the auto-focus button is faulty:<br/>

    If pressing the auto-focus button on the engraving machine body produces no response and the software shows no error messages, try triggering auto-focus via software:<br/>

    In AtomStack Studio, click the auto-focus button(see Figure 24). Or in LightBurn’s console input box, enter the command [ESP500] to see if the machine executes auto-focus (see Figure 25).<br/>

    If the machine can perform auto-focus via software but not via the physical button, the auto-focus button on the machine is faulty and needs to be replaced.<br/>

    Refer to the Kraft Auto-Focus Button Replacement Video.<br/>

    If auto-focus cannot be executed through software either, and the Z-axis does not move at all:<br/>

    Check the Z-axis motor cable connection for proper insertion, bent or broken pins.<br/>

    Manually rotate the adjustment knob behind the Z-axis to confirm if it can move up and down smoothly.<br/>

    If no issues are found with the cable or movement, the problem may lie with the motherboard or its connection cable.<br/>

    [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_24.png?v=1767691219:Figure 24]<br/>

    [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_25.png?v=1767691219:Figure 25]<br/>

    (2) Check if the upper and lower limit switches are faulty:<br/>

    If the machine can execute the auto-focus command but moves only upward or downward until it hits a mechanical limit and cannot reverse, the issue may be with a limit switch failure.<br/>

    To test this:<br/>

    Remove the laser module, then rotate the manual adjustment knob downward to expose the upper limit switch (see Figure 26).<br/>

    Manually press the upper and lower limit switches (see Figure 27) to see if they can both be triggered.<br/>

    If the upper limit switch cannot be triggered:<br/>

    Refer to the Kraft Limit Switch Replacement Video and check whether its connection cable is properly inserted.<br/>

    Unplug and reconnect the cable. If it still fails to trigger, the switch is likely faulty and needs to be replaced.<br/>

    If the lower limit switch cannot be triggered:<br/>

    Refer to the solution titled \`During auto-focus, the Kraft laser head touches the material and cannot complete auto-focus.\`<br/>

    For further guidance on testing the switches, see the Kraft motherboard firmware burns into video and Kraft Manual Limit Trigger Test Video.`,
          video_url: [
            `https://youtu.be/NN0raPITQss`,
            `https://youtu.be/CCYbB1pKtY0`,
            `https://youtu.be/9DMaOiOa2zU`,
            `https://youtu.be/pzhm-CW99CQ`,
            `https://youtu.be/1Gd5fKsAlLA`,
          ],
        },
        {
          Q: `Kraft stop suddenly in the middle of carving`,
          A: `Solution:<br/>

    (1) When the software shows a prompt:<br/>

    Prompt: Disconnected<br/>

    ◆ If the software displays a “disconnected” message:<br/>

    Check whether the TYPE-C cable was accidentally touched or loosened.<br/>

    Measure the power adapter output to ensure it is between 23V–24V.<br/>

    Try using a different USB port on the computer.<br/>

    Try switching to AtomStack Studio software.<br/>

    ◆ Prompt: Alarm 1<br/>

    “Alarm 1” means a limit switch was triggered.<br/>

    Check whether the file size exceeds the working area of the machine.<br/>

    Frame to see if the movement is normal.<br/>

    If framing is fine but engraving triggers the alarm, move the file to the center or reduce its size.<br/>

    Note: The center of the crosshair is the laser firing point, it may not hit the limit during framing, but during actual engraving, the edge of the laser module might come too close and trigger the switch.<br/>

    If the file is small, centered, and start from absolute coordinates, yet still triggers an alarm, a limit switch fault is likely.<br/>

    Refer to the Kraft Manual Limit Trigger Test Video for troubleshooting.<br/>

    (2) When the software shows no prompt:<br/>

    Unplug and replug the TYPE-C cable, or try a different TYPE-C cable.<br/>

    Switch between AtomStack Studio and LightBurn software.<br/>

    Try a different USB port on the computer.<br/>

    If the problem persists, reflash the firmware. (Note: You cannot flash the same version of the firmware again—use a different version. Contact customer service if needed.)<br/>

    If the issue continues even after reflashing, the motherboard is likely faulty and needs to be replaced.<br/>

    Refer to the Kraft motherboard Firmware Flashing Video and Kraft motherboard Replacement Video for guidance.`,
          video_url: [
            `https://youtu.be/757s6JzbKsY`,
            `https://youtu.be/pzhm-CW99CQ`,
            `https://youtu.be/CCYbB1pKtY0`,
          ],
        },
        {
          Q: `Kraft unable to connect to the software`,
          A: `Solution:<br/>

    (1) Check that the serial port is not occupied:<br/>

    Ensure that no other engraving software is currently connected to the Kraft machine.<br/>

    (2) Confirm the baud rate is set to 460800:<br/>

    It is recommended to use AtomStack Studio or LightBurn software.<br/>

    When using AtomStack Studio, no additional setup is needed—connection should occur automatically.<br/>

    When using LightBurn, you can import the configuration file provided on the included USB drive (see Figure 28).<br/>

    [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_28.png?v=1767691218:Figure 28]<br/>

    (3) Confirm the correct COM port is selected:<br/>

    Open Device Manager and check which COM port corresponds to CH340 (see Figure 29).<br/>

    If CH340 does not appear or is not recognized, install the USB-to-Serial (CH340) driver.<br/>

    Try a different TYPE-C cable, switch to another USB port on your computer, or try using a different computer altogether.<br/>

    [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_29.png?v=1767691220:Figure 29]<br/>

    (4) Confirm whether you're using a macOS computer:<br/>

    If you are using a Mac operating system, note that you cannot directly connect the C-end of the TYPE-C cable into the Mac.<br/>

    You must use a USB hub or docking station to convert the connection to a USB-A port (see Figure 30).<br/>

    [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_30.png?v=1767691220:Figure 30]<br/>

    (5) If the above steps do not resolve the issue, try reflashing the firmware.<br/>

    Note: The same firmware version cannot be flashed repeatedly—you will need a different version.<br/>

    You can request the appropriate firmware from customer support.<br/>

    If the problem persists after reflashing, the issue is likely due to a faulty motherboard, which will need to be replaced.<br/>

    Refer to the Kraft motherboard Firmware Flashing Video and Kraft motherboard Replacement Video for guidance.`,
          video_url: [`https://youtu.be/757s6JzbKsY`, `https://youtu.be/pzhm-CW99CQ`],
        },
        {
          Q: `No response after powering on Kraft.`,
          A: `Solution：<br/>

    (1)Verify that the adapter output is normal: use a multimeter set to DC mode to measure the output port of the adapter.<br/>

    A voltage of 20V to 24V should be present, as shown in Figure 31.<br/>

    [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_31.png?v=1767691220:Figure 31]<br/>

    (2) Check whether the power switch is faulty:<br/>

    First, visually inspect whether the power switch indicator light is on.<br/>

    If it is on, the device is receiving power normally.<br/>

    If the light is off, check the accessory connection ports on the motherboard to see if any indicator lights on the motherboard are on.<br/>

    If the motherboard indicator lights are on, the power switch is functioning properly.<br/>

    If no lights are on, the issue may lie with the power switch or the motherboard.<br/>

    Refer to positions 4 and 12 in the Kraft Panel Function Overview for details.<br/>

    (3) If the above steps reveal no issues, the motherboard is likely faulty and needs to be replaced.<br/>

    Refer to the Kraft motherboard replacement video for guidance.`,
          video_url: [`https://youtu.be/pzhm-CW99CQ`],
        },
        {
          Q: `Kraft is malfunctioning and a limit switch triggered error persists`,
          A: `Solution：<br/>

  Confirm the file size: Kraft's working range is 500mm*320mm. If the file size exceeds this range, it will prompt that the travel is exceeded.<br/>

  Confirm the coordinates used: If the current position is used, it may be that the remaining engraving range of the current position cannot meet the engraving requirements.<br/>

  It is recommended to patrol the edge first, confirm that the range is met, and then engrave or set it to \`Absolute Coords\`.<br/>

  Confirm the limit switch: ◆ Check whether each limit switch is triggered by other objects.<br/>

  If so, move the triggering object away. ◆ Use software prompts to locate and troubleshoot.<br/>

  AtomStack Studio software will directly prompt. If LightBurn software is used, you can enter \`?\`<br/>

  after the alarm message in the code box to get a prompt (as shown in Figure 32).<br/>

  Then follow the prompts to troubleshoot. If it can be triggered normally by pressing it manually, you can unplug the limit switch to check whether the prompt continues to trigger.<br/>

  Confirm the fault and replace it. Refer to the Kraft limit switch replacement video.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_32.png?v=1767691219:Figure 32]<br/>

  If a Z-axis limit switch error is indicated:<br/>

  Start by checking the upper limit switch. Try unplugging the upper limit switch connector to rule out a fault.<br/>

  If the issue is confirmed to be with the laser module’s lower limit switch, press the trigger block gently by hand to check whether it moves freely.<br/>

  If the trigger block is stuck, refer to the Kraft Laser Module Lower Limit Trigger Block Adjustment video to make the necessary adjustments.<br/>

  If the trigger block moves normally, the laser module likely needs to be replaced.<br/>

  Please provide the following to customer support for further assistance:<br/>

  A clear troubleshooting video, the machine’s serial number (see Figure 33), the laser module’s engraved code (see Figure 34)<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_33.png?v=1767691220:Figure 33]<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_34.png?v=1767691219:Figure 34]`,
          video_url: [`https://youtu.be/9DMaOiOa2zU`, `https://youtu.be/9pjnFzSlFsA`],
        },
        {
          Q: `Kraft produces distorted engraving results.`,
          A: `Solution：<br/>

  (1) Check whether the speed setting is too high:<br/>

  Set appropriate parameters according to the reference parameter table.How to view the Kraft parameter table: ①Enter to view by scanning the QR code on the engraving machine.<br/>

  ②Enter the official website to view [link:https://atomstack.com/pages/product-support].<br/>

  ③Contact customer service staff to request it.<br/>

  (2) Inspect the X and Y axis dual shafts for dirt or damage:<br/>

  Carefully examine the guide rails and dual shafts to ensure there is no dirt, damage, or other abnormalities.<br/>

  (3) Identify which axis is malfunctioning:<br/>

  In the software, create a test file with both a circle and a square outline.<br/>

  For example, use a cutting mode with a speed of 10,000 mm/min and 30% power to output the lines on plywood.<br/>

  Observe whether the issue is caused by abnormal movement on one axis or both.<br/>

  Refer to the Kraft Mechanical Adjustment Video to focus on adjusting the relevant parts.<br/>

  Important: After each adjustment, perform a test to determine whether the issue improves. If there is improvement, continue fine-tuning.<br/>

  If not, proceed to adjust other positions.<br/>

  (4) Check whether the X-axis is parallel to the lower crossbeam:<br/>

  If the engraved lines are slanted but not wavy or curved, the issue is likely that the X-axis is not parallel to the lower crossbeam.<br/>

  Adjust the X-axis to ensure it is parallel. Refer to the Kraft Mechanical Adjustment Video for guidance.<br/>

  (5) Verify whether the step settings have been altered:<br/>

  In LightBurn or LaserGRBL, open the machine settings and check whether the values for $100 and $101 are set to 100 (see Figure 35).<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_35.png?v=1767694662:Figure 35]<br/>

  (6) Confirm that there are no abnormalities in the firmware：try reflashing the firmware(Note: identical firmware versions cannot be reflashed. Please provide your current firmware version to customer support to request an appropriate version.) Refer to the Kraft motherboard firmware burning video.<br/>

  (7) If all the above steps fail to resolve the issue and structural adjustments have no effect, the motherboard is likely faulty and needs to be replaced.<br/>

  Refer to the Kraft Motherboard Replacement Video for detailed instructions.`,
          video_url: [
            `https://youtu.be/KY3dAcAqYVU`,
            `https://youtu.be/757s6JzbKsY`,
            `https://youtu.be/pzhm-CW99CQ`,
          ],
        },
        {
          Q: `Kraft fails to recognize the camera.`,
          A: `Solution：<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_36.png?v=1767694662:Figure 36]<br/>

  (1) Check whether the camera is disabled:<br/>

  Open Device Manager to see if the camera is restricted or disabled.<br/>

  If so, remove the restriction and grant the necessary permissions.<br/>

  (2) Check whether the computer's USB port is damaged:<br/>

  Try a different USB port on the computer, and use the built-in camera or video app to verify if the image can be displayed.<br/>

  (3) Check whether the camera cable on the mainboard is loose:<br/>

  If the camera fails to capture an image, inspect the camera connection cable (see Figure 37).<br/>

  Use tweezers or a similar tool to carefully unplug and reinsert the cable, then test the camera again.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_37.png?v=1767694663:Figure 37]<br/>

  (4) If none of the above steps resolve the issue, the camera is likely faulty and needs to be replaced.<br/>

  Refer to the Kraft Camera Replacement Video for instructions.`,
          video_url: [`https://youtu.be/5UgyzdwLDXI`],
        },
        {
          Q: `Camera positioning on Kraft is inaccurate, with significant deviation.`,
          A: `Solution：<br/>

  (1) Check whether the coordinate settings are correct:<br/>

  For camera positioning to work properly, “Start From” should be set to Absolute Coordinates, not Current Position or User Origin.<br/>

  (2) Ensure the camera is calibrated:<br/>

  After switching to materials with different thicknesses, recalibration is required.<br/>

  If the error is too large during calibration, redo the machine model calibration.<br/>

  (3) Check whether the internal lighting is sufficient:<br/>

  Inadequate lighting inside the Kraft enclosure may cause significant camera algorithm errors. Improve internal brightness and try again.<br/>

  (4) Avoid using the edges of the camera view:<br/>

  It is recommended to perform engraving near the center of the working area.<br/>

  The closer to the edges, the higher the potential positioning error.`,
          video_url: [],
        },
        {
          Q: `Kraft's camera operates normally in AtomStack Studio, but cannot be calibrated when using LightBurn.`,
          A: `Solution：<br/>

  (1) Check the lighting conditions of the working environment:<br/>

  AtomStack Studio has relatively low lighting requirements when using the camera.<br/>

  However, LightBurn requires significantly better lighting conditions for successful calibration.<br/>

  If calibration fails, try using external lighting to assist with the process.<br/>

  (2) Ensure the software has the necessary permissions:<br/>

  If calibration still fails even with additional lighting, it may be due to insufficient system permissions granted to LightBurn or an issue with the LightBurn software itself.<br/>

  In such cases, it is recommended to use AtomStack Studio for camera operations instead.`,
          video_url: [],
        },
        {
          Q: `Kraft movement is abnormal.`,
          A: `Solution：<br/>

  Confirm that the factory fixings have been removed: In order to protect the X-axis structure from changes during transportation, we will install a fixing module when it leaves the factory.<br/>

  After receiving the product, please unscrew the screws of the fixing module and remove the fixing modules at both ends of the X-axis, as shown in Figure 38.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_38.png?v=1767694663:Figure 38]<br/>

  (2) Check whether reverse movement is enabled:<br/>

  If the abnormal movement is consistent or patterned—such as reversed motion—it may indicate that the Kraft motherboard parameters have been modified.You can check this by going to the machine settings in LightBurn or LaserGRBL（see Figure 39）, Or restore the factory settings in the software or re-burn the firmware.<br/>

  Note that the same firmware cannot be re-burned. You can contact the customer service staff to request Kraft motherboard firmware burning video.<br/>

  The method of factory reset is as follows:<br/>

  ◆Restore factory settings in AtomStack Studio:for version 2.20 or later, tap the Version Number (e.g., V.2.20) seven times consecutively to enter Developer Mode (see Figure 40).In the menu, open Serial Port Log, then click Reset to restore factory settings (see Figure 41).<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_39.png?v=1767694662:Figure 39]<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_40.png?v=1767694661:Figure 40]<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_41.png?v=1767694661:Figure 41]<br/>

  ◆in LightBurn software: enter the command $RST=* in the command box to reset to factory defaults (see Figure 42).<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_42.png?v=1767694661:Figure 42]<br/>

  (2) Check for damaged or deformed components:<br/>

  Inspect the timing belts, dual-axis guide rails, and couplings for any looseness, breakage, damage, or deformation.<br/>

  Also verify that the motor cables are securely connected and that there are no bent or broken pins.<br/>

  (3) If none of the above steps resolve the issue, try replacing the motherboard, connection cables, and motors.<br/>

  Refer to the following videos for guidance:<br/>

  Kraft Motherboard Replacement<br/>

  Kraft Motor Replacement<br/>

  Kraft Motherboard Cable Replacement`,
          video_url: [
            `https://youtu.be/757s6JzbKsY`,
            `https://youtu.be/pzhm-CW99CQ`,
            `https://youtu.be/1Gd5fKsAlLA`,
            `https://youtu.be/eR-zxrJz7Kk`,
          ],
        },
        {
          Q: `The machine does not respond when performing engraving tasks on Kraft.`,
          A: `Solution：<br/>

  (1) Confirm all operations are normal:<br/>

  First, check whether the power supply and all connection cables are properly connected, the enclosure door is closed, and whether any limit switches are triggered.<br/>

  (2) Check for software prompts:<br/>

  Observe whether the software displays any error messages. If so, follow the guidance to troubleshoot accordingly.<br/>

  If no message appears, restart the Kraft power supply and the software, then try reconnecting the device.<br/>

  (3) Check whether other software works properly:<br/>

  Try switching to AtomStack Studio or LightBurn to test functionality.<br/>

  If neither software works, try replacing the Type-C cable, using a different USB port, or updating the USB driver.<br/>

  (4) If the issue persists after all of the above steps, try reflashing the firmware<br/>

  (Note: identical firmware versions cannot be reflashed. Refer to the Kraft motherboard firmware burning video. Please provide your current firmware version to customer support to obtain a usable version.)<br/>

  If reflashing the firmware does not solve the issue, the motherboard may be faulty and needs replacement.<br/>

  Please provide the machine’s serial number (see Figure 43) to customer service for further assistance.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_43.png?v=1767694662:Figure 43]`,
          video_url: [`https://youtu.be/757s6JzbKsY`],
        },
        {
          Q: `The laser module on Kraft performs motion correctly, but fails to emit a laser beam during engraving operations.`,
          A: `Solution：<br/>

  (1) Check whether the laser cable is properly connected:<br/>

  Ensure the laser module's cable is securely plugged in. Unplug and reconnect it to confirm a stable connection.<br/>

  (2) Verify the software parameter settings:<br/>

  Check if the settings match the recommended material parameter table.If using LightBurn, confirm whether the S-value Max has been altered.Ensure that S-value Max is set to 1000 (see Figure 44).How to view the Kraft parameter table:<br/>

  ①Enter to view by scanning the QR code on the engraving machine.<br/>

  ②Enter the official website to view [link:https://atomstack.com/pages/product-support].<br/>

  ③Contact customer service staff to request it.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_44.png?v=1767694662:Figure 44]<br/>

  (3) Check whether the focal distance is set to 40mm.<br/>

  (4) Switch to another laser mode to test functionality:<br/>

  If the infrared mode is currently in use, try switching to blue laser mode or dual-laser mode to see whether the blue laser functions correctly.<br/>

  If the blue laser works but the infrared does not, refer to the troubleshooting guide for:<br/>

  “Blue laser functions normally, infrared does not emit a beam.”<br/>

  If no mode works, proceed to measure the voltage output of the laser cable:<br/>

  Unplug the laser cable.<br/>

  Run a cutting task at 100% power and 10mm/min speed.<br/>

  Use a multimeter (DC mode) to measure the voltage:<br/>

  Between Pin 2 and Pin 3, the normal value should be 20V–24V.<br/>

  Between Pin 4 and Pin 5, the normal value should be 1V–6V. (See Figure 45.)<br/>

  If the voltage readings are within the normal range, the laser module is faulty and needs to be replaced.<br/>

  If the voltage is 0V or below the normal range, the issue lies with the motherboard or its connection cables.<br/>

  Refer to the following videos for detailed instructions:<br/>

  Kraft Laser Cable Voltage Testing Video<br/>

  Kraft Motherboard Replacement Video<br/>

  Kraft Motherboard Cable Replacement Video<br/>

  Kraft Laser Module Replacement Video<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_45.png?v=1767694663:Figure 45]`,
          video_url: [
            `https://youtu.be/t5eae1vGkjE`,
            `https://youtu.be/pzhm-CW99CQ`,
            `https://youtu.be/1Gd5fKsAlLA`,
            `https://youtu.be/leUQfQl34Lw`,
          ],
        },
        {
          Q: `Kraft outputs incomplete or broken lines.`,
          A: `Solution：Check the laser focus:<br/>

  After changing to materials with different thicknesses, you need to refocus the laser.<br/>

  Simply press the auto-focus button to complete the process.<br/>

  You can also manually measure the distance from the bottom edge of the laser module (not the air-assist hood) to the material surface.<br/>

  It should be 40 mm.<br/>

  Check the power settings in the software:<br/>

  If the power setting is too low, try increasing the power or reducing the speed.<br/>

  Ensure “Constant Power Mode” is enabled:<br/>

  In AtomStack Studio (see Figure 46) or LightBurn (see Figure 47), make sure the Constant Power Mode is turned on.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_46.png?v=1767694661:Figure 46]<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_47.png?v=1767694662:Figure 47]<br/>

  Adjust the minimum power value ($31):<br/>

  If enabling Constant Power Mode doesn’t fix the issue, go to the machine settings in LightBurn or LaserGRBL, and increase the $31 value until the lines appear complete (see Figure 48).<br/>

  Note: If Constant Power Mode solves the problem, there’s no need to modify $31.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_48.png?v=1767694662:Figure 48]`,
          video_url: [],
        },
        {
          Q: `The lines engraved by Kraft are too wide.`,
          A: `Solution：<br/>

  Check the laser focus:<br/>

  If the laser has not been refocused after switching to materials of different thicknesses, the beam may become unfocused and cause wider lines.<br/>

  Press the auto-focus button to refocus the laser.<br/>

  Check the protective glass and air-assist hood:<br/>

  Ensure that the protective glass and air-assist hood are clean and undamaged.<br/>

  Refer to the Kraft Laser Cleaning Video for inspection and cleaning instructions.<br/>

  Check the parameter settings:<br/>

  If the power setting is too high, it can cause the laser beam to widen.<br/>

  Make sure the settings match the recommended material parameter table, How to view the Kraft parameter table: ①Enter to view by scanning the QR code on the engraving machine.<br/>

  ②Enter the official website to view [link:https://atomstack.com/pages/product-support].<br/>

  ③Contact customer service staff to request it.`,
          video_url: [`https://youtu.be/H8cfU-eOHr8`],
        },
        {
          Q: `The cut edges produced by Kraft appear yellow and fail to cut through the material.`,
          A: `Solution：<br/>

  (1)Check cutting conditions:<br/>

  Make sure air assist is enabled during cutting.<br/>

  Verify that the power adapter output voltage is within the normal range (23V–24V).<br/>

  Ensure the material thickness does not exceed the machine's cutting capability.<br/>

  (2)Check the laser focus:<br/>

  After changing to a material with a different thickness, refocus the laser by pressing the auto-focus button.<br/>

  Inspect the protective glass and air-assist hood:<br/>

  Make sure the glass and hood are clean and undamaged.<br/>

  Refer to the Kraft Laser Cleaning Video for proper inspection and cleaning instructions.<br/>

  (3)Verify software parameter settings:<br/>

  If the power is too low or the speed too high, the laser may not cut through the material.<br/>

  Try increasing the power or decreasing the speed.<br/>

  If using LightBurn, ensure that the S-value Max is set to 1000 and has not been changed (see Figure 49).<br/>

  How to view the Kraft parameter table:<br/>

  ①Enter to view by scanning the QR code on the engraving machine.<br/>

  ②Enter the official website to view [link:https://atomstack.com/pages/product-support].<br/>

  ③Contact customer service staff to request it.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_49.png?v=1767694662:Figure 49]<br/>

  (4) If there are no abnormalities in the above, it is judged that the laser is faulty and needs to be replaced.<br/>

  Please provide the customer service staff with the Serial Number (as shown in Figure 50), the fault video (including parameter settings), and the laser engraving code (as shown in Figure 51).<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_50.png?v=1767694662:Figure 50]<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_51.png?v=1767694661:Figure 51]`,
          video_url: [`https://youtu.be/H8cfU-eOHr8`],
        },
        {
          Q: `The laser does not stop operating even when the Kraft enclosure door is open.`,
          A: `Solution:<br/>

  (1) Check whether the door opening detection function is enabled:<br/>

  Verify in AtomStack Studio or the AtomStack App whether this function has been disabled. If so, enable it.<br/>

  See Figure 52.<br/>

  (2) Check whether the enclosure door limit switch is faulty:<br/>

  Manually press and release the enclosure door limit switch to see if the software displays a door open warning.<br/>

  If no warning appears, the limit switch may be faulty and needs to be replaced.<br/>

  Refer to the Kraft limit switch replacement video.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_52.png?v=1767694662:Figure 52]`,
          video_url: [`https://youtu.be/9DMaOiOa2zU`],
        },
        {
          Q: `The LED light strip of the Kraft enclosure is not lighting up.`,
          A: `Solution：<br/>

  Measure the voltage at the LED strip connector:<br/>

  When the machine is powered on normally, the LED light strip should illuminate.<br/>

  If it does not, use a multimeter set to DC mode to measure the voltage at the LED strip connector.<br/>

  The normal voltage range should be between 20V and 24V. See Figure 53.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_53.png?v=1767694663:Figure 53]<br/>

  ① If the voltage is within the normal range, the LED strip is faulty and needs to be replaced.<br/>

  Refer to the Kraft LED strip replacement video.<br/>

  ② If the measured voltage is 0V, the LED connection cable is faulty.<br/>

  Refer to the Kraft LED connection cable replacement video.<br/>

  ③ If the measured voltage is below 20V, the power adapter may be faulty.`,
          video_url: [`https://youtu.be/6rI-PbQVlLI`, `https://youtu.be/1Gd5fKsAlLA`],
        },
        {
          Q: `Kraft failed to reset.`,
          A: `Solution:<br/>

  Confirm that the factory fixings have been removed: In order to protect the X-axis structure from changes during transportation, we will install a fixing module at the factory.<br/>

  After receiving the product, please unscrew the fixing module screws and remove the fixing modules at both ends of the X-axis, as shown in Figure 54.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_54.png?v=1767694663:Figure 54]<br/>

  Confirm that the step length is correct: Use LightBurn or LaserGRBL to enter the machine settings to check whether the values of $100 and $101 are 100, as shown in Figure 55:<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_55.png?v=1767694662:Figure 55]<br/>

  (3) Confirm that the laser is installed correctly: If the Y-axis limit switch triggers normally, but the laser hits the frame, reinstall the laser.<br/>

  Refer to the Kraft laser replacement video.<br/>

  (4) Confirm that the X-axis is on the horizontal line: Use a ruler to measure the distance from both ends of the X-axis (the axis where the laser is installed) to the frame to see if they are consistent, as shown in Figure **.<br/>

  If not, refer to the Kraft X-axis horizontal adjustment video for adjustment.<br/>

  (5) Confirm the information prompted by the software: If there is a prompt that the maximum stroke has been reached, it is a faulty X-axis or Y-axis limit switch.<br/>

  Press the limit switch manually (as shown in the Figure 56) to see if a \`beep\` sound is emitted and the software prompts an information prompt.<br/>

  If there is no prompt, it is a limit switch fault; if there is a prompt, it is normal.<br/>

  For replacement, please refer to the Kraft limit switch replacement video.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_56.png?v=1767694663:Figure 56]<br/>

  (6) Confirm whether the X-axis and Y-axis movement are normal: If only one axis can move normally during reset, then you can plug the Y-axis motor cable into the X-axis motor to see if the normal axis and the faulty axis are swapped.<br/>

  If the same, it is judged to be a motor fault.<br/>

  If the problem is transferred, it is judged to be a motherboard driver fault or a motor connection cable fault.<br/>

  Refer to the Kraft motor cable swap video, Kraft motor replacement video, Kraft motherboard replacement video, and Kraft motor cable replacement video.<br/>

  (7) Confirm the firmware problem: If the above cannot solve the customer's problem, please try to upgrade the firmware.<br/>

  You can upgrade through AtomStack Studio, AtomStack APP or USB flash drive.<br/>

  ◆Connect to the AtomStack Studio client or mobile app and directly click Update Firmware, as shown in the Figure 57. Note that you will need to insert a USB drive as storage for the update.<br/>

  ◆Copy the file to the root directory of a USB drive and insert it into the USB port on the machine to update.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_57.png?v=1767694662:Figure 57]`,
          video_url: [
            `https://youtu.be/leUQfQl34Lw`,
            `https://youtu.be/9DMaOiOa2zU`,
            `https://youtu.be/KPIi_Vv9VNI`,
            `https://youtu.be/pzhm-CW99CQ`,
            `https://youtu.be/eR-zxrJz7Kk`,
            `https://youtu.be/xuaepbjWv5I`,
            `https://youtu.be/gGMmN-PHTk8`,
          ],
        },
        {
          Q: `Kraft cannot trigger the limit switch.`,
          A: `Solution:<br/>

  The X-axis limit switch cannot be triggered: In standby mode, manually press the two limit switches on the X-axis (as shown in Figure 58).<br/>

  ◆ If a \`beep\` sound is heard after pressing and the software has a trigger alarm prompt, then the limit switch itself is normal.<br/>

  Please carefully check whether there are obstacles blocking the ends or whether the trigger rod is skewed, as shown in Figure 59.<br/>

  ◆ If no prompt is heard after pressing and there is no beep, it may be a limit switch failure.<br/>

  Please provide a photo of the machine's serial number (as shown in Figure 60) and a video of the failure to trigger to the customer service staff for processing.<br/>

  For replacement, please refer to the Kraft limit switch replacement video.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_58.png?v=1767694663:Figure 58]<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_59.png?v=1767694663:Figure 59]<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_60.png?v=1767694662:Figure 60]<br/>

  The Y-axis limit switch cannot be triggered: In standby mode, manually press the two limit switches on the front and rear of the left Y axis (as shown in Figure 58).<br/>

  ◆ If a \`beep\` sound is heard after pressing and the software has a trigger alarm prompt, then the limit switch itself is normal.<br/>

  Please carefully check the following points.<br/>

  ①The laser is not installed properly: remove the laser and reinstall it, making sure the two grooves at the bottom of the laser are aligned with the two limit posts on the slider, as shown in Figure 61.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_61.png?v=1767694663:Figure 61]<br/>

  ② The X-axis is not horizontal: measure the distances from both ends of the X-axis to the front frame to see if they are consistent.<br/>

  If not, refer to the Kraft X-axis horizontal adjustment video.<br/>

  ◆ If no prompt appears after pressing and no beeping sound occurs, it may be a limit switch failure.<br/>

  Please provide a photo of the machine's serial number and a video of the failure to trigger to the customer service staff for processing.<br/>

  (3) The Z-axis limit switch cannot be triggered: In standby mode, manually press the Z-axis upper limit switch (as shown in Figure **) and the trigger lever under the laser (as shown in Figure **).<br/>

  ◆ If no \`beeping\` sound appears when pressing the upper limit switch and there is no alarm prompt on the software, it may be a limit switch failure.<br/>

  Please carefully check whether the limit switch plug is properly connected.<br/>

  If it is confirmed that there is no abnormality in the connection line, it may be a limit switch failure.<br/>

  Please provide a photo of the machine's serial number and a video of the failure to trigger to the customer service staff for processing.<br/>

  ◆If there is no \`beep\` sound when pressing the lower limit switch and there is no alarm prompt in the software, please unscrew the screws of the flame detection board and check whether the trigger pin of the lower limit switch on the driver board is broken.<br/>

  If it is broken, please provide a clear photo and a photo of the serial number to the customer service staff for processing.<br/>

  If it is not broken, please provide a video of the failure to trigger and a photo of the serial number to the customer service staff for processing.<br/>

  ◆If the lower limit switch does not move when pressed, it may be that the trigger rod is stuck.<br/>

  Please refer to the Kraft laser lower limit trigger rod adjustment video for adjustment.<br/>

  (4) All limit switches can be manually pressed to issue a prompt but cannot control the movement of the laser: This situation may be caused by an abnormality in the mainboard firmware.<br/>

  Please provide a video of the failure and a photo of the serial number to the customer service staff for processing.`,
          video_url: [
            `https://youtu.be/9DMaOiOa2zU`,
            `https://youtu.be/9pjnFzSlFsA`,
            `https://youtu.be/gGMmN-PHTk8`,
          ],
        },
        {
          Q: `The Kraft system repeatedly triggers the flame detection alarm.`,
          A: `Solution:<br/>

  (1) Confirm whether the engraving material is flammable:<br/>

  Check if the material is flammable, such as MDF. If so, false alarms from the flame detection sensor are more likely.<br/>

  (2) Confirm whether the engraving file has dense lines:<br/>

  If the line patterns are very dense, the flame detection is more easily triggered.<br/>

  It is recommended to increase the engraving speed and the number of passes.<br/>

  (3) Test whether engraving other materials triggers the alarm:<br/>

  ① If cutting the same file on plywood does not trigger the alarm, you can disable the flame detection function in AtomStack Studio or the AtomStack App while cutting the current material, as shown in Figure 62.<br/>

  (Note: When this function is disabled, the machine must be supervised at all times to prevent accidents.) Please re-enable this function after engraving is complete.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_62.png?v=1767694662:Figure 62]<br/>

  ② If the alarm is still triggered when working on plywood, adjust the flame detection sensitivity in LightBurn or LaserGRBL:<br/>

  The command $fire_alarm/overflow_value=15 adjusts the number of trigger counts beyond the threshold.<br/>

  The command $fire_alarm/threshold_value=74 adjusts the flame detection threshold value，shown in Figure 63; a higher value makes it harder to trigger.<br/>

  Note: While these tips can effectively reduce false alarms, they do not replace careful operation.<br/>

  Always closely monitor the machine during operation, as safety should be your top priority.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_63.png?v=1767694662:Figure 63]`,
          video_url: [],
        },
        {
          Q: `The air assist of Kraft is not working.`,
          A: `Solution:<br/>

  (1) Confirm that the air assist is properly turned on:<br/>

  Check if the control knob is turned on; turning clockwise switches it on.<br/>

  (2) Check whether the air pump is vibrating:<br/>

  ① If the air pump is not vibrating, measure the voltage at the Kraft air assist power output port (port 05 as described in the panel function section).<br/>

  The voltage should be between 20V and 24V.<br/>

  If the power supply is normal, the rotary switch board is faulty and needs to be replaced.<br/>

  Refer to the Kraft Air Assist Rotary Switch Replacement Video.<br/>

  If there is no voltage, the mainboard is faulty. Refer to the Kraft Mainboard Replacement Video.<br/>

  ② If the air pump vibrates but there is no airflow, the air pump is faulty and needs to be replaced.<br/>

  Refer to the Kraft Air Pump and Water Pump Replacement Video.`,
          video_url: [
            `https://youtu.be/r6yvxL3uXfs`,
            `https://youtu.be/pzhm-CW99CQ`,
            `https://youtu.be/ugqh5NtUNyY`,
          ],
        },
        {
          Q: `The Kraft system's active fire extinguishing device fails to respond after the flame alarm is triggered.`,
          A: `Solution:<br/>

  (1) Check if the fire extinguishing water tank has sufficient water:<br/>

  Inspect the water level through the water level window of the fire extinguishing pump.<br/>

  (2) Confirm that the active fire suppression function is enabled:<br/>

  Verify this in AtomStack Studio software or the AtomStack App, as shown in Figure 64.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_64.png?v=1767694662:Figure 64]<br/>

  (3) Confirm that the fire suppression device is receiving power:<br/>

  If the fire suppression function is triggered but the water pump does not vibrate or make any noise, measure the voltage at the water pump output port on the Kraft chassis.<br/>

  The voltage should be between 20V and 24V.<br/>

  If the voltage is present, the water pump is faulty and needs replacement.as shown in Figure 65.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_65.png?v=1767694662:Figure 65]`,
          video_url: [],
        },
        {
          Q: `There is severe smoke inside the Kraft enclosure, and the exhaust capability is very poor.。`,
          A: `Solution:<br/>

  (1) Confirm whether an air purifier is being used:<br/>

  If the purifier’s filtering capability is weak, the exhaust will be affected.<br/>

  Try removing the exhaust hose and venting the smoke directly outdoors to check if the enclosure exhaust works normally.<br/>

  If direct venting works, it indicates the purifier’s filtering capacity is weak or the filter needs replacement.<br/>

  (2) Check if the enclosure fan is clogged with dust:<br/>

  Excessive dust accumulation will reduce exhaust efficiency. Refer to the Kraft Enclosure Cleaning Video to clean the enclosure and fan.<br/>

  (3) If direct venting and cleaning do not resolve the issue, the fan may be faulty:<br/>

  Try replacing the fan. Refer to the Kraft Enclosure Fan Replacement Video.`,
          video_url: [`https://youtu.be/ayJjKddG4kk`, `https://youtu.be/qOaaI53eYK4`],
        },
        {
          Q: `When using the rotary device on the Kraft, the output is reversed.`,
          A: `Solution:<br/>

  (1) Confirm whether the output pattern is mirrored:<br/>

  If yes, check if the mirror function is enabled in the software settings. If it is enabled, disable it;<br/>

  if it is disabled, enable it.<br/>

  Refer to AtomStack Studio (see Figure 66) and LightBurn (see Figure 67).<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_66.png?v=1767694661:Figure 66]<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_67.png?v=1767694662:Figure 67]<br/>

  (2) Confirm whether the engraving pattern is reversed:<br/>

  If so, try reversing the motor direction to fix the issue. See Figure 68.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_68.png?v=1767694662:Figure 68]<br/>

  (3)If the above steps do not resolve the issue：Restore factory settings in AtomStack Studio: for version 2.20 or later, tap the Version Number (e.g., V.2.20) seven times consecutively to enter Developer Mode (see Figure 69).In the menu, open Serial Port Log, then click Reset to restore factory settings (see Figure 70).Alternatively, in LightBurn software, enter the command $RST=* in the command box to reset to factory defaults (see Figure 71)<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_69.png?v=1767694662:Figure 69]<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_70.png?v=1767694661:Figure 70]<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_71.png?v=1767694661:Figure 71]`,
          video_url: [],
        },
        {
          Q: `Kraft fails to connect mobile app.`,
          A: `Solution:<br/>

  Confirm that the connection method is correct: Please refer to the video of unboxing and online use of Kraft.<br/>

  Confirm the password is correct:The default password for Kraft is 12345678.<br/>

  Ensure the phone is close enough to the machine:When connecting via the app, keep the phone near the machine.<br/>

  Check if the machine’s Wi-Fi is occupied:If the machine’s Wi-Fi is already connected to another device, it cannot connect to a new one.<br/>

  Disconnect other devices before attempting to connect.<br/>

  Turn off mobile data on the phone and reconnect to Wi-Fi, or try using a different phone.<br/>

  Confirm the Wi-Fi signal strength of the machine:<br/>

  When connecting, check the Wi-Fi signal strength on the phone.<br/>

  If the signal is very weak, the Wi-Fi antenna may be loose.<br/>

  Open the mainboard, check if the Wi-Fi antenna connector is detached, and reseat it before trying again.`,
          video_url: [`https://youtu.be/p_WDoDDHwYA`],
        },
        {
          Q: `Kraft device fails to start engraving after connecting to the APP.`,
          A: `Solution:<br/>

  (1) Confirm usage conditions:<br/>

  When using the APP, a USB KEY and a USB drive must be plugged in. The USB drive should have sufficient storage space.<br/>

  (2) Confirm the enclosure door is closed:<br/>

  The door must be fully closed to start engraving. The laser will not emit light if the door is open.<br/>

  (3) Check for any error messages in the APP:<br/>

  Pay attention to any abnormal prompts in the APP. If there are no messages, try restarting both the engraving machine and the APP.<br/>

  Also, delete the connected machine from the APP and reconnect it.`,
          video_url: [],
        },
        {
          Q: `Kraft system fails to detect the USB drive.`,
          A: `Solution:<br/>

  (1) Check if the USB drive is damaged:<br/>

  Insert the USB drive into a computer to see if it can be read normally.<br/>

  If files can be accessed, the USB drive is considered functional.<br/>

  (2) Confirm the USB drive is plugged into the correct port:<br/>

  Ensure the USB drive is inserted into the engraving machine’s USB DRIVE port.<br/>

  Do not insert it into the USB KEY port.<br/>

  (3) Check if the USB DRIVE port is functioning properly:<br/>

  Inspect the USB DRIVE port for any damage or defects.<br/>

  (4) If all the above checks are normal but the issue persists, the mainboard may need to be replaced.<br/>

  Refer to the Kraft Mainboard Replacement Video.`,
          video_url: [`https://youtu.be/pzhm-CW99CQ`],
        },
        {
          Q: `Updates for Kraft control software, firmware, and APP.`,
          A: `(1) AtomStack Studio Update:<br/>

  After opening the software, if a new version is available, an update prompt will appear automatically.<br/>

  If there is no prompt, go to Settings and select Check for Updates.<br/>

  You can also download the latest version from AtomStack.com.<br/>

  Firmware upgrade:<br/>

  You can upgrade via AtomStack Studio, AtomStack APP, or USB flash drive.<br/>

  ◆ After connecting to the AtomStack Studio client or mobile app, directly click Update Firmware, as shown in Figure 72. Note that you need to insert a USB flash drive as storage to upgrade.<br/>

  ◆ Copy the file to the root directory of the USB flash drive and insert it into the USB flash drive port of the machine to upgrade.(3) APP Update:<br/>

  Download the latest APP version from AtomStack.com, or open the APP and go to Profile > Settings > About ATOMSTACK to check the software version.<br/>

  If an update is available, you can update directly from there.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_71.png?v=1767694661:Figure 72]`,
          video_url: [],
        },
        {
          Q: `Kraft Alarm Prompts and Troubleshooting.`,
          A: `Alarm1: Limit switch triggered - Check whether the limit switch has been triggered, and verify the size of the engraving file. If an alarm is triggered even when the engraving position is at the center of the working area, the limit switch may be faulty.Refer to the Kraft Manual Limit Switch Trigger Check Video for troubleshooting.<br/>

  Alarm9: Homing failed - Troubleshoot according to the Kraft homing failure solution.<br/>

  Alarm12: Flame detection triggered - Carefully observe whether the material being engraved or cut has caught fire. If it is a false alarm, follow the solution for 'Kraft frequently triggers flame alarm'<br/>

  Alarm13: Door opening detected - The enclosure door may be open or the limit switch may be malfunctioning. Refer to the solution for 'Kraft continues engraving even when the door is open'.`,
          video_url: [`https://youtu.be/CCYbB1pKtY0`],
        },
      ],
    ],
  },
  P1: {
    nav: [`pre-Sale Questions`, `Quick Start`, `Maintenance & Care`],
    nav_desc: [
      `What You Need to Know Before Buying`,
      `Your First Steps Made Simple(For Beginners) `,
      `Keep Your Machine in Top Shape`,
    ],
    quantions: [
      [
        {
          Q: `Can the P1 work with third-party (non-AtomStack) modules or accessories?`,
          A: `Due to the P1's special design, it is not compatible with other brands' modules/accessories. The module uses an 8-pin connector and a specific mounting (see Figure 1). [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_1.png?v=1758787320:Figure 1]`,
        },
        {
          Q: `Is the P1 compatible with modules from other AtomStack machines?`,
          A: `The P1 does not support other models' modules. It supports [link:/products/atomstack-p1-1w-1064nm-laser-module:the P1's 1.2W infrared module] and AtomStack [link:/products/r6:R6] /[link:/products/r8:R8] /[link:/products/r8-pro:R8 Pro] rotaries with auto-recognition.`,
        },
        {
          Q: `What is the working area?`,
          A: `Diode laser: 110 × 110 mm. Infrared laser: 105 × 100 mm. The P1 prioritizes portability.`,
        },
        {
          Q: `Can it engrave or cut metal?`,
          A: `It can engrave certain metals but cannot cut metal. The P1 supports a diode laser (blue) and a [link:/products/atomstack-p1-1w-1064nm-laser-module:1.2W infrared laser]. See the P1 parameter sheet for settings.<br/>

  Notes for metal:<br/>

  • With the diode laser: limited metal marking (e.g., stainless steel with appropriate process), not suitable for metal cutting.<br/>

  • With the 1.2W infrared laser: suitable for metal engraving; still not for metal cutting.<br/>

    Where to find the parameter sheet?<br/>

  Scan the QR code on the machine; visit [link:/pages/product-support:product support]; or request from support.`,
        },
        {
          Q: `Can the P1 connect to a Wi-Fi router?`,
          A: `Yes. During Bluetooth APP setup, the AtomStack provisioning flow includes router connection steps. See the APP tutorial.`,
          video_url: [`https://www.youtube.com/embed/fS4eDWv50Hs`],
        },
        {
          Q: `Can it engrave tumblers, cups, and other curved items?`,
          A: `Yes, with AtomStack [link:/products/r6:R6] /[link:/products/r8:R8] /[link:/products/r8-pro:R8 Pro] (auto‑recognition) and riser feet installed. See rotary tutorial.`,
          video_url: [`https://www.youtube.com/embed/aT0n1hF0wgI`],
        },
        {
          Q: ` Can it engrave or cut leather? What parameters should I use?`,
          A: `Yes. As a starting point: Engrave at 6000 mm/min, 80% power. Cut 1 mm leather at 500 mm/min, 80% power in one pass. For other materials, consult the P1 parameter sheet.`,
        },
        {
          Q: `Does the P1 support rotary?`,
          A: `Yes. See the rotary tutorial.`,
          video_url: [`https://www.youtube.com/embed/0dIsqOSiCnk`],
        },
        {
          Q: ` What advantages does the P1 have versus other models?`,
          A: `
• Affordable & easy: budget‑friendly, ready out of the box; free asset library; simple UI with clear status indicators.<br/>


• Dual‑module recognition: software detects which module is installed and auto‑switches modes. Supports 5W diode and 1.2W infrared modules for a wide range of materials (wood, bamboo, paper, leather, cardstock, cork, stone, felt, metals, plastics, acrylic, etc.).<br/>


• AtomStack software: AtomStack Studio (PC) and AtomStack APP (mobile) include materials presets, asset library, auto accessory recognition—great for beginners and pros.<br/>


• Mini & portable: compact (265 × 303 × 185 mm), ~3 kg. Fits home, studio, trade shows, and shops.<br/>


• Fast engraving: up to 10,000 mm/min.<br/>


• High detail: CoreXY with dual motors; positioning accuracy up to 0.1 mm.<br/>


• Class‑1 safety: fully enclosed design with viewing window, tilt detection, door detection, and USB key lock.<br/>


• Quick focus: built‑in fixed focus lever.<br/>


• Rich accessories: supports rotary chuck/roller/belt accessories (sold separately) to handle tumblers, rings, bracelets, and even expanded working areas.<br/>


• Certifications: IEC 60825‑1 Class 1, CE, RoHS, FCC, FDA.<br/>


• Compatibility: Works with AtomStack software on Android/iOS/Windows/macOS; also compatible with LightBurn (paid).`,
        },
        {
          Q: ` Is there a dedicated purifier?`,
          A: `Use the AtomStack [link:/products/atomstack-d3-air-purifier:D3 purifier]. The P1 exhaust port is 49 mm OD; use the supplied adapter to connect. See the D3 connection tutorial.`,
          video_url: [`https://www.youtube.com/embed/o3Ij-po3u_c`],
        },
        {
          Q: `Can I use a honeycomb panel?`,
          A: `Not necessary. The included metal base plate is designed for cutting. Use the supplied magnets to lift the workpiece slightly for cleaner cuts.`,
        },
        {
          Q: ` Can I use air assist?`,
          A: `No. The module has no air port. The enclosure uses a high‑speed exhaust fan to remove smoke for cleaner results.`,
        },
        {
          Q: `What safety measures are included? Do I need safety glasses?`,
          A: `• Safety: fully enclosed design with viewing window; tilt detection; door detection; USB key lock.<br/>


• Glasses: Not required when operating inside the enclosure. If you install risers to use a rotary (enclosure open), wear appropriate laser safety eyewear.`,
        },
        {
          Q: `What if the material is too large to fit the enclosure?`,
          A: `The bottom plate is removable. Remove it to engrave oversized items.`,
        },
        {
          Q: ` What software can I use?`,
          A: `Recommended: AtomStack Studio (PC) and AtomStack APP (mobile). LightBurn is also supported. For LightBurn, set baud to 460800 or import the P1 config from the USB drive.`,
        },
        {
          Q: ` What is the operating temperature?`,
          A: `Recommended ambient: 0–35°C.`,
        },
        {
          Q: `Can it engrave reflective materials?`,
          A: `No. Reflective or highly refractive materials are not supported and may damage the laser.`,
        },
      ],
      [
        {
          Q: `Control Panel and Functions?`,
          A: `
          1. USB Key — Insert to unlock the machine.<br/>


          2. Accessory Port — Connect rotary rollers/chucks and other add-ons.<br/>


          3. USB Slot — Required when using the mobile APP; otherwise the APP will not operate.<br/>


          4. Type-C Port — Connect to a PC with a Type-C cable.<br/>


          5. Power Input — 24V 3A.<br/>


          6. Power Switch — Turn the engraver on/off.<br/>


          7. APP Frame / Repeat Button (APP mode only): press once to Frame; press and hold (3s) to repeat the last job.<br/>


          8. Start / Pause Button: press once to pause/resume; double-click to clear errors; hold (3s) to toggle Bluetooth pairing / Wi-Fi mode. The ring indicator lights when an accessory (e.g., rotary) is connected.<br/>


          9. Status Indicator: solid green = normal; blinking green = paused; solid red = error; solid blue = laser firing.<br/>


          10. Wi-Fi Indicator: off = not connected; blinking = connecting; solid green = connected.<br/>


          [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_1_ae3571a6-73c7-4cf4-b2c4-e994974c8aa8.png?v=1758866558:Fig. 1]`,
        },
        {
          Q: `What about the PC connection?`,
          A: `• With AtomStack Studio: no baud‑rate setup required.<br/>


              • With LightBurn: set baud rate to 460800 or import the provided P1 config file (included on the USB drive). See Fig. 1.<br/>


              • The laser has a fixed focus lever—lower it until it touches the material surface (Fig. 2).<br/>


              • The module is secured by an L‑shaped hand screw for fast focusing. If the screw handle is blocked by the rail, pull the handle outward to reposition (Fig. 3).<br/>


              [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1.png?v=1758866781:Fig. 1]
              [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2.png?v=1758867024:Fig. 2]
              [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._3.png?v=1758866954:Fig. 3]`,
          video_url: [`https://www.youtube.com/embed/ZV_OsUjkZ4k`],
        },
        {
          Q: `What about the APP connection?`,
          A: `• See the APP tutorial / user manual.<br/>


              • Insert a USB drive before using the APP.<br/>


• During Bluetooth APP setup, follow the provisioning flow to connect the P1 to your router (Wi‑Fi).<br/>


• The APP includes a material library and sample assets. If results are too deep/shallow, lower/raise power or increase/decrease speed accordingly.`,
          video_url: [`https://www.youtube.com/embed/fS4eDWv50Hs`],
        },
        {
          Q: `How do I replace the laser module?`,
          A: `• The module includes a fixed focus lever; no focusing card is required.
              • Fast swap via L‑shaped hand screws. If the handle is obstructed by the rail, pull it outward to rotate freely (Fig. 1).
              • With the [link:/products/atomstack-p1-1w-1064nm-laser-module:1.2W infrared module], the machine may auto‑preheat for ~2–10s at low ambient temperatures before engraving.
              [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_a3d30f12-dcfe-4279-ba67-86bdd70d4601.png?v=1758867988:Fig. 1]`,
          video_url: [`https://www.youtube.com/embed/eVCdVBK4DDA`],
        },
        {
          Q: `How do I connect the rotary devices (R6 / R8 / R8 Pro)?`,
          A: `• Supports AtomStack R6, R8, R8 Pro (auto‑recognition) only. Use the dual‑USB auto‑ID cable to the accessory port (Fig. 1).<br/>


• If your rotary kit lacks riser feet, purchase the H5 riser kit.<br/>


• AtomStack Studio: R6 requires no parameters; R8 requires entering the workpiece diameter or circumference (Fig. 2).<br/>


• LightBurn: set rotation type (R6 = Roller, R8 = Chuck), axis = Y. Parameters: R8 = 160 mm/rotation (fixed), R6 = 50 mm/rotation (fixed) with rotary diameter 16 mm (fixed). Provide either diameter or circumference (Fig. 3).<br/>


• Remove the bottom plate (turn latches clockwise) and install risers when using a rotary (Fig. 4).<br/>


• If results appear mirrored, toggle Mirror in AtomStack Studio (Fig. 5) or LightBurn (Fig. 6).<br/>


[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_503d242a-2e43-4397-bafb-0bded3e54a25.png?v=1758869138:Fig. 1]
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_f3a93e58-4651-4de3-aad6-a3edb646f87c.png?v=1758869182:Fig. 2]
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._3_2acad521-fa1e-4c33-ae9f-838b89d89ab5.png?v=1758869183:Fig. 3]
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._4.png?v=1758869184:Fig. 4]
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._5.png?v=1758869182:Fig. 5]
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_6dc8da09-daa0-476b-b19d-9af59fec2224.png?v=1758875525:Fig. 1]
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_7f51015e-a34f-4251-ae09-e9e6ff3094c7.png?v=1758875525:Fig. 2]`,
          video_url: [
            `https://www.youtube.com/embed/aT0n1hF0wgI`,
            'https://youtu.be/0dIsqOSiCnk',
            'https://youtu.be/rCjEHuaNifs',
          ],
        },
        {
          Q: `How do I focus the laser?`,
          A: `Loosen the L‑shaped hand screw, lower the fixed focus lever until it touches the material surface, tighten the screw, then retract the lever. If the screw handle is obstructed by the rail, pull it outward to reposition (Fig. 1).
          [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_8b836157-dd15-4a21-994f-9bd4dead2e69.png?v=1758870212:Fig. 1]`,
          video_url: [`https://www.youtube.com/embed/BQ-HoWZhJ1A`],
        },
        {
          Q: `How to use the coordinate modes (software)?`,
          A: `• Current Position — The laser starts where you place it manually.<br/>


• User Origin — You choose and set a start point.<br/>


• Absolute Coordinates — Uses machine home (0,0) after homing; the design’s absolute position determines the start (LightBurn: Fig. 1; AtomStack Studio: Fig. 2).<br/>


[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_1cbb6018-412a-4950-88c1-df4dca21d4be.png?v=1758870332:Fig. 1]
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_35b234c1-5a8e-496c-bba9-1136654792e2.png?v=1758870384:Fig. 2]`,
        },
        {
          Q: `What is the parameter test (software)?`,
          A: `Available in licensed LightBurn v1.3.01+ or AtomStack Studio. Use parameter tests to quickly find optimal settings for different materials.`,
        },
      ],
      [
        {
          Q: `How do I clean the laser window and fan?`,
          A: `The laser window (protective glass) is non-removable. Use 99% anhydrous ethanol or optical-grade lens cleaner (avoid ammonia/acetone). Wipe gently with a lint-free cloth in one direction (e.g., center-out spiral) to prevent scratches. Side-light with a bright source to confirm no residue/fibers remain. Daily cleaning for heavy use; weekly for light use. If the window is damaged, contact [link:/pages/contact:support].
          • Dust buildup on the module fan impairs cooling. Clean weekly (heavy use) or every 1–2 months (light use). Use lint-free cloths or optical swabs (avoid fuzzy cotton swabs).`,
        },
        {
          Q: `How do I clean the enclosure interior?`,
          A: `Use 99% anhydrous ethanol and a lint‑free cloth. Avoid corrosive liquids and avoid back‑and‑forth rubbing that may scratch surfaces. Clean weekly (heavy use) or monthly (light use). After wiping the linear shafts, apply grease evenly (recommend NLGI grade 2 below 15°C; grade 3 above 15°C). When cleaning the exhaust fan, disassemble carefully; do not force. See Fig. 1 for screw locations.
          [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_93fe5274-a555-40d2-9d30-247235d830e9.png?v=1758871190:Fig. 1]`,
          video_url: [`https://www.youtube.com/embed/wH6GIgNEeTg`],
        },
        {
          Q: `What about long-term storage?`,
          A: `• Store in a dry place; avoid humidity over time.<br/>


• Power on the machine periodically to keep electronics in good condition.`,
        },
        {
          Q: `What should I do when the PC connection fails and the software cannot connect?`,
          A: `• Check panel indicators: solid green = normal; solid red = alarm. If red, confirm the door is closed, head not pressing limit switches, USB key seated, and the door limit switch works. If the door switch is faulty, you may temporarily disable Door Detection in the APP or AtomStack Studio (see Fig. 1) but operate cautiously.<br/>


• LightBurn baud rate: 460800 (Fig. 2). Or import the P1 config file.<br/>


• Serial/COM port: check Device Manager (plug/unplug Type‑C to see changes). If not recognized or shows warnings, install the USB serial driver. Example COM port shown in Fig. 3.<br/>


• Try a different Type‑C cable/port; try AtomStack Studio.<br/>


[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_66a922ca-e2e4-4b62-b39a-f8269c2acd78.png?v=1758872181:Fig. 1]
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_d725f250-7ca2-4666-b982-246986198f8b.png?v=1758872181:Fig. 2]
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._3_d59aa01a-81d3-4f7f-bc93-c3595758fb58.png?v=1758872181:Fig. 3]`,
          video_url: [`https://www.youtube.com/embed/ihZ-cWw5rw8`],
        },
        {
          Q: `What should I do if the mobile app connection fails?`,
          A: `• Check Wi‑Fi signal strength on your phone near the machine. If weak, see “ Wi‑Fi signal is very weak.”<br/>


• Ensure no other device is occupying the P1’s Wi‑Fi connection.<br/>


• Try alternative modes: Wi‑Fi, Bluetooth, or Hotspot as supported. See APP connection tutorial.<br/>

`,
          video_url: [`https://www.youtube.com/embed/fS4eDWv50Hs`],
        },
        {
          Q: `What should I do if the laser window dirty or damaged?`,
          A: `• If dirty: clean with 99% anhydrous ethanol or optical‑grade cleaner (avoid ammonia/acetone). Wipe gently with a lint‑free cloth in one direction. Side‑light to confirm clean. Clean daily (heavy use) or weekly (light use). See window /fan cleaning video.<br/>


• If damaged: the window is non‑replaceable; replace the entire module. Provide clear photos of the damage, the machine Serial Number (Fig. 1), and the laser module code (Fig. 2) to support.<br/>


[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_6dc8da09-daa0-476b-b19d-9af59fec2224.png?v=1758875525:Fig. 1]
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_7f51015e-a34f-4251-ae09-e9e6ff3094c7.png?v=1758875525:Fig. 2]`,
          video_url: [`https://www.youtube.com/embed/OE0dVz_c5_w`],
        },
        {
          Q: `What should I do if the P1 will not power on or boot normally?`,
          A: `Indicator is RED:<br/>


• Door closed? Open and re‑close. Check the Hall switch wiring at the door (Fig. 1). Use a small magnet near the Hall sensor—if it turns green (Fig. 2), the door magnet may be weak or the switch/wiring loose. See “Door Detection not working.”<br/>


• Head at the edge? Manually move the head to the center to avoid pressing a limit switch.<br/>


• Limit switches: press each internal limit switch to confirm it triggers (Fig. 3).<br/>


• USB key: gently wiggle to detect intermittent contact. Reseat. If needed, press the USB jack shell slightly inward to improve contact (Fig. 4). Provide a fault video and Serial Number (Fig. 5) to support.<br/>


• Firmware: copy the latest (or previous) firmware to the USB drive root; insert and wait for beeps to finish. See firmware tutorial.<br/>


• If unresolved: mainboard replacement.<br/>


<br/>


Indicator cycles RED/GREEN with beeps:<br/>


• Usually poor USB‑key contact. Reseat or gently press the USB jack (Fig. 6).<br/>


<br/>


No indicator light:<br/>


• Power adapter: check the adapter LED. Measure output DC 20–25V (Fig. 7). If <20V, adapter is faulty.<br/>


• Power switch: disconnect adapter, open the top lid, short the two power‑switch leads with a wire, reconnect power and test. If it boots, replace the switch (see short‑connect tutorial).<br/>


• If still off: mainboard failure; replace the mainboard.
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_9dcb2e48-1b1b-43f0-b08b-3145b73b8019.png?v=1758876240:Fig. 1]
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_db7131db-d00e-43ca-96fb-1fb037bac0f9.png?v=1758876242:Fig. 2]
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._3_dc3a7d68-d145-4b79-b2b2-400dc04ba248.png?v=1758876242:Fig. 3]
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._4_f24a252f-83a6-4ffa-b4ac-310c9c0c5c1b.png?v=1758876238:Fig. 4]
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._5_ce9b5d8b-f3c4-4db4-a89e-79abb87ef94a.png?v=1758876242:Fig. 5]
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._6.png?v=1758876238:Fig. 6]
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._7.png?v=1758876243:Fig. 7]`,
          video_url: [
            'https://youtu.be/AR1UlNIDheI',
            'https://youtu.be/5k5FWyUSaL8',
            'https://youtu.be/tmiQr5I2_a0',
          ],
        },
        {
          Q: `What should I do when the door detection (open-door check) is not working?`,
          A: `• Check wiring: reseat the Hall switch connector at the door (Fig. 1).<br/>

<br/>


• Confirm the door is fully closed.<br/>


• Ensure Door Detection is enabled in AtomStack Studio or the APP (Fig. 2).<br/>


• Test the Hall switch with a magnet—if it turns green, the door magnet is weak; replace the magnet. If no response to any magnet, replace the Hall switch board (Fig. 3). Until replaced, you can disable Door Detection via software to continue (operate cautiously).
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_d513bebf-8667-4f2f-b0aa-7335de140edf.png?v=1758876997:Fig. 1]
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_b8e17245-7492-46e4-a751-78a56a1ff66d.png?v=1758876995:Fig. 2]
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._3_ce1c5e1b-be3a-46a3-9f54-6ceb625d5ee7.png?v=1758876996:Fig. 3]`,
          video_url: ['https://youtu.be/FxNPiXiqvlM', 'https://youtu.be/KI-CWcxoMhc'],
        },
        {
          Q: `What steps should I take to troubleshoot the problem of the engraving becoming very shallow?`,
          A: `• Focus: refocus after placing material (see focusing tutorial).<br/>


• Flatness: ensure the work surface and material are flat; warping leads to uneven depth.<br/>


• Material suitability: only non‑transparent materials engrave properly. Verify compatibility in the P1 parameter sheet.<br/>


• Software parameters: start from recommended values; for missing presets, test to find optimal parameters based on similar materials.<br/>


[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_5a7391e8-1936-46c7-811a-7edf71fc0b19.png?v=1758878187:Fig. 1]
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_ecc27018-bb82-4995-bf4b-5b222fc77176.png?v=1758878187:Fig. 2]`,
          video_url: ['https://youtu.be/jheG1aVGWzc', 'https://youtu.be/OE0dVz_c5_w'],
        },
        {
          Q: `What steps should I take to troubleshoot the significant drop in cutting performance?`,
          A: `• Usage time: diode power naturally decays over time—compensate with higher power or lower speed.<br/>


• Refocus for different material thicknesses.<br/>


• Power adapter output: verify 20–25V DC (Fig. 1).<br/>


• Software: confirm LightBurn S‑Max remains 1000 (Fig. 2). Consult the parameter sheet.<br/>


• Window condition: clean or replace module if the window is damaged. If all checks pass but cutting is still weak, the module may have failed. Provide videos, Serial Number (Fig. 3), and module code (Fig. 4) for support and replacement.<br/>


[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_9ef33927-e637-472d-9f35-5c69c9f4ecd1.png?v=1758879259:Fig. 1]
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_9f4b2911-7f56-4872-a8eb-5318166f6ea5.png?v=1758879253:Fig. 2]
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._3_4979a38b-f5a1-4655-bdc7-49b771418f7f.png?v=1758879256:Fig. 3]
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._4_e4080901-5eea-4916-97c6-1a92dfdabb2d.png?v=1758879256:Fig. 4]`,
          video_url: ['https://youtu.be/OE0dVz_c5_w', 'https://youtu.be/eVCdVBK4DDA'],
        },
        {
          Q: `What steps should I take to troubleshoot the machine when the head moves but there is no laser output?`,
          A: `• Do not engrave reflective materials unprepared—coat the surface (e.g., black paint) or avoid such materials to prevent damage.<br/>


• Power adapter: verify 20–25V DC output (Fig. 1).<br/>


• Laser cable: reseat the connector.<br/>


• Recognition: AtomStack Studio auto‑detects modules. If framing/engraving reports “no laser installed,” the module or cable may be faulty. Use a multimeter to continuity‑test the cable.<br/>


• Cable voltages: while running 100% power at 1 mm/min, measure on the module connector (Fig. 2): pins 1–2 = 20–25V; pins 2–3 = >1–6V. If voltages are normal, the module is faulty—replace it. Provide Serial Number (Fig. 3) and module code (Fig. 4).<br/>


[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_a0b3913e-8eb1-483d-86a2-a44ad163514b.png?v=1758879965:Fig. 1]
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_92ae4bd7-e6ac-4df8-ac8f-cb9467ba1532.png?v=1758879963:Fig. 2]
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._3_67edfcda-a2c5-4a07-bc94-fce4e4dcb348.png?v=1758879966:Fig. 3]
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._4_cb09bafa-0516-4b19-9aa6-bb93c4ac1987.png?v=1758879965:Fig. 4]`,
          video_url: ['https://youtu.be/r-iuQcnabiQ', 'https://youtu.be/eVCdVBK4DDA'],
        },
        {
          Q: `What steps should I take to troubleshoot the machine when it stops unexpectedly during a job?`,
          A: `• Power adapter: LED on and DC output 20–25V? If mains power is unstable locally, try again or use another 24V 3A adapter.<br/>


• Rebooting during jobs may indicate a mainboard or adapter fault.<br/>


• “Alarm 1” or out‑of‑bounds without hitting the frame: likely a limit‑switch failure; if it hit the boundary, scale down the job.<br/>


• “Disconnected”: may be Type‑C cable/COM/mainboard fault. Try another cable/port and install drivers. If disconnects persist, replace the mainboard.<br/>


• No alarm message at all: re‑flash firmware. If still bad, mainboard failure.`,
        },
        {
          Q: `What steps should I take to troubleshoot inconsistent results when using the same material and parameters?`,
          A: `• Focus consistency: refocus after material changes.<br/>


• Flatness: ensure base plate and material are flat.<br/>


• Grain variations: natural grain causes variability—try MDF.<br/>


• Window: clean the laser window.<br/>


• Mechanical: check motor pulley set‑screws (Fig. 1) and confirm belts sit correctly on idlers (Fig. 2).<br/>


• If unresolved, send a video showing settings, material surface, results, plus Serial Number (Fig. 3) to support.
[img::https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_bb68daf6-95ca-42d9-b57b-ace150c4fc17.png?v=1758881305Fig. 1]
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_34693420-d2cc-4823-8e05-f9643944688c.png?v=1758881305:Fig. 2]
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._3_2bd88497-7331-4f5b-b5c9-2f4d37ee8815.png?v=1758881303:Fig. 3]`,
        },
        {
          Q: `What steps should I take to troubleshoot and fix poor engraving quality?`,
          A: `• Parameters: verify against the P1 parameter sheet.<br/>


• LightBurn S‑Max: confirm 1000 (Fig. 1).<br/>


• Window: clean or replace the module if the window is damaged.<br/>


• Adapter voltage: confirm 20–25V (Fig. 2).<br/>


• Fill artifacts: if horizontal banding occurs, reduce line interval to ~0.08 mm and use Vertical scanning (AtomStack Studio: Fig. 3; LightBurn: Fig. 4).<br/>


• Power decay check: 100% power at 200 mm/min cutting 3 mm plywood in one pass—if it fails, the module may be at end‑of‑life.<br/>


• If patterns are irregular, see “Irregular patterns.”<br/>


[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_80b834f6-b089-4b7c-8c66-3954e163ca78.png?v=1758881678:Fig. 1]
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_af386a49-fb78-42a5-806d-7a0e444f7098.png?v=1758881679:Fig. 2]
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._3_106746fb-788d-4296-8157-d771814d2778.png?v=1758881678:Fig. 3]
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._4_7a55f36f-cebc-46f3-ba00-c084db4d47fc.png?v=1758881678:Fig. 4]`,
          video_url: ['https://youtu.be/OE0dVz_c5_w', 'https://youtu.be/eVCdVBK4DDA'],
        },
        {
          Q: `What steps should I take to troubleshoot irregular patterns or distorted shapes?`,
          A: `• Jog test: use arrow keys to move axes; if motion is diagonal (45°) or wrong, a motor or driver may be faulty. Swap motor connectors to see if the issue moves—if it moves, mainboard driver is faulty; if not, the motor is faulty.<br/>


              • Circle & square test: draw vector circle & square.<br/>


              – If unequal sides but straight lines are fine: steps/mm may have changed. Check LightBurn Machine Settings: $100 and $101 should be 100.270 (Fig.1).<br/>


–               If wavy/curved lines: adjust mechanics—belt tension, belt in idlers (Fig. 51), X‑axis parallelism, motor pulley set‑screws (Fig.2). If still bad, re‑flash firmware. Provide video, parameter screenshots, and Serial Number (Fig.3).<br/>


[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_5740fce0-dc1d-4b9b-be58-e5922485e13a.png?v=1759996632:Fig. 1]
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_c24d885c-61e7-42df-bfe0-e0bfc4388146.png?v=1759996632:Fig. 2]
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._3_25095fe6-6893-4207-840c-4c403285fbc3.png?v=1759996632:Fig. 3]`,
          video_url: [
            'https://youtu.be/y14XNf4T6KU',
            'https://youtu.be/z6b6Gc5Ingk',
            'https://youtu.be/ihZ-cWw5rw8',
            'https://youtu.be/mqn7Ee4Draw',
          ],
        },
        {
          Q: `What steps should I take to troubleshoot the repeated "Warn! Hit the limit." error message?`,
          A: `• Module type: note that the infrared module working volume is 105 × 100 × 50 mm.<br/>


• File size: ensure the design fits within the P1 work area.<br/>


• Coordinates: remove negative coordinates; restart software and re‑import the file.<br/>


• Motion check: engrave a 20 × 20 mm square. If size is off, steps/mm may have changed or the controller is abnormal. In LightBurn Machine Settings, set $100 and $101 to 100.270 (Fig. 1). Re‑flash firmware if needed; otherwise mainboard failure.
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_5de6e241-c890-4653-a0c9-0db92a3a5351.png?v=1759997525:Fig. 1]`,
        },
        {
          Q: `What steps should I take to troubleshoot the issue where the frames appear normal, but the engraving crashes into the boundary?`,
          A: `• Calibrate the infrared red‑cross cursor first (applicable only to the IR module). See tutorial.<br/>


• If still off, enter LightBurn Console and send: $rst=* (Fig. 1), then calibrate the cross cursor again.<br/>


• If still off, reset offsets with either:<br/>


$aux_red_light/offset_y_mm=0<br/>


$aux_red_light/offset_x_mm=0<br/>


or [ESP312]/X0/Y0<br/>


Then re‑calibrate the cross cursor.
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_27e93623-d1c9-4577-bda3-5b2c9e29e95e.png?v=1759997748:Fig. 1]`,
          video_url: ['https://youtu.be/agxm6chTlZs'],
        },
        {
          Q: `How can I fix the issue where the IR engraving is misaligned from the framed outline and results in a crash?`,
          A: `Calibrate the IR red‑cross cursor (only on the IR module). If still misaligned, follow the steps in topic 14.`,
          video_url: ['https://youtu.be/agxm6chTlZs'],
        },
        {
          Q: `What steps should I take to troubleshoot the machine when it crashes into the frame during engraving?`,
          A: `• Design size: ensure it fits (diode: 110 × 110 mm; IR: 105 × 100 mm).<br/>


• Always Frame before engraving. If the frame exceeds boundaries, the job will crash.<br/>


• Coordinate mode: with Current Position, always frame first to ensure clearance. With Absolute Coordinates and a file smaller than the work area, crashes are unlikely.<br/>


• Module type difference: diode uses the laser spot as (0,0) after homing; IR uses the red‑cross center as (0,0).<br/>


• Axis motion: use arrow keys to verify correct motion; if only diagonal motion or alarms occur, reseat motor connectors (Fig. 01).<br/>


• Firmware: update to latest via AtomStack Studio/APP. If already latest, try a previous version. If unresolved, consider swapping mainboard and motors. Provide Serial Number and fault video. See firmware, mainboard, and motor replacement tutorials.
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_39de5251-6494-4f1b-8345-18219bffddb0.png?v=1759998153:Fig. 1]`,
          video_url: [
            'https://youtu.be/ihZ-cWw5rw8',
            'https://youtu.be/tmiQr5I2_a0',
            'https://youtu.be/y14XNf4T6KU',
          ],
        },
        {
          Q: `What steps should I take to troubleshoot and prevent thin/light materials from "skipping lines" or shifting during engraving?`,
          A: `The enclosure fan can lift or move very light materials. Use the supplied magnets or weights to secure corners/edges.`,
        },
        {
          Q: `What steps should I take to troubleshoot the very weak Wi-Fi signal?`,
          A: `• Wi‑Fi antenna: open the top cover and reseat the antenna connector on the mainboard (Fig. 1).<br/>


• If still weak, the antenna may be faulty—replace it (see antenna replacement tutorial).<br/>


• No Wi‑Fi at all may indicate firmware or mainboard faults. Re‑flash compatible firmware; if still absent, replace the mainboard.
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_78893b86-2c08-491a-91df-ea5da24fa683.png?v=1759998527:Fig. 1]`,
          video_url: [
            'https://youtu.be/ihZ-cWw5rw8',
            'https://youtu.be/tmiQr5I2_a0',
            'https://youtu.be/AYHzv-ErtUs',
          ],
        },
        {
          Q: `What steps should I take to troubleshoot the clicking noise when the machine moves at a 45° angle or doesn't move at all?`,
          A: `• Motor connectors: reseat.<br/>


• Identify the faulty motor by unplugging one motor at a time. Swap connectors to determine if the issue follows the motor (driver issue) or stays with the same motor (motor issue). Replace the faulty part accordingly.`,
          video_url: ['https://youtu.be/y14XNf4T6KU', 'https://youtu.be/ihZ-cWw5rw8'],
        },
        {
          Q: `How can I fix the issue of the machine failing to home or reset?`,
          A: `
• Limit switches: manually press X and Y limit switches (Fig. 58). If not triggering, reseat connectors; if still bad, replace the switch (see replacement tutorial).<br/>


• Axis motion: verify normal motion with arrow keys. If clicking or no motion, see topic 19.<br/>


• Firmware: check and update via AtomStack Studio/APP (Fig. 1). Insert a USB drive to update.<br/>


• Motor pulleys: tighten the pulley set‑screws on both motors with a 1.5 mm hex key (Fig. 2).<br/>


• Factory reset: In AtomStack Studio v2.20+, tap the Version Number 7 times to enter Developer Mode (Fig. 3). Open “Serial Port Log” and click “Reset” (Fig. 4). Or in LightBurn Console, type $RST=* (Fig. 5).
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_9b739df6-bfd3-41c4-bf64-92a51a2c602e.png?v=1759999747:Fig. 1]
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_95681a47-b4b5-4d0e-9019-d3b59aa68587.png?v=1759999746:Fig. 2]
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._3_bab624de-2daa-4f60-96b0-5aa3abf4c5e5.png?v=1759999746:Fig. 3]
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._4_1f878555-3088-4fea-b461-21b2f072d9b6.png?v=1759999746:Fig. 4]
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._5_45315ee9-0193-4ccc-9465-b5919f5c8277.png?v=1759999746:Fig. 5]
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._6_488008b7-7ded-48ea-8fff-3b3a319d4175.png?v=1759999746:Fig. 6]`,
          video_url: ['https://youtu.be/dYEL2UDOIXo'],
        },
        {
          Q: `What steps should I take to troubleshoot vector lines that don't close and have gaps at the ends?`,
          A: `• Focus: refocus with the fixed focus lever correctly.<br/>


• Energy: increase power or reduce speed.<br/>


• Constant Power: enable Constant Power mode (LightBurn: Fig. 1; AtomStack Studio: Fig. 2).<br/>


[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_2f3b82ab-765a-4f42-8f96-0c829ffc087f.png?v=1760000549:Fig. 1]
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_96c72ac8-20cc-4586-b176-0c7588d30919.png?v=1760000547:Fig. 2]`,
        },
        {
          Q: `What steps should I take to troubleshoot and fix the poor exhaust performance?`,
          A: `• Clean the fans as per the enclosure maintenance tutorial.<br/>


• If using a purifier: check hose kinks/bends; try venting directly. If direct exhaust is fine, the purifier filter may be saturated—replace filters.<br/>


• Replace the enclosure fan if RPM is low after cleaning.`,
          video_url: ['https://youtu.be/wH6GIgNEeTg', 'https://youtu.be/kXQU8bgUv2M'],
        },
        {
          Q: `What steps should I take to troubleshoot the friction noise that occurs during operation?`,
          A: `• Linear shafts: if dry, apply lubricant.<br/>


• Belts: ensure the timing belts sit in the idler grooves (Fig. 1); misalignment can rub on standoffs. See belt replacement and idler adjustment tutorials.<br/>


• Steps/mm: verify LightBurn Machine Settings $100 and $101 are 100.270.<br/>


• Motor pulley set‑screws: tighten with a 1.5 mm hex key (Fig. 2).<br/>


[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_eda7e05d-eb59-4c93-8174-45912360aeb5.png?v=1760001151:Fig. 1]
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_e26e09ea-f5da-40ef-ad30-71b1f33bf4af.png?v=1760001153:Fig. 2]`,
          video_url: [
            'https://youtu.be/_YZ0CbywgMU',
            'https://youtu.be/wH6GIgNEeTg',
            'https://youtu.be/rEzOaAmhYj0',
          ],
        },
        {
          Q: `How can I correct the issue of getting mirrored output when engraving with the rotary?`,
          A: `• Jog direction: if axes move opposite to the on‑screen arrows, toggle the axis invert ($3) in LightBurn Machine Settings (Fig. 1).<br/>


• Firmware: re‑flash if parameter edits don’t resolve.<br/>


• Software: set rotary parameters, and enable/disable Mirroring as needed (AtomStack Studio: Fig. 2; LightBurn: Fig. 3). If still unresolved, consider replacing mainboard and X/Y motors.<br/>


[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_2fbacaf0-45d7-479c-bf6e-586e8dd2b091.png?v=1760002275:Fig. 1]
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_6e21786f-2174-41c4-b8ac-bff3f5406ecd.png?v=1760002278:Fig. 2]
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._3_1ba08653-9581-4a4f-9599-5d5c9062786a.png?v=1760002279:Fig. 3]`,
          video_url: ['https://youtu.be/ihZ-cWw5rw8', 'https://youtu.be/y14XNf4T6KU'],
        },
        {
          Q: `How can I fix the issue of the USB drive not being recognized?`,
          A: `• Test the USB drive in a computer. If not recognized, replace it and request the required files from support.<br/>


• If prompted to format, use FAT32.<br/>


• If the PC recognizes it and formatting doesn’t help on the P1, the mainboard USB port may be faulty—replace the mainboard.`,
          video_url: ['https://youtu.be/ihZ-cWw5rw8'],
        },
        {
          Q: `What steps should I take to troubleshoot the APP job stopping with the error "USB drive not inserted"?`,
          A: `• Power off the P1; reseat the USB drive and try again.<br/>


• If asked to format in PC, choose FAT32.<br/>


• If storage is abnormal, replace the USB drive.`,
        },
        {
          Q: `How can I fix the issue where the laser head is locked and cannot be manually positioned after the machine powers on?`,
          A: `• Power‑off Resume: if enabled, the head is locked. Connect via APP or AtomStack Studio and disable “Power‑off Resume” (Fig. 1).<br/>


• If still locked after disabling, re‑flash P1 firmware (you cannot flash the same version again; request a different version if needed). If manual movement works only when power is off, the mainboard may be faulty—replace it.<br/>


[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_dee49839-3b61-4bc4-92ff-38515ad91ded.png?v=1760002969:Fig. 1]`,
          video_url: [
            'https://youtu.be/Ah0wyk9I5sg',
            'https://youtu.be/ihZ-cWw5rw8',
            'https://youtu.be/tmiQr5I2_a0',
          ],
        },
        {
          Q: `What steps should I take to troubleshoot the machine when the firmware update fails?`,
          A: `Update directly via AtomStack Studio or the APP (requires a USB drive for storage; see Fig. 1). If it still fails, first confirm the USB drive works on the P1.
          [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_d6dc212d-6975-47e4-b475-a32d7c7a14a3.png?v=1760003252:Fig. 1]`,
        },
        {
          Q: `How to perform software, firmware or app updates?`,
          A: `• AtomStack Studio: if a new version exists, the app prompts to update. Or go to Settings → Check for updates. You can also download from atomstack.com.<br/>


• Firmware: update via AtomStack Studio/APP (requires a USB drive; Fig. 1) or copy the firmware file to the USB root and insert it into the P1.<br/>


• APP: download from atomstack.com or in APP go to Profile → Settings → About ATOMSTACK to check for updates.<br/>


[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_d0382cb6-e9ea-4c02-a1c2-73773dabf351.png?v=1760004748:Fig. 1]`,
        },
        {
          Q: `What steps should I take to troubleshoot and resolve the alarm messages displayed in LightBurn or Grbl?`,
          A: `• Alarm 1 — A limit switch was triggered. If it occurred without physical contact, check each limit switch by manually triggering and reseating connectors to isolate the faulty one.<br/>


• Alarm 2 — Soft limits. Check $20 (soft limits) in Machine Settings; disable if necessary (Edit → Machine Settings; see Fig. 1).<br/>


• Alarm 3 — Disconnected during operation. Use the console/code output to inspect preceding messages and diagnose.<br/>


• Alarm 8 — A limit switch is held active continuously. Reseat or disconnect limit switches one by one to locate the fault.<br/>


• Alarm 11 — Tilt alarm. If the machine did not tilt or the control box wasn’t disturbed, it could be a false alarm. Power‑cycle or disable the tilt alarm via the APP/control screen/AtomStack Studio.<br/>


[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_bdf89232-328a-49af-ab00-4f445f235f2d.png?v=1760004880:Fig. 1]`,
        },
      ],
    ],
  },
  Swift: {
    nav: [`pre-Sale Questions`, `Quick Start`, `Maintenance & Care`],
    nav_desc: [
      `What You Need to Know Before Buying`,
      `Your First Steps Made Simple(For Beginners) `,
      `Keep Your Machine in Top Shape`,
    ],
    quantions: [
      // Category 1: Pre-Sale Questions
      [
        {
          Q: `What is the engraving area of the Swift?`,
          A: `The engraving area is 300mm × 300mm.`,
        },
        {
          Q: `How thick of a wood board can the Swift cut?`,
          A: `With the 7W laser, at 100% power and 120mm/min speed, it can cut 4mm plywood in one pass.<br/>

  With the 12W laser, at 100% power and 110mm/min speed, it can cut 7mm plywood in one pass.`,
        },
        {
          Q: `Can the Swift use laser modules from other AtomStack machines?`,
          A: `AtomStack offers a 1.8W infrared laser module that is compatible with the Swift.`,
        },
        {
          Q: `Can the Swift engrave or cut metal?`,
          A: `It can engrave small portions of metal such as black anodized aluminum, stainless steel, galvanized iron, etc.<br/>

  With an infrared laser module, it can engrave most metals.<br/>

  Cutting metal is not recommended due to the low power.`,
        },
        {
          Q: `Can the Swift connect to a computer via WiFi?`,
          A: `Yes. You need to download the AtomStack Studio Beta version to use WiFi. Under normal circumstances, a wired connection is recommended.`,
        },
        {
          Q: `Can the Swift engrave objects like cups or thermos bottles?`,
          A: `Yes. You will need the R6 or R8 rotary attachment. Please refer to the “Swift Rotary Attachment Connection” section.`,
        },
        {
          Q: `Can the Swift engrave leather? What settings are recommended?`,
          A: `Yes.<br/>

  7W laser:<br/>

  Engraving bitmap: 10,000mm/min, 30% power<br/>

  Cutting 1mm leather: 500mm/min, 100% power<br/>

  12W laser:<br/>

  Engraving bitmap: 10,000mm/min, 20% power<br/>

  Cutting 1mm leather: 700mm/min, 100% power`,
        },
        {
          Q: `Does the Swift support rotary devices?`,
          A: `Yes. Please refer to the “Swift Rotary Attachment Connection” section.`,
        },
        {
          Q: `Which enclosure is recommended for the Swift?`,
          A: `We recommend the FB2 protective enclosure.`,
        },
        {
          Q: `Which air purifier is recommended?`,
          A: `The D3 purifier is recommended. Note: it must be used together with an enclosure, such as the FB2.`,
        },
        {
          Q: `Can the Swift use air assist?`,
          A: `Yes. The Swift has a dedicated air assist with a special air nozzle. See the “Swift Air Assist Connection” section for details.`,
        },
        {
          Q: `Is there a honeycomb panel for the Swift?`,
          A: `Yes. The dedicated F2N honeycomb panel is available, sized 350mm × 350mm.`,
        },
        {
          Q: `Does the Swift have safety features?`,
          A: `Yes. The power button can quickly cut off power.`,
        },
        {
          Q: `Can the Swift be expanded?`,
          A: `Yes. You can install an extension kit to enlarge the working area to 300mm × 600mm.`,
        },
        {
          Q: `What control software is compatible with the Swift?`,
          A: `Compatible with:<br/>

  AtomStack Studio<br/>

  AtomStack APP<br/>

  LightBurn<br/>

  Not recommended: LaserGRBL, because it does not stably support the 460800 baud rate, which may cause stuttering or data errors.`,
        },
        {
          Q: `What is the operating temperature of the Swift?`,
          A: `Blue-light laser: 0°C – 35°C<br/>

  Infrared laser: 10°C – 30°C`,
        },
      ],
      // Category 2: Quick Start
      [
        {
          Q: `What ports and indicator lights are on the Swift panel?`,
          A: `The Swift panel includes:<br/>

  1、Power port: Input 24V 1.5A (7W) or 24V 2A (12W)<br/>

  2、Type-C port: Connect to a computer<br/>

  3、Accessory port: Connect to rotary attachments (requires USB adapter cable)<br/>

  4、Power button: Long-press for 5 seconds to enter WiFi setup<br/>

  5、Indicator lights:<br/>

  White: Solid = Standby; Flashing = WiFi configuration<br/>

  Green: Solid = Connected to WiFi; Flashing = Pause<br/>

  Blue: Solid = Working<br/>

  Red: Solid = Alarm<br/>

  <br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_14a0a109-c645-494f-90d8-2c35069f81dd.png?v=1764732359:Fig. 1]`,
          video_url: ['https://youtu.be/ZoAOg78NhxQ'],
        },
        {
          Q: `How to install the Swift？`,
          A: `Refer to the installation video or user manual.<br/>

  Notes:<br/>

  Do not overtighten screws.<br/>

  When installing the linkage optical axis, ensure the X-axis is parallel to the upper and lower frames before tightening the coupling screws.<br/>

  <br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_7c92a86b-2dca-403e-b871-4e27e18db4f6.png?v=1764732829:Fig. 1]`,
          video_url: ['https://youtu.be/sguqSunzygM'],
        },
        {
          Q: ` How to connect the Swift and choose software？`,
          A: `(1) Software options:<br/>

  Recommended: AtomStack Studio, LightBurn<br/>

  Mobile: Download AtomStack APP<br/>

  AtomStack Studio download: https://atomstack.com/pages/atomstack-studio-software<br/>

  LightBurn download: https://lightburnsoftware.com/pages/download-trial<br/>

  (2) Engraving area setup:<br/>

  In AtomStack Studio, select the correct machine model and the engraving area is set automatically.<br/>

  In LightBurn, manually set the engraving area to 300mm × 300mm, or import the configuration file from the TF card.<br/>

  (See “Swift configuration file import” video.)<br/>

  (3) System notes (Mac users):<br/>

  Mac users should not connect via the Type-C port directly.<br/>

  Use an adapter hub and connect via the USB-A port instead.<br/>

  (4) Choosing a Type-C cable:<br/>

  Non-original or charge-only Type-C cables may cause connection failure.<br/>

  Make sure the cable supports data transfer.<br/>

  <br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_1d2fc041-4779-4fe4-9067-c40fe2186f17.png?v=1764733068:Fig. 1]`,
          video_url: ['https://youtu.be/WSn0kQ7caKo'],
        },
        {
          Q: `How to replace the Swift laser module？`,
          A: `The laser uses a fixed-focus module located on the side bottom of the laser.<br/>

  The laser is secured using an L-shaped hand screw, making focus adjustment faster and easier.<br/>

  If the hand screw is blocked by the optical axis, pull the handle outward to rotate it freely.<br/>

  <br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_1bac7557-7bb3-47e0-adfa-74b32b9f6e61.png?v=1764733364:Fig. 1]<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_9bc4b47e-4b87-4826-aa73-82887bb30cd2.png?v=1764733364:Fig. 2]`,
          video_url: ['https://youtu.be/n3y-cGH_6-I', 'https://youtu.be/vaRW93SHC54'],
        },
        {
          Q: `Can the Swift connect to air assist?`,
          A: `The Swift laser does not come with an air nozzle, so only the F40 Air Assist is compatible.<br/>

  The F40 includes dedicated air nozzles for both the 7W and 12W lasers and must be installed manually.<br/>

  <br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_57e72572-9b69-4039-8147-4ead6315188c.png?v=1764740746:Fig. 1]`,
          video_url: ['https://youtu.be/jB3rUCI9Ruo'],
        },
        {
          Q: `Can the Swift connect to a rotary device?`,
          A: `Rotary selection:<br/>

  The Swift uses threaded risers, so R6, R8, and R8 PRO rotary tools are recommended.<br/>

  Connect the included USB cable to the Accessory port for automatic recognition.<br/>

  If using R1, R1 Pro, R2, R3 Pro, R1-B, or R2-B:<br/>

  You must power off the machine, unplug the Y-axis motor cable, and follow the sequence-connection procedure.<br/>

  Warning: Ensure the device is completely powered off before disconnecting cables to avoid short circuits.<br/>

  The default riser feet may not fit first-generation rotary units. Use four objects of equal height to elevate the Swift.<br/>

  AtomStack Studio configuration:<br/>

  Select the detected rotary device.<br/>

  R6 (roller) requires no parameter changes.<br/>

  R8 (chuck) requires setting the circumference or diameter of the material.<br/>

  LightBurn configuration:<br/>

  Set the rotary parameters manually:<br/>

  Rotary type: Roller for R6, Chuck for R8<br/>

  Rotary axis: Y-axis<br/>

  R8 (chuck):<br/>

  Steps per rotation: fixed at 160mm/rotation<br/>

  Enter either diameter or circumference<br/>

  R6 (roller):<br/>

  Steps per rotation: 50mm/rotation<br/>

  Roller diameter: 16mm (fixed)<br/>

  Enter either diameter or circumference<br/>

  <br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_139d4840-fa5c-4f78-9742-df6c91daf409.png?v=1764741423:Fig. 1]<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_ac9301ac-a493-4fe3-9188-5fe1fc043746.png?v=1764741422:Fig. 2]<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._3_e7d99974-9864-475f-8932-8a0518a5d68e.png?v=1764741423:Fig. 3]<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._4_2452233f-cfc6-4850-9205-e8656d8c4f4b.png?v=1764741423:Fig. 4]<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._5_18647c18-87fa-4d03-ae71-4d1a1594cbc2.png?v=1764741423:Fig. 5]`,
          video_url: ['https://youtu.be/MjLYdcqnZFo'],
        },
        {
          Q: `How to adjust the Swift focus？`,
          A: `Each laser has a fixed-focus knob.<br/>

  Turn the knob fully in the direction of the arrow.<br/>

  When the highest point of the knob touches the material surface, set the laser height and then loosen the knob slightly to complete focusing.<br/>

  Final focus distance is 4mm.<br/>

  <br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_d6714535-7c50-41a3-8067-99bd188f703e.png?v=1764742569:Fig. 1]`,
          video_url: ['https://youtu.be/lBVm3z1xILQ'],
        },
        {
          Q: `What if the L-shaped laser screw is blocked?`,
          A: `If the L-shaped screw is blocked, pull the handle outward and rotate it to a different orientation.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_257203a7-be5f-410b-aa7f-6d99c6e642c7.png?v=1764744372:Fig. 1]`,
          video_url: ['https://youtu.be/lBVm3z1xILQ'],
        },
        {
          Q: `Software coordinate system overview`,
          A: `Current Position:<br/>

  Uses the laser’s current location as the starting point. You can manually move the laser to any desired position.<br/>

  User Origin:<br/>

  A custom start point set by the user.<br/>

  Absolute Coordinates:<br/>

  Uses the home position (0,0) as the origin.<br/>

  The material’s position on the workspace determines the starting location.<br/>

  <br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_3ea0b963-8bdb-41ed-b2dd-8fc5e74bef47.png?v=1764744974:Fig. 1]<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_98a553e6-71b5-4a2f-9942-c74e63a99e9d.png?v=1764744974:Fig. 2]`,
          video_url: ['https://youtu.be/ojRNaf4txn8'],
        },
        {
          Q: `Software engraving parameters`,
          A: `Engraving parameter testing requires:Official LightBurn version 1.3.01 or above, or AtomStack Studio.`,
        },
      ],
      [
        {
          Q: `How to Clean the Swift Laser Module’s Window Lens and Focus Lens`,
          A: `Cleaning Accessories:<br/>

  7W laser module: It has no removable focus lens or window lens, so only the surface of the laser tube’s internal lens needs to be cleaned.<br/>

  12W laser module: It has both a focus lens and a window lens. You may remove the window lens for cleaning, and also check both lenses for damage.<br/>

  Cleaning Method:<br/>

  Use 99% anhydrous ethanol or a professional optical lens cleaner (avoid cleaners containing ammonia or acetone).<br/>

  Wipe gently with a lint-free cloth in a single direction (e.g., from the center outward in a spiral). Avoid back-and-forth wiping that may cause scratches.<br/>

  After cleaning, inspect the lens surface under strong side lighting to ensure there is no residue or fiber.<br/>

  Cleaning Frequency:<br/>

  High-frequency users: clean once daily.<br/>

  Low-frequency users: clean once weekly.`,
          video_url: ['https://youtu.be/rCgK4zlsgIU'],
        },
        {
          Q: `How to Clean Dust Inside the Swift Laser Module`,
          A: `Components to Clean: Laser module fan, driver board, and tube heat sink.<br/>

  Cleaning Method: Start by brushing off surface dust. Then wipe clean with 99% anhydrous ethanol and a lint-free cloth.<br/>

  Cleaning Frequency: Clean when the fan blades are visibly covered with dust.`,
          video_url: ['https://youtu.be/rCgK4zlsgIU'],
        },
        {
          Q: `How to Clean the Swift Frame`,
          A: `Components to Clean: Dust on the Y-axis and X-axis guide rails.<br/>

  Cleaning Method: Use a soft brush to remove dust and debris from the rails to avoid obstruction during operation.<br/>

  Cleaning Frequency:<br/>

  Dusty environments: clean once weekly.<br/>

  Cleaner environments: clean once monthly.`,
          video_url: ['https://youtu.be/1CL4vSDQWDU'],
        },
        {
          Q: `How to Clean the Swift Air Assist`,
          A: `Reason for Cleaning: Prevent dust from blocking the air pump’s intake, which could cause overheating and damage.<br/>

  Cleaning Method: Remove the outer cover, then clean internal dust using a brush, lint-free cloth, and alcohol following the tutorial video.<br/>

  Cleaning Frequency:<br/>

  Dusty environments: once per month.<br/>

  Low-dust environments or infrequent use: once every three months.`,
          video_url: ['https://youtu.be/vgIegZDZ8wQ'],
        },
        {
          Q: `How to Store the Swift When Not Used for a Long Time`,
          A: `If the machine will not be used for an extended period, store it in a dry environment.<br/>

  It is recommended to power on the machine and run it for 5 minutes once per month to maintain the lifespan of electronic components.`,
        },
        {
          Q: `How to Resolve Severely Reduced Cutting Performance of the Swift Laser Module`,
          A: `(!)Normal Power Attenuation:<br/>

  Laser modules naturally lose power over time. This can be compensated by increasing power or reducing cutting speed.<br/>

  (2)Check Laser Focus:<br/>

  Re-focus using the fixed-focus knob at the bottom of the laser module.<br/>

  The correct focus height is 4 mm (distance from the laser module’s bottom frame to the material).<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_1bac7557-7bb3-47e0-adfa-74b32b9f6e61.png?v=1764733364:Fig. 1]
  (3)Check Parameter Settings:<br/>

  Verify that your settings match the recommended parameter table.<br/>

  Ensure the speed unit is mm/min.<br/>

  To view the Swift parameter table:<br/>

  ① Scan the QR code on the machine.<br/>

  ② Visit the official support page: [link:https://atomstack.com/pages/product-support:atomstack.com/pages/product-support]<br/>

  ③ Contact customer service.<br/>

  (4)Check the Maximum S-Value in Software:<br/>

  If using LightBurn, confirm that the maximum S-value is set to 1000 and has not been modified.<br/>

  Do not change the value 1000.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/2_169dd1ff-59b5-49e5-8cd5-eb6189fea669.jpg?v=1764817965:Fig. 2]
  (5)Check for Air Nozzle Obstruction:<br/>

  If using the F40 air assist with the air guide, ensure the guide is installed correctly and not blocking the laser output.<br/>

  (6)Check Window and Focus Lenses for Dirt or Damage:<br/>

  Disconnect power, remove the laser module, and inspect the lenses.<br/>

  If dirty, refer to the “Cleaning Window Lens & Focus Lens” section.<br/>

  (7)Check the Power Adapter Output:<br/>

  Use a multimeter (DC mode) to measure whether the adapter outputs 24V 1.5A (7W) or 24V 2A (12W).<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/3_60c10599-fae4-4627-af94-2b465a802165.jpg?v=1764818203:Fig. 3]
  (8)Check the Laser Module Connector Voltage:<br/>

  Unplug the laser cable.<br/>

  Run a cutting job at 100% power and 1 mm/min.<br/>

  Measure the connector voltage:<br/>

  Pins 1–2: should be 24V<br/>

  Pins 2–3: should be ≥1V (see Figure 18)<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/4_4df4fe2e-1f31-476a-992e-2e1ef753bd7e.jpg?v=1764818349:Fig. 18]
  If:<br/>

  1–2 < 20V or 0V,<br/>

  2–3 < 1V or 0V,<br/>

  then it indicates a motherboard or cable fault.<br/>

  Please send customer service:<br/>

  A fault video<br/>

  Voltage test video<br/>

  A photo of the machine’s Serial Number (see Figure 19)<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/5_586c136d-4de3-4335-a38b-f0428eeee9e3.jpg?v=1764818348:Fig. 19]
  Refer to the laser cable testing video and motherboard replacement video.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/5_586c136d-4de3-4335-a38b-f0428eeee9e3.jpg?v=1764818348:Fig]

  (9)If all checks are normal:<br/>

  If Pin 1–2 ≥ 20V and Pin 2–3 ≥ 1V, then the laser module is experiencing abnormal power degradation.<br/>

  Please provide customer service with a cutting video showing:<br/>

  The parameters used<br/>

  The cutting process<br/>

  Cutting results<br/>

  The laser module engraving code (see Figure 20)<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/7_c29efe61-c933-4a4a-95f9-940bd4223ace.jpg?v=1764818607:Fig. 20]
  Refer to the Swift Laser Module Replacement Video for guidance.`,
          video_url: [
            'https://youtu.be/08OgANnvVWw',
            'https://youtu.be/Ge9sIxBEasA',
            'https://youtu.be/5AZ8ojx6KKo',
            'https://youtu.be/yebgo1L04E4',
          ],
        },
        {
          Q: `How to Solve the Issue When the Swift Laser Moves but Does Not Emit Light`,
          A: `Solutions:<br/>

  (1)Check the Laser Connector:<br/>

  Turn off the power, unplug the laser connector, then plug it back in and check if the issue is resolved.<br/>

  (2)Check Software Parameter Settings:<br/>

  Set parameters according to the parameter table.<br/>

  Ensure the “Output” option for the layer is turned on.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/8_75159a23-511c-4e5f-be06-160b4c51b4f8.jpg?v=1764818775:]
  (3)Check the Adapter Output:<br/>

  Measure the adapter output using a multimeter in DC mode.<br/>

  It should be 24V, 1.5A (7W) or 24V, 2A (12W)<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/3_60c10599-fae4-4627-af94-2b465a802165.jpg?v=1764818203:]
  (4)Check the Laser Connector Voltage:<br/>

  Unplug the laser cable, run a cutting job at 100% power and 1 mm/min.<br/>

  Measure voltage:<br/>

  Pins 1–2: 24V<br/>

  Pins 2–3: ≥1V<br/>

  If Pins 1–2 < 20V or 0V, or Pins 2–3 < 1V or 0V, there may be a motherboard or cable fault.<br/>

  Refer to the Swift Laser Connector Testing Video and Swift Motherboard Replacement Video.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/5_586c136d-4de3-4335-a38b-f0428eeee9e3.jpg?v=1764818348:]
  (5)If the problem persists and the connector voltage is normal:<br/>

  The laser module may be faulty.<br/>

  Provide a fault video showing the set parameters, the cutting/engraving process, and the laser’s serial engraving code to customer service for assistance.
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/7_c29efe61-c933-4a4a-95f9-940bd4223ace.jpg?v=1764818607:]
  `,
          video_url: [
            'https://youtu.be/08OgANnvVWw',
            'https://youtu.be/Ge9sIxBEasA',
            'https://youtu.be/5AZ8ojx6KKo',
          ],
        },
        {
          Q: `How to Solve the Issue When the Laser Emits Light but the Fan Does Not Spin`,
          A: `Solution:<br/>

  Remove the 4 screws on the back of the laser, open the casing, take out the fan, and connect it to the adapter using two wires to test if it spins.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/9_1754199f-d6de-426b-84d9-2154136e1489.jpg?v=1764819423:]
  1.If the fan still does not spin:<br/>

  The fan is faulty.<br/>

  Send the laser serial code and a troubleshooting video to customer service.<br/>

  Refer to the Swift Laser Fan Replacement Video for guidance.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/7_c29efe61-c933-4a4a-95f9-940bd4223ace.jpg?v=1764818607:]
  2.If the fan spins normally:<br/>

  The laser driver board is faulty.<br/>

  Send the laser serial code and troubleshooting video to customer service.`,
          video_url: ['https://youtu.be/vaRW93SHC54'],
        },
        {
          Q: `How to Solve Overheating During Engraving`,
          A: `Solutions:<br/>

  1.Check if theLaser Fan Spins:<br/>

  During engraving, observe if the fan spins.<br/>

  If the fan does not spin, remove the 4 screws, take out the fan, and connect it to the adapter to test.<br/>

  If it spins with the adapter, the driver board is faulty.<br/>

  If it does not spin, the fan is faulty.<br/>

  Send the serial code and troubleshooting video to customer service.<br/>

  Refer to the Swift Laser Driver Board & Fan Replacement Videos.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/9_1754199f-d6de-426b-84d9-2154136e1489.jpg?v=1764819423:]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/7_c29efe61-c933-4a4a-95f9-940bd4223ace.jpg?v=1764818607:]
  2.Check if the Fan is Installed Correctly:<br/>

  Observe the fan’s center label.<br/>

  If the label is facing up, the fan is installed incorrectly. Reinstall with the label facing down toward the tube core.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/10_876bb2bb-d392-4d7d-98d4-12f626a761dc.jpg?v=1764819581:]
  3.Check Window & Focus Lenses for Dirt or Damage:<br/>

  Dirty or damaged lenses can block laser energy, causing overheating.<br/>

  Clean or replace as per “Cleaning Window & Focus Lenses” section.<br/>

  4.Check Internal Cleanliness:<br/>

  Dust buildup inside the laser can hinder heat dissipation.<br/>

  Refer to the Swift Laser Internal Dust Cleaning Video.<br/>

  5.Check Air Guide Installation:<br/>

  Remove the air guide and test.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/11_70e63b66-e844-430d-9b78-fdc7837e8c2a.jpg?v=1764819626:]
  If overheating stops, reinstall the air guide properly.<br/>

  6.If problem persists:<br/>

  Send a fault video and the laser serial code to customer service.`,
          video_url: [
            'https://youtu.be/vaRW93SHC54',
            'https://youtu.be/QDbtpBBO75o',
            'https://youtu.be/vaRW93SHC54',
            'https://youtu.be/rCgK4zlsgIU',
          ],
        },
        {
          Q: `What to Do if the Swift Suddenly Stops During Engraving`,
          A: `Solutions:<br/>

  Ensure mains power is stable without voltage fluctuations.<br/>

  Check that the adapter and Type-C cable are not being moved during engraving.<br/>

  Try different software: AtomStack Studio, APP, or LightBurn.<br/>

  If the issue does not occur in the APP but does in computer software, try a different USB port or Type-C cable.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/12_b466c8e4-757f-4599-a7b5-ef09596c468d.jpg?v=1764819952:]
  Check and update firmware via AtomStack Studio or APP.<br/>

  If the issue persists, provide customer service with:<br/>

  Checked steps<br/>

  Serial Number photo
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/6_44baf0cf-c076-4016-b73b-e6ad395844c0.jpg?v=1764818348:]
  `,
          video_url: [
            'https://youtu.be/08OgANnvVWw',
            'https://youtu.be/Ge9sIxBEasA',
            'https://youtu.be/5AZ8ojx6KKo',
            'https://youtu.be/yebgo1L04E4',
          ],
        },
        {
          Q: `How to Solve Light or Faint Engraving Patterns`,
          A: `Solutions:<br/>

  1.Check for Normal Power Attenuation:<br/>

  Laser power may decrease over time. Increase power or reduce speed to compensate.<br/>

  2.Check Laser Focus:<br/>

  Re-focus using the knob on the bottom; focus height = 4 mm from laser bottom frame to material.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_d6714535-7c50-41a3-8067-99bd188f703e.png?v=1764742569:]
  3.Check Parameter & Material Settings:<br/>

  Ensure settings match recommended parameters for the material.<br/>

  Speed unit must be mm/min.<br/>

  View parameter table: QR code on machine, [link:https://atomstack.com/pages/product-support:atomstack.com/pages/product-support], or contact customer service.<br/>

  4.Check Software Maximum S-Value:<br/>

  For LightBurn, ensure the max S-value = 1000 and not modified.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/2_169dd1ff-59b5-49e5-8cd5-eb6189fea669.jpg?v=1764817965:]
  5.Check Lenses for Dirt or Damage:<br/>

  Disconnect power, inspect window & focus lenses, clean if needed.<br/>

  6.Check Air Guide Installation:<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/11_70e63b66-e844-430d-9b78-fdc7837e8c2a.jpg?v=1764819626:]
  Ensure air guide does not block laser output.<br/>

  7.Check Adapter Output:<br/>

  DC 24V, 1.5A (7W) or 2A (12W).<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/3_60c10599-fae4-4627-af94-2b465a802165.jpg?v=1764818203:]
  8.Check Laser Connector Voltage:<br/>

  Pins 1–2 ≥ 20V, Pins 2–3 ≥ 1V.<br/>

  Lower voltage indicates motherboard fault; provide troubleshooting video, voltage measurement, and Serial Number photo to customer service.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/5_586c136d-4de3-4335-a38b-f0428eeee9e3.jpg?v=1764818348:]
  9.If all is normal but output is still weak:<br/>

  Laser power may be abnormally low.<br/>

  Provide cutting video showing parameters, process, results, and laser serial code.<br/>

  Refer to Swift Laser Replacement Video.
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/7_c29efe61-c933-4a4a-95f9-940bd4223ace.jpg?v=1764818607:]
  `,
        },
        {
          Q: `How to Solve Vector Line Shaking During Engraving`,
          A: `Solutions:<br/>

  Check that X and Y frame screws are tight.<br/>

  Ensure vector speed ≤ 1000 mm/min.<br/>

  Inspect POM wheels on X and Y axes for damage.<br/>

  Check eccentric nuts for proper tension; adjust per Swift Structure Adjustment Video.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/14_3f8f79c2-be41-47ed-a62b-ac3df5b7f78d.jpg?v=1764829611:]
  Check timing belt tension; adjust per Swift Timing Belt Replacement Video.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/15_656a4501-25f0-43bd-90c2-8fa6d819a0d3.jpg?v=1764829755:]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/16_8442021e-fd56-42a7-a4cc-f549c1b4a2fa.jpg?v=1764829755:]
  Tighten motor pulley screws; ensure X-axis distances consistent.<br/>

  Check X-axis horizontal alignment; adjust if needed.<br/>

  If problem persists, provide troubleshooting video and Serial Number photo to customer service.`,
          video_url: [
            'https://youtu.be/aTHsp6CX8Us',
            'https://youtu.be/opUuJ_wYR1M',
            'https://youtu.be/InPaynvy9rI',
            'https://youtu.be/wIFTLnh8Es8',
          ],
        },
        {
          Q: `How to Solve Pattern Deformation or Open Lines`,
          A: `Solutions:<br/>

  Check X/Y frame screws are tight.<br/>

  Inspect POM wheels for damage; send photos and Serial Number if faulty.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/6_44baf0cf-c076-4016-b73b-e6ad395844c0.jpg?v=1764818348:]
  Check eccentric nuts; adjust as described above.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/14_3f8f79c2-be41-47ed-a62b-ac3df5b7f78d.jpg?v=1764829611:]
  Verify step length via LightBurn ($100 & $101 = 100.15).<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/17_107fac4a-e39d-43bf-8f73-67d934c256fa.jpg?v=1764830161:]
  Enable “Overscan” in software (LightBurn, AtomStack Studio).<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/18_5a6e8be4-38f7-414c-aedc-33da471257b6.jpg?v=1764830160:]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/19_60251e84-cb4d-434f-a328-95dc1f075807.jpg?v=1764830160:]
  Check motor pulley screws are tight.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/15_656a4501-25f0-43bd-90c2-8fa6d819a0d3.jpg?v=1764829755:]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/16_8442021e-fd56-42a7-a4cc-f549c1b4a2fa.jpg?v=1764829755:]
  Ensure X-axis and horizontal beams are level.<br/>

  Check timing belt tension; adjust if needed.<br/>

  Test motor movement in software; if direction abnormal, update firmware or swap motor connectors to diagnose motherboard vs motor fault.<br/>

  If unresolved, provide a troubleshooting video with settings, engraving status, results, and Serial Number to customer service.

  `,
          video_url: [
            'https://youtu.be/aTHsp6CX8Us',
            'https://youtu.be/opUuJ_wYR1M',
            'https://youtu.be/wIFTLnh8Es8',
            'https://youtu.be/InPaynvy9rI',
            'https://youtu.be/IbMC0If7qvM',
            '',
          ],
        },
        {
          Q: `How to Solve Swift Reset Failure`,
          A: `Solutions:<br/>

  1.Check if motherboard cables are obstructing movement:<br/>

  Ensure all cables are routed through cable holders and are not pulled during movement.<br/>

  2.Reset causes collision with frame:<br/>

  Usually due to limit switch malfunction. Press X and Y limit switches manually: a “click” sound should be heard, and software should show an alarm.<br/>

  If no click/alarm: check the limit switch connector, unplug and reconnect. If still not working, record a video of the issue and provide the machine Serial Number to customer service.<br/>

  If click/alarm occurs but collision persists: firmware may be abnormal. Update firmware via AtomStack Studio or APP, or provide Serial Number to request matching firmware via TF card.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/22.jpg?v=1764831404:]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/6_44baf0cf-c076-4016-b73b-e6ad395844c0.jpg?v=1764818348:]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/23.jpg?v=1764831404:]
  3.Alarm without movement:<br/>

  Use software (AtomStack Studio, LightBurn) to test movement via arrow keys.<br/>

  If movement is normal: firmware may be abnormal; update firmware via AtomStack Studio or APP, or request matching firmware.<br/>

  If one axis does not move or vibrates: check motor connectors, unplug/replug. If still faulty, swap motor connectors between working and non-working axis to identify motherboard/cable vs motor fault. Send video and Serial Number to customer service.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/20_e19a92de-654b-49b8-96bc-42f3a1ed40b1.jpg?v=1764831403:]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/21.jpg?v=1764831404:]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/24.jpg?v=1764831705:]
  4.Both axes cannot move:<br/>

  Update firmware or request matching firmware.<br/>

  If still unresolved, may be motherboard or cable fault. Provide troubleshooting video and Serial Number. Refer to Swift motherboard and cable replacement videos.<br/>

  5.Try factory reset:<br/>

  In AtomStack Studio version ≥ 2.20: click Version Number 7 times to enter Developer Mode, open “Serial Port Log”, click “Reset”.<br/>

  In LightBurn: input $RST=* in console.
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/28.jpg?v=1764831843:]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/26.jpg?v=1764831774:]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/27.jpg?v=1764831774:]
  `,
          video_url: [
            'https://youtu.be/vr0-nYwbimE',
            'https://youtu.be/IbMC0If7qvM',
            'https://youtu.be/IbMC0If7qvM',
            '',
          ],
        },
        {
          Q: `How to Solve Swift Won’t Power On`,
          A: `Solutions:<br/>

  1.Check adapter output:<br/>

  DC 24V, 1.5A (7W) or 24V, 2A (12W).<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/3_60c10599-fae4-4627-af94-2b465a802165.jpg?v=1764818203:]
  2.Check for short circuits:<br/>

  Unplug all motherboard connectors (limit switches, motors, laser), then try powering on.<br/>

  If power-on succeeds: a short in a component; plug connectors back one by one to find the culprit.<br/>

  If still fails: motherboard fault; provide troubleshooting video and Serial Number to customer service.
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/6_44baf0cf-c076-4016-b73b-e6ad395844c0.jpg?v=1764818348:]
  `,
          video_url: ['https://youtu.be/Ge9sIxBEasA', 'https://youtu.be/08OgANnvVWw'],
        },
        {
          Q: `How to Solve Swift Power On with Red Light Alarm`,
          A: `Solutions:<br/>

  Check connectivity: via AtomStack Studio or LightBurn.<br/>

  Cannot connect: possible motherboard fault; send video + Serial Number.<br/>

  Can connect but no control: may be alarm state due to limit switches; unplug to test.<br/>

  Not limit switch fault: use $i command in Console to check error points; send screenshot to customer service.
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/6_44baf0cf-c076-4016-b73b-e6ad395844c0.jpg?v=1764818348:]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/22.jpg?v=1764831404:]
  `,
          video_url: ['https://youtu.be/Ge9sIxBEasA', 'https://youtu.be/08OgANnvVWw'],
        },
        {
          Q: `How to Solve Swift Cannot Connect to Computer`,
          A: `Solutions:<br/>

  Ensure machine powers on and white light appears.<br/>

  Verify Type-C connection per “Swift Panel Introduction”.<br/>

  Restart software and try reconnecting.<br/>

  Check if computer recognizes COM port; install driver if needed:<br/>

  -Windows driver download link: https://asa.atomstack.com/downloadWindowsDrivers.do3<br/>

  -Mac driver download link: https://asa.atomstack.com/downloadMacDrivers.do3<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/29.jpg?v=1764832282:]
  Ensure no other software occupies the COM port.<br/>

  Windows: Type-C direct; Mac: use hub to Type-C A port.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/30.jpg?v=1764832374:]
  Try different software: AtomStack Studio or LightBurn.<br/>

  Replace Type-C cable to test; if works, original cable is faulty.<br/>

  Try another computer.<br/>

  If unresolved, likely motherboard fault; provide troubleshooting video, Serial Number.
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/6_44baf0cf-c076-4016-b73b-e6ad395844c0.jpg?v=1764818348:]
  `,
          video_url: ['https://youtu.be/Ge9sIxBEasA', 'https://youtu.be/08OgANnvVWw'],
        },
        {
          Q: `How to Solve Swift Cannot Connect to APP`,
          A: `Solutions:<br/>

  Follow Swift APP connection video steps.<br/>

  Ensure latest APP version from [link:https://atomstack.com/pages/software-guide:atomstack.com/pages/software-guide] or App Store.<br/>

  Stay close to the machine’s mainboard when connecting.<br/>

  Ensure WIFI is not in use by another device.<br/>

  Default password: 12345678.<br/>

  Check WIFI signal strength; if weak near machine, WIFI module may be faulty; send video + Serial Number.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/6_44baf0cf-c076-4016-b73b-e6ad395844c0.jpg?v=1764818348:]
  Try another phone; if still fails, send video + Serial Number.`,
          video_url: ['https://youtu.be/WSn0kQ7caKo'],
        },
        {
          Q: `Swift APP Connected but Cannot Engrave`,
          A: `Solutions:<br/>

  Ensure TF card is inserted.<br/>

  Verify software controls (directional movement). Reconnect machine if needed.<br/>

  Check G-code file size (<100MB recommended).<br/>

  Check TF card on computer; format to FAT32 if needed.<br/>

  Try another phone; if still fails, provide video + Serial Number.
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/6_44baf0cf-c076-4016-b73b-e6ad395844c0.jpg?v=1764818348:]
  `,
        },
        {
          Q: `How to Solve Swift Stuttering During Engraving`,
          A: `Solutions:<br/>

  Remove TF card and test.<br/>

  Try different software (AtomStack Studio or LightBurn).<br/>

  Test motor movement via software arrow keys:<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/20_e19a92de-654b-49b8-96bc-42f3a1ed40b1.jpg?v=1764831403:]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/21.jpg?v=1764831404:]
  Normal movement: skip to next check.<br/>

  One axis fails or vibrates: check motor connectors, unplug/replug, swap connectors if needed to identify motherboard/cable vs motor fault; send video + Serial Number.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/24.jpg?v=1764831705:]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/6_44baf0cf-c076-4016-b73b-e6ad395844c0.jpg?v=1764818348:]
  Factory reset: AtomStack Studio → Developer Mode → “Reset” or LightBurn console $RST=*.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/28.jpg?v=1764831843:]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/27.jpg?v=1764831774:]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/25.jpg?v=1764831774:]
  Firmware upgrade: use AtomStack Studio or APP, or request matching firmware via Serial Number.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/23.jpg?v=1764831404:]
  If all checks pass but problem persists, likely motherboard fault; send troubleshooting video, steps, Serial Number.`,
          video_url: [
            'https://youtu.be/Ge9sIxBEasA',
            'https://youtu.be/08OgANnvVWw',
            'https://youtu.be/QDbtpBBO75o',
            'https://youtu.be/Izlqpqgrh5U',
            'https://youtu.be/IbMC0If7qvM',
          ],
        },
        {
          Q: `Swift Engraving Dimension Error`,
          A: `Solutions:<br/>

  Check steps: In LightBurn, go to machine settings and check motor steps $100 and $101—they should be 100.15. Correct if needed.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/17_107fac4a-e39d-43bf-8f73-67d934c256fa.jpg?v=1764830161:]
  Check motor pulley screws: Using an L1.5 hex wrench, ensure both motor pulleys are tight. When tightening, keep equal distance between X-axis ends and horizontal beams.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/15_656a4501-25f0-43bd-90c2-8fa6d819a0d3.jpg?v=1764829755:]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/16_8442021e-fd56-42a7-a4cc-f549c1b4a2fa.jpg?v=1764829755:]
  Structural adjustment: Follow Swift structure adjustment video, focusing on timing belts and pulleys.<br/>

  Factory reset:<br/>

  AtomStack Studio ≥ 2.20: click Version Number 7 times → Developer Mode → “Serial Port Log” → Reset.<br/>

  LightBurn console: input $RST=*.<br/>

  Firmware update: Upgrade via AtomStack Studio or APP, or provide Serial Number to request matching firmware via TF card.<br/>

  If unresolved: Likely motherboard fault; provide troubleshooting video and Serial Number.`,
          video_url: ['https://youtu.be/opUuJ_wYR1M'],
        },
        {
          Q: `Swift X or Y Axis Cannot Move or Makes Noise`,
          A: `Solutions:<br/>

  Test movement via software arrow keys (AtomStack Studio, LightBurn).<br/>

  If one axis fails or vibrates:<br/>

  Check motor connectors, unplug/replug.<br/>

  Swap connectors between working and non-working axis to determine if it’s motor or motherboard/cable fault.<br/>

  Provide troubleshooting video and Serial Number.
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/20_e19a92de-654b-49b8-96bc-42f3a1ed40b1.jpg?v=1764831403:]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/21.jpg?v=1764831404:]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/24.jpg?v=1764831705:]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/6_44baf0cf-c076-4016-b73b-e6ad395844c0.jpg?v=1764818348:]
  `,
        },
        {
          Q: `Swift Cutting Edges Turn Black or Yellow`,
          A: `Solutions:<br/>

  Use air assist: Required for cutting; AtomStack F40 recommended.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/31.jpg?v=1764833528:]
  Check laser focus: Adjust focus knob; focus height = 4mm from material surface.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/32.jpg?v=1764833678:]
  Use honeycomb board: AtomStack F2N recommended.<br/>

  Check material thickness: Follow recommended parameters.<br/>

  Check cutting parameters: Power/speed too high/slow can burn edges. Refer to parameter table via QR code, website, or customer service.<br/>

  Check window & focusing lens: Clean if dirty or damaged.<br/>

  Check laser power: Adjust per parameter table; consider power decay. If still abnormal, provide video and laser code to customer service.
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/7_c29efe61-c933-4a4a-95f9-940bd4223ace.jpg?v=1764818607:]
  `,
        },
        {
          Q: `Swift Engraving Appears Rough`,
          A: `Solutions:<br/>

  Check POM wheels: Inspect all 9 for deformation/damage; provide photos + Serial Number if faulty.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/6_44baf0cf-c076-4016-b73b-e6ad395844c0.jpg?v=1764818348:]
  Check X-axis end screws: Tighten if loose.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/34.jpg?v=1764833820:]
  Check X-axis bracket movement: Adjust horizontal alignment and eccentric nuts if loose.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/14_3f8f79c2-be41-47ed-a62b-ac3df5b7f78d.jpg?v=1764829611:]
  Check timing belt tension: Adjust if too loose.`,
          video_url: [
            'https://youtu.be/opUuJ_wYR1M',
            'https://youtu.be/wIFTLnh8Es8',
            'https://youtu.be/InPaynvy9rI',
          ],
        },
        {
          Q: `Swift Flame Detection Not Working`,
          A: `Solutions:<br/>

  Ensure flame detection is enabled in AtomStack Studio or APP.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/22.jpg?v=1764831404:]
  Keep sensor clean; wipe with lint-free cloth + ethanol.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/35.jpg?v=1764833916:]
  If unresolved: sensor may be damaged; provide troubleshooting steps, video, laser code, and Serial Number to customer service.
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/6_44baf0cf-c076-4016-b73b-e6ad395844c0.jpg?v=1764818348:]
  `,
        },
        {
          Q: `Swift False Flame Alarm`,
          A: `Solutions:<br/>

  Reduce line density or increase speed/reduce power.<br/>

  For MDF cutting, disable flame detection in software if frequent false alarms.<br/>

  Adjust sensitivity in LightBurn or LaserGRBL:<br/>

  $fire_alarm/overflow_value=15 → trigger count<br/>

  $fire_alarm/threshold_value=74 → flame threshold<br/>

  Always monitor machine during operation for safety.
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/36.jpg?v=1764833981:]
  `,
        },
        {
          Q: `Swift Using LaserGRBL Software Abnormal`,
          A: `Solution:<br/>

  Not recommended; default baud rate 460800 causes stuttering and abnormal operation.`,
        },
        {
          Q: `Swift Engraving Pattern Mirror Issue with Rotary`,
          A: `Solutions:<br/>

  Check software mirror settings; toggle if necessary (AtomStack Studio, LightBurn).<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/37.jpg?v=1764834087:]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/38.jpg?v=1764834089:]
  If unresolved: factory reset $RST=* or reflash firmware; request matching firmware if needed.
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/25.jpg?v=1764831774:]
  `,
        },
        {
          Q: `Swift Rotary Connection Cannot Be Used`,
          A: `Solutions:<br/>

  Confirm connection:<br/>

  R6/R8/R8 PRO: use supplied USB cable.<br/>

  R1/R1 Pro/R2/R3 PRO/R1-B: use sequential connection cable to Y-axis motor.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_ac9301ac-a493-4fe3-9188-5fe1fc043746.png?v=1764741422:]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._3_e7d99974-9864-475f-8932-8a0518a5d68e.png?v=1764741423:]
  Confirm settings:<br/>

  AtomStack Studio: R6 roll → no settings, R8 chuck → input material diameter/circumference.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._4_2452233f-cfc6-4850-9205-e8656d8c4f4b.png?v=1764741423:]
  LightBurn: select rotary type, Y-axis, and input parameters (R8: 160mm/rotation; R6: 50mm/rotation, diameter 16mm).<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._5_18647c18-87fa-4d03-ae71-4d1a1594cbc2.png?v=1764741423:]
  Check movement: If abnormal, test rotary motor with Y-axis motor connector; provide video + rotary model label photo.
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/39.jpg?v=1764834362:]
  `,
          video_url: ['https://youtu.be/aVtrXUHuRvI', 'https://youtu.be/MjLYdcqnZFo'],
        },
        {
          Q: `Swift Collides with Frame During Edge Detection or Engraving`,
          A: `Solutions:<br/>

  ◆ Check file size: The Swift engraving area is 300 mm × 300 mm. If the file exceeds this range, it may collide with the frame.<br/>

  ◆ Confirm coordinates used: If using the current position mode, ensure the laser’s position provides enough space for the file size. Manually move the laser to an appropriate position or select absolute coordinates.<br/>

  ◆ Confirm motor step values: In LightBurn or LaserGRBL, go to “Edit → Machine Settings,” double-click “Outputs Setup” to open the list, and check whether $100 and $101 values are 100 and 150. If not, correct them (see Figure 112).<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/17_107fac4a-e39d-43bf-8f73-67d934c256fa.jpg?v=1764830161:]
  Factory reset: AtomStack Studio or LightBurn $RST=*.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/28.jpg?v=1764831843:]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/27.jpg?v=1764831774:]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/25.jpg?v=1764831774:]
  `,
        },
        {
          Q: `Swift Cannot Read TF Card`,
          A: `Solutions:<br/>

  Ensure TF card is inserted.<br/>

  Check TF card integrity on computer.<br/>

  Try another TF card.<br/>

  If unresolved: motherboard may need replacement; provide Serial Number + video.
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/6_44baf0cf-c076-4016-b73b-e6ad395844c0.jpg?v=1764818348:]`,
        },
        {
          Q: `HOW TO Replace Damaged Swift Plastic Parts`,
          A: `Solutions:<br/>

  Provide photos of damage + Serial Number. Customer service will guide replacement; refer to Swift plastic parts replacement video.
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/6_44baf0cf-c076-4016-b73b-e6ad395844c0.jpg?v=1764818348:]
  `,
          video_url: ['https://youtu.be/kMPO_u0odD0'],
        },
      ],
    ],
  },
  Hurricane: {
    nav: [`pre-Sale Questions`, `Quick Start`, `Maintenance & Care`],
    nav_desc: [
      `What You Need to Know Before Buying`,
      `Your First Steps Made Simple(For Beginners) `,
      `Keep Your Machine in Top Shape`,
    ],
    quantions: [
      // Category 1: Pre-Sale Questions
      [
        {
          Q: ` Can Hurricane cut transparent acrylic? What thickness?`,
          A: `Yes, it can cut transparent acrylic. At 100% power and 50mm/min speed, it can cut up to 20mm thickness in one pass.<br/>

  Note: Acrylic cutting produces strong fumes. Use AtomStack D4 purifier or vent the exhaust outdoors.<br/>
`,
        },
        {
          Q: `What is Hurricane's engraving area?`,
          A: `The standard engraving area is 500mm × 300mm.<br/>

  With the R7 conveyor accessory, it can reach 500mm × 800mm. (See “Hurricane Conveyor Accessory” section.)<br/>
`,
        },
        {
          Q: `Can Hurricane cut transparent glass?`,
          A: `No, cutting glass with a CO2 laser may cause it to shatter. Engraving is possible.`,
        },
        {
          Q: `What material thickness can Hurricane engrave?`,
          A: `With the tray and honeycomb board in place, max thickness is 25mm.<br/>

  If removed and the machine is elevated, thickness is theoretically unlimited.<br/>
`,
        },
        {
          Q: `Can Hurricane be expanded to engrave larger materials?`,
          A: `Yes, the R7 conveyor accessory allows a maximum area of 500mm × 800mm.`,
        },
        {
          Q: `Recommended air purifier and fan flange size?`,
          A: `Recommended purifier: AtomStack D4.<br/>

  Fan flange diameter: 75mm.<br/>
`,
        },
        {
          Q: `Fan speed and dust/fume removal efficiency?`,
          A: `Fan speed: 6500 RPM, sufficient to remove internal smoke and dust efficiently.`,
        },
        {
          Q: `Protection level and hazardous gas isolation?`,
          A: `Enclosed design, IEC/EN60825-1 Class 1 certified, effectively isolates toxic gases and fumes when paired with D4 purifier or outdoor venting.<br/>
`,
        },
        {
          Q: `How often to change the water in the tank?`,
          A: `Fill water to MAXIMUM when it reaches MINIMUM.<br/>

  Replace every 200 hours of operation or if water is dirty.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_b634f808-ad89-4ed8-8a0a-e17cdaaae1f2.png?v=1766484100:Fig. 1]`,
        },
        {
          Q: `Recommended operating temperature?`,
          A: `5°C to 35°C.<br/>

  Do not operate under freezing conditions.<br/>
`,
        },
        {
          Q: `Is antifreeze required in cold environments?`,
          A: `Yes, if temperature <5°C, use non-corrosive antifreeze. Mixing ratio:[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_611a7346-0f46-43ad-9401-4435c3e7c032.png?v=1766484307:Fig. 1]`,
        },
        {
          Q: `Can it cut or engrave leather? Recommended settings?`,
          A: `Yes. For 3mm leather, recommended: 80% power, 800mm/min.`,
        },
        {
          Q: `Can it be operated via mobile app?`,
          A: `Yes, via AtomStack APP, available through QR code or AtomStack website.`,
        },
        {
          Q: `Can it engrave cups or stainless steel bottles?`,
          A: `Yes, using R6, R8, or R8 PRO rotary accessories with H3 riser.`,
        },
        {
          Q: `Supported software:`,
          A: `1.AtomStack Studio (PC, free, official library)<br/>

  https://atomstack.com/pages/atomstack-studio-software<br/>

  2.LightBurn (requires baud rate 460800 or config file from USB; paid)<br/>

  3.LaserGRBL (not recommended due to disconnection issues)<br/>

  4.AtomStack APP (mobile, free library)<br/>

  https://atomstack.com/pages/atomstack-studio-software<br/>
`,
        },
        {
          Q: `Air assist and noise levels?`,
          A: `Airflow: ≥30 L/min<br/>

  Environmental noise: 45 dB<br/>

  Machine noise: 66 dB<br/>
`,
        },
        {
          Q: `Are spare parts easy to replace?`,
          A: `Yes, modular design with instructional videos.`,
        },
        {
          Q: `Z-axis maximum travel?`,
          A: `Auto-focus: 40mm<br/>

  Manual: 43mm<br/>
`,
        },
        {
          Q: `Minimum distance to wall with R7 conveyor?`,
          A: `At least 510mm to avoid collision.`,
        },
        {
          Q: `Laser tube lifespan?`,
          A: `10,000 hours, with sufficient water and proper water level maintenance.`,
        },
        {
          Q: `Hurricane advantages over other brands:`,
          A: `High Power: 55W CO2 laser, 10.6μm, cuts/engraves acrylic, glass, stainless steel, wood, leather, etc.<br/>

  Camera Positioning: 5MP full-area visual positioning.<br/>

  Flame Detection: Automatically stops and alarms when fire detected.<br/>

  Active Fire Suppression: Sprays water from user-connected container when fire detected.<br/>

  Rich Accessories: Supports rotary, conveyor (up to 500mm × 800mm).<br/>

  Easy Optical Adjustment: Red-light indicator for safe, accurate alignment.<br/>

  Fast: Up to 600mm/s engraving speed.<br/>

  Power Recovery: Resume work after power loss without losing progress.<br/>

  Temperature Display: Monitors water and machine temperature.<br/>

  Safety Features: Stops when lid opened or drawer pulled; Class 1 laser certified.<br/>

  Status Indicator Lights: Machine status clearly visible.<br/>

  Batch Processing: Engrave all workpieces at once.<br/>

  Software Support: Perfect compatibility with AtomStack Studio, APP, and LightBurn.<br/>
`,
        },
      ],
      // Category 2: Quick Start
      [
        {
          Q: `Hurricane Safety Guidelines`,
          A: `Before operating the Hurricane, ensure you have read and understood all safety instructions and operating procedures. Follow these guidelines to ensure safe and correct usage:<br/>

  Pre-use Check: Inspect the machine for any damage before each use. Do not operate if defects are found. Fill the water tank to the MAX line before powering on. Starting with water below the MIN line may cause the laser tube to explode.<br/>

  Working Environment: Keep the workspace clean and organized.<br/>

  No Modifications: Do not disassemble, modify, or alter the device or its operating system.<br/>

  Monitoring: Always supervise the machine during operation.<br/>

  Cleanliness: Remove debris and residues regularly, as accumulated materials may pose a fire hazard.<br/>

  Operating Temperature: Operate within 5°C to 35°C. Do not use under freezing conditions.<br/>

  Device Integrity: Never operate with any components removed, as this may expose the laser system and increase risk.<br/>

  Material Restrictions: Avoid PVC, vinyl, or chlorine-containing materials, which produce corrosive fumes and can damage the device. Damage caused by such materials is not covered under warranty. Do not cut or engrave unknown materials.<br/>

  Supervision: Never leave the machine unattended. Ensure normal operation at all times.<br/>

  Reflective Materials: Do not process highly reflective materials as they can irreversibly damage the machine.<br/>
`,
        },
        {
          Q: `Hurricane Control Panel Overview`,
          A: `1.Reset/Pause Button: During engraving, click this button to pause the machine. After closing the door, click it again to resume work. When an alarm occurs, clear the alarm first, then press this button to return the machine to normal standby status.<br/>

  2.Auto-Focus Button: After placing the material, press this button to automatically focus on the current material.<br/>

  3.Water Filling Port: Add cooling water to the water tank through this port.<br/>

  4.Emergency Stop Switch: Press in case of emergency to cut off power and stop the machine immediately.<br/>

  5.Key Switch: Insert the key and turn clockwise to power on, turn counterclockwise to turn off the machine.<br/>

  6.Power Switch, Fuse & Power Socket: Controls the machine’s power on/off, fuse, and power cord connection.<br/>

  7.Active Firefighting Water Inlet: Water inlet for the active firefighting function. Users need to provide a water tank for this feature, and connect it using the supplied hose.<br/>

  8.USB Port: For offline operation and firmware upgrades.<br/>

  9.Computer Control Port: Data connection port for computer control, supports TYPE-C cable connection.<br/>

  10.Expansion Accessory Port: Interface for accessories such as chucks, rollers, and conveyor belts, with automatic recognition function.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_82a83de9-bd9a-4d7c-991a-b1fc7bf86755.png?v=1766546333:Fig. 1]`,
        },
        {
          Q: `Unboxing Checklist`,
          A: `Follow the Hurricane unboxing video or manual.<br/>

  Check CO2 tube for damage before powering on (see Fig.1).<br/>

  Fill water tank to MAX; start machine and ensure proper water circulation.<br/>

  Water Type: Use distilled or purified water. Add non-corrosive antifreeze if ambient temperature <5°C.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_4a1cc794-7259-4442-8fd3-ca0dae405cd5.png?v=1766546966:Fig. 1]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_f92b3023-a2ca-4a23-a82c-89a8bce73365.png?v=1766546966:Fig. 2]`,
          video_url: ['https://youtu.be/1wjI3lU64vY'],
        },
        {
          Q: `Connecting to a PC`,
          A: `Use AtomStack Studio for plug-and-play connection.<br/>

  For LightBurn, set baud rate to 460800 or import the configuration file from the included USB drive (see Fig.1).<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_0e393f5a-eed1-4933-a7a7-aaa64168db62.png?v=1766554386:Fig. 1]`,
        },
        {
          Q: `Focus Adjustment`,
          A: `(1) Hurricane can achieve autofocus via the autofocus button on the chassis, by clicking the autofocus button in AtomStack Studio software, or by entering [ESP500] in the code box of LightBurn software. Manual focus can also be achieved using a fixed-focus lens.<br/>

  (2) If the autofocus focal length is not 8mm:<br/>

  If the autofocus focal length is not 8mm, you can adjust the autofocus focal length by modifying the code in LightBurn or LaserGRBL software. The default value for the autofocus parameter is 1.5, and the correction value is 1.5 ± the error value, i.e.: When the actual value is greater than 8mm, the correction value is calculated as: 1.5 - (actual measured value - 8).<br/>

  When the actual value is less than 8mm, the correction value is calculated as: 1.5 + (8 - actual measured value).<br/>

  In LightBurn 【Console】, enter $autoFocus/depth_max_mm = correction value (1.5 ± error value) and press Enter. For example, if the actual focal length of autofocus is 9mm, then the correction value is 1.5-1=0.5.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_ca8cbcff-07b3-4884-8769-19c496539799.png?v=1766554905:Fig. 1]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_fd36403b-7d96-44db-9e98-ccd1b185d209.png?v=1766554907:Fig. 2]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._3_6df70f6e-2456-4acd-b6b4-9c34f1986ad2.png?v=1766554908:Fig. 3]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._4_68aed1c3-d30f-4823-8a59-202b8fe571f3.png?v=1766554905:Fig. 4]`,
          video_url: ['https://youtu.be/2UeKAdzumsU'],
        },
        {
          Q: `Camera Application`,
          A: `Refer to the Hurricane camera application video or instruction manual.<br/>

  Note:<br/>

  (1) Absolute coordinates must be used when using the camera.<br/>

  (2) Calibration is required before use, and recalibration is required after changing materials of inconsistent thickness.<br/>

  (3) When calibrating the camera, ensure sufficient lighting inside the chamber so that the camera can clearly capture the working interface inside the chamber.<br/>

  (4) The camera and conveyor belt cannot be used simultaneously.<br/>

  (5) When calibrating using LightBurn software, zoom in on the image before clicking on any of the four points to improve accuracy.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_e5fe479b-df03-401d-a41d-f2c85dee442e.png?v=1766555325:Fig. 1]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_ddc4a41e-1c66-463a-908a-ca35d407ef3a.png?v=1766555326:Fig. 2]`,
          video_url: ['https://youtu.be/dMK7afokbNM'],
        },
        {
          Q: `Conveyor Accessory (R7)`,
          A: `Refer to the Hurricane conveyor belt application video or instruction manual.<br/>

  Note:<br/>

  (1) The Hurricane conveyor belt has an automatic recognition function; simply insert the included USB cable.<br/>

  (2) Absolute coordinates cannot be used when using the conveyor belt.<br/>

  (3) The engraving area becomes 500mm*800mm after using the conveyor belt.<br/>

  (4) The AtomStack conveyor belt model is R7.<br/>

  (5) An H3 riser platform (the base of the machine in the video) is required when using the conveyor belt.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_75293a6f-c693-4cd1-8a23-ebfe32df71a8.png?v=1766555862:Fig. 1]`,
          video_url: ['https://youtu.be/gbH-Sz8lMsk'],
        },
        {
          Q: `Rotary Accessories (R6/R8/R8 Pro)`,
          A: `Refer to the Hurricane rotating accessory usage video or instruction manual.<br/>

  Note: <br/>

  (1) Hurricane's rotating accessories all have an automatic recognition function; simply insert the included USB cable to use. Models are R6, R8, and R8 Pro.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_c90267ed-5793-414c-9f24-e744fbc1f1b7.png?v=1766557618:Fig. 1]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_fb5a1f94-b202-46c0-a70c-d23a31c71213.png?v=1766557616:Fig. 2]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._3_de0689b5-5b1f-4cac-8628-575380544619.png?v=1766557616:Fig. 3]
  (2) Absolute coordinates cannot be used when using rotating accessories.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._4_499311c9-6b56-40bb-b6aa-dd3edaba24e7.png?v=1766557616:Fig. 4]
  (3) An H3 riser is required when using rotating accessories.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._5_185f15e3-04a7-423f-9f11-1841521db604.png?v=1766557618:Fig. 5]
  (4) When using AtomStack Studio software, no parameter settings are required for the roller (R6), but the chuck (R8) requires setting the material's circumference or diameter.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._6_b23780f7-5d7a-403a-95ad-627a79d52dd2.png?v=1766557618:Fig. 6]
  (5)When using LightBurn software, rotation parameter settings are required. Select the rotation type (roller type for R6, chuck type for R8), select the Y-axis for the rotation axis, and set the parameters. For R8, set the rotation speed to 160 mm/revolution (fixed value), and enter either the material's diameter or circumference. For R6, set the rotation speed to 50 mm/revolution (fixed value), the rotation diameter to 16 mm (fixed value), and enter either the material's diameter or circumference.<br/>

  `,
          video_url: ['https://youtu.be/za1Ponzv68c'],
        },
        {
          Q: `Software Coordinates`,
          A: `Current Position: The starting point for engraving is the location of the laser. You can freely move the laser to the desired engraving position by hand.<br/>

  User Origin: The user sets the starting position for the laser. Refer to the origin setting video.<br/>

  Absolute Coords: The starting point is at coordinates 0,0.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_5ff443a4-41fe-4352-883b-3b3c5075a7ee.png?v=1766557941:Fig. 1]`,
        },
        {
          Q: `Active Fire Suppression`,
          A: `(1) The user needs to provide their own fire-fighting water tank, which should be connected to the active fire-fighting water inlet plug on the back of the unit via the supplied hose, as indicated by port "7" on the panel<br/>

  (2) The automatic fire-fighting function must be activated.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_b80bf7df-a8e8-4b1a-a2c5-ff25bb546025.png?v=1766558175:Fig. 1]`,
          video_url: ['https://youtu.be/4cdtLDQ9W8w'],
        },
        {
          Q: `Optical Path Verification & Adjustment`,
          A: `(1) Optical path calibration should begin with the two-mirror setup, then move to the three-mirror setup, and finally to the focusing assembly.<br/>

  (2) When moving the mirror up, down, left, or right, the red dot position should not shift significantly.<br/>

  (3) An error of ≤2mm between the red dot and the laser dot on the engraved material surface is considered normal.<br/>

  (4) When adjusting the two-mirror setup, the three-mirror setup should be moved from left to right.<br/>

  (5) When adjusting the three-mirror setup, you can first slightly tighten one screw, then adjust the angle, and finally tighten the screw.<br/>

  (6) After adjusting the optical path, remove the tools (reflectors) used for adjusting the optical path to avoid burning them.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_e32f5892-fa4b-4786-ae47-af28019cf696.png?v=1766558853:Fig. 1]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_9cdc7b5d-219d-4485-bb2d-d03247f3e7d4.png?v=1766558852:Fig. 2]`,
          video_url: ['https://youtu.be/JiPonHiwV8o'],
        },
        {
          Q: `Software Engraving Test`,
          A: `Available in AtomStack Studio or licensed LightBurn (v1.3.01+).`,
          video_url: ['https://youtu.be/sUPmUo3cLwE '],
        },
        {
          Q: `Software, Firmware & APP Updates`,
          A: `AtomStack Studio: Auto-update or check under “Settings → Check for Updates.”<br/>

  Firmware: Update via Studio, APP, or USB with Serial Number info (Fig.1).<br/>

  APP: Download from AtomStack website or check in-app under Settings → About → Update.Download address: https://atomstack.com/pages/atomstack-studio-software<br/>
`,
          video_url: ['https://youtu.be/eLppYJ8egPc'],
        },
      ],
      // Category 3: Maintenance & Care
      [
        {
          Q: `How to Clean the Hurricane Mirrors and Focusing Lens`,
          A: `Refer to the Hurricane mirror and focusing lens cleaning video.<br/>

  Note: Cleaning Method: Disconnect the power supply. Use 99% pure anhydrous ethanol or a professional optical lens cleaner (avoid solvents containing ammonia or acetone). When wiping, use a lint-free cloth to gently wipe in one direction (e.g., wipe in a spiral motion from the center outwards) to avoid scratching from back-and-forth friction.<br/>

  Cleaning Frequency: For users with high usage frequency, it is recommended to clean weekly; for users with low usage frequency, clean monthly.<br/>

  Caution: If the lens coating peels off (appearing purple/gold patches), it must be replaced immediately and not used further.<br/>
`,
          video_url: ['https://youtu.be/hahm4Ierh78'],
        },
        {
          Q: `How to Clean and Maintain the Hurricane Enclosure`,
          A: `Refer to the Hurricane model cleaning and maintenance video.<br/>

  Note: Cleaning Method: Disconnect the power supply. Use 99% pure anhydrous ethanol as the cleaning agent. Use a lint-free cloth dampened with the cleaning agent to wipe away dust inside the chassis, including the fans, X-axis and Y-axis rails, air vents, etc.<br/>

  Cleaning Frequency: Users with high usage frequency are advised to clean weekly, while users with low usage frequency should clean monthly.<br/>
`,
          video_url: ['https://youtu.be/bgNd-1hbwBg'],
        },
        {
          Q: `How to Store and Maintain the Hurricane When Not in Use`,
          A: `When not in use for an extended period, please drain the cooling water from the tank according to the Hurricane drainage tutorial video to prevent the tank from becoming damp or causing other unexpected problems.<br/>

  Store in a dry location. Avoid placing the equipment in a humid environment for extended periods. Power on the engraving machine periodically. It is recommended to run the fan for 10 minutes weekly to prevent bearing corrosion.<br/>
`,
          video_url: ['https://youtu.be/b8x8nefCwis'],
        },
        {
          Q: `How to Troubleshoot No Response After Powering On the Hurricane`,
          A: `Check whether the power indicator light turns on:<br/>

  If the indicator light turns on but there is no buzzer sound and the fan does not rotate, the issue may be a 24V power supply failure.<br/>

  If the indicator light does not turn on after powering on, continue with the checks below.<br/>

  Check the power cable connection:<br/>

  Ensure the power cable is firmly plugged in and that the power strip or outlet is supplying power normally.<br/>

  Check the key switch:<br/>

  Confirm that the key switch is turned on and fully rotated into position. Turn the key back and forth several times to check for poor contact or incomplete rotation.<br/>

  If poor contact is found, the key switch needs to be replaced.<br/>

  Check the emergency stop switch:<br/>

  Press down the emergency stop switch and rotate it in the indicated direction. After releasing it, confirm that it automatically pops back up.<br/>

  If it does not pop up, the emergency stop switch is faulty.<br/>

  Check whether the fuse is blown:<br/>

  Open the fuse holder cover and check whether the fuse is intact.<br/>

  (You may also use a multimeter in diode/continuity mode to test the fuse.)<br/>
`,
          video_url: [
            'https://youtu.be/1LsPjzYvUYI',
            'https://youtu.be/zqpqJSsSKz0',
            'https://youtu.be/54GP6qpWLgQ',
            'https://youtu.be/N0VegXMuonM ',
          ],
        },
        {
          Q: `How to Troubleshoot Hurricane Connection Issues`,
          A: `(1) Confirm baud rate: Hurricane's baud rate is 460800. If using AtomStack Studio, no setting is needed; if using LightBurn or LaserGRBL (not recommended), the baud rate needs to be changed. If LightBurn cannot display the baud rate, please import the LightBurn configuration file provided with the machine's USB flash drive into the software. Refer to the LightBurn configuration file import video.<br/>

          [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_f6eafd18-a167-4a20-b336-3118a5e1dfd1.png?v=1766561698:Fig. 1]
          (2) Confirm correct TYPE-C cable connection: Please insert into the correct port. If using a MAC system, note that you cannot directly insert into the C port of the TYPE-C cable; you need to use a docking station to connect to the A port of the TYPE-C cable.<br/>

          [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_2e046248-d3e4-4ecc-b797-f8e8d6c3ebbe.png?v=1766561699:Fig. 2]
          [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._3_70674c57-ab89-417e-86f3-dbf74d06fd73.png?v=1766561700:Fig. 3]
  (3) Confirm serial port is occupied: Check if other software is already connected to Hurricane.<br/>

  (4) Confirm serial port is recognized: Open "My Computer—Manage—Device Manager" and check if there is a serial port like CH340. If not, please install the serial port driver first. Please contact customer service for the driver; refer to the serial port driver installation video. (5) Confirm the Type-C cable is not damaged: Try replacing it with another Type-C cable that supports communication. If the replacement works, the Type-C cable is faulty.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._4_c1813658-ce52-4d90-a6a4-46479a4c8f4e.png?v=1766561699:Fig. 4]
  (6) Confirm the computer is not disabled: Try connecting to the internet on another computer. If the other computer can connect, the original computer may have some functions disabled. It is recommended to install a professional operating system or contact computer customer service for assistance.<br/>

  (7) If the above methods do not solve the problem, please provide the machine's serial number to customer service for assistance.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._5_9cd9185a-ff18-4782-a135-94c95ae5e9ab.png?v=1766561700:Fig. 5]`,
          video_url: ['https://youtu.be/nRU4EVwlIEY '],
        },
        {
          Q: ` How to Troubleshoot an Unusable Hurricane Camera`,
          A: `(1) Unrecognized:<br/>

  ① Confirm computer access to the camera: Open "Settings - Privacy - Camera - Enable Allow Apps to Access Camera",<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_22770f59-3684-4278-bc83-6b1e4a9c1886.png?v=1766562690:Fig. 1]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_f86e8682-20ca-4149-ba83-b97745df96f2.png?v=1766562692:Fig. 2]
  ② Confirm computer's built-in video software can open: Open the built-in Camera software, select Switch Camera - USB Camera. If it outputs images normally, it's because the computer itself has disabled the camera. It's recommended to contact customer service for the software. If it cannot be used or recognized, troubleshoot using the following steps.<br/>

  ③ Confirm TYPE-C cable is plugged in: After shutting down, unplug the TYPE-C cable, close the software, plug it back in, and reconnect.<br/>

  ④ Confirm driver is working correctly: Reinstall the serial port driver. Download the driver or contact customer service for a copy. Refer to the serial port driver installation video. Driver download links:<br/>

  -Windows driver download link: https://asa.atomstack.com/downloadWindowsDrivers.do3<br/>

  -Mac driver download link: https://asa.atomstack.com/downloadMacDrivers.do3<br/>

  ⑤ Confirm camera cable connection is normal: Open the cover at the camera and check the glue at the motherboard cable connection to see if it is loose or not glued. Open the cover at the upper left corner of the model to check if the cable connection is loose or detached.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._3_42c2d9ee-b590-4d1f-9587-5bed5bce57f5.png?v=1766562692:Fig. 3]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._4_b4f6914d-8f74-4688-847a-7184d8fed7f1.png?v=1766562693:Fig. 4]
  ⑥ If the above cannot solve the problem, it may be a motherboard or camera malfunction. Please record the troubleshooting steps as a video and take a photo of the machine's Serial Number and send it to customer service. Refer to Hurricane motherboard replacement video and Hurricane camera replacement video.<br/>


  (2) Unable to calibrate:<br/>

  ① Confirm that absolute coordinates are being used: Absolute coordinates must be set when using the camera.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._5_2a96b9db-5d9e-423c-a0a6-b2769e60eb95.png?v=1766562691:Fig. 5]
  ② Confirm that the light inside the box is bright: If the light inside the box is too dim, the camera cannot be recognized, especially when using LightBurn software for calibration. ③ Confirm the camera can output images normally: Open the system's built-in Camera software, select Switch Camera - USB Camera. If it outputs images normally, the problem is caused by your computer disabling the camera. We recommend contacting customer service for the software. If it cannot be used or recognized, follow the steps in point one, "Unrecognized".<br/>

  ④ Confirm software version: When using AtomStack Studio, please update to the latest version.<br/>

  ⑤ Confirm other software compatibility: Try different software to determine if it's a software bug. You can try connecting using AtomStack Studio or LightBurn.<br/>

  ⑥ If the above does not resolve the issue, please contact customer service and provide a screenshot of the Hurricane Serial Number.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._6_56cbe5ba-f9ba-4e68-88e3-823c9f09ecaa.png?v=1766562694:Fig. 6]`,
          video_url: ['https://youtu.be/_RqKuKrk7bU', 'https://youtu.be/UHzgZq9CDHI'],
        },
        {
          Q: `How to Troubleshoot Significant Camera Positioning Accuracy Errors on the Hurricane`,
          A: `(1) Ensure absolute coordinates are used: Absolute coordinates must be used when using the camera.<br/>

  (2) Calibration environment requirements: During calibration, ensure adequate indoor lighting, that the cabinet lights are functioning properly, and that the camera can clearly capture the working interface.<br/>

  (3) Ensure the engraving material thickness matches the calibration thickness: If the material thickness differs, recalibration is required.<br/>

  (4) Ensure the location is not at the edge of the cabinet: After camera calibration, accuracy is higher closer to the center point; accuracy is relatively lower at the edge.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_8e4a361b-f280-4b9f-8d1c-bb770da4ab6d.png?v=1766563127:Fig. 1]`,
        },
        {
          Q: `How to Troubleshoot Abnormal Power Issues on the Hurricane When It Cannot Cut Materials`,
          A: `(1) Confirm correct parameter settings: Please refer to the parameter table https://atomstack.com/pages/material-setting for software parameter settings. If using LightBurn, note that the maximum S value of 1000 cannot be modified.<br/>

          [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_50bec36e-5ce9-41f5-9fb8-130d16fa4ad4.png?v=1766563612:Fig. 1]
  (2) Confirm clean reflectors: Check that reflectors 1, 2, and 3 are clean, free of dust and damage. Note that this should be checked after the machine is turned off, as shown in Figure 35. You can refer to the Hurricane optical path verification and adjustment video for reference.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_8a7ab435-180a-4ad7-8049-2e6e36c1f51c.png?v=1766563616:Fig. 2]
  (3) Confirm normal focus: The focal length after autofocus is 8mm. Refocusing is required after changing materials.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._3_dd438041-0674-43fd-845d-c6d28e770ce6.png?v=1766563616:Fig. 3]
  (4) Confirm the honeycomb panel is placed flat: Confirm that the honeycomb panel is placed flat and free of foreign objects, ensuring that the material is level when placed on it.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._4_8f285c6c-c7fb-4fd8-afec-b7fad625b1c7.png?v=1766563616:Fig. 4]
  (5) Confirm the air nozzle outlet is clean: The air outlet is easily clogged by dirt, affecting power. Please clean it frequently.<br/>

  (6) Confirm the optical path is normal: Please refer to the "Hurricane Optical Path Verification and Adjustment" section. <br/>

  (7) Confirm usage time: CO2 laser tubes will experience normal power attenuation with prolonged use. Please increase the power or decrease the speed to complete the task.<br/>

  (8) If the above steps do not resolve the issue, it may be a laser tube malfunction. Please record the above troubleshooting steps as a video and send a photo of the Serial Number to customer service. If replacement is deemed necessary, please refer to the Hurricane laser tube replacement video.<br/>

  `,
          video_url: ['https://youtu.be/DgAUnWvRwb4', 'https://youtu.be/JiPonHiwV8o '],
        },
        {
          Q: `How to Troubleshoot Image Distortion During Hurricane Engraving`,
          A: `(1) Confirm the material did not move during engraving: Thin materials may be blown by the exhaust fan or air assist in the chamber, causing image distortion.<br/>

  (2) Confirm the software speed settings are appropriate: If the speed is too high, abnormal movement may occur, leading to image distortion. Please use the parameter table as a reference setting.<br/>

  (3) Confirm the X-axis and Y-axis dual-axis cores are free of dirt and damage: Carefully observe the guide rails and dual-axis cores to confirm there are no dirt, damage, or other abnormalities. <br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_9a0aa568-44f6-4369-9493-4f6f0567e85c.png?v=1766565332:Fig. 1]
  (4) Confirm that the X-axis and Y-axis timing belts are not loose or damaged: Carefully check whether the timing belts are too loose, too tight, or damaged. If any are broken or damaged, they need to be replaced. Please send a clear photo of the damage and the Serial Number to customer service. Refer to the Hurricane timing belt replacement video for replacement instructions.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_58a63e06-059f-430e-932d-67ffa3c7012b.png?v=1766565328:Fig. 2]
  (5) Confirm that the X-axis and lower crossbeam are parallel: If the straight line is only slightly skewed without ripples or bends, mainly check whether the X-axis and lower crossbeam are on parallel lines. If they are not on parallel lines, the X-axis needs to be adjusted to be parallel. Please refer to the Hurricane structural adjustment video.<br/>

  (6) Confirm that the step size has been modified: Check the values ​​of $100 and $101 in the machine settings through LightBurn or LaserGRBL to see if they are 100. Note that for older models before January 9, 2025 (serial number preceded by 20250109V), the step size is 133.33. If you cannot distinguish between them, please provide the Serial Number from the chassis to customer service for confirmation.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._3_2c94208e-b163-4451-9430-53a3a19415c8.png?v=1766565328:Fig. 3]
  (7) Check if the screws on the X-axis and Y-axis motor synchronizer pulleys are loose: Use an L1.5 wrench to check if the fixing screws on the X-axis and Y-axis motor synchronizer pulleys are loose. If loose, tighten them. Note: Checking the X-axis motor synchronizer pulley requires disassembling the motor. Please refer to the Hurricane motor synchronizer pulley screw inspection and adjustment video.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._4_4ef93e0f-8e67-45e8-a3e6-c521b8cb2c1b.png?v=1766565332:Fig. 4]
  (8) Check if the machine firmware parameters have been modified: Check if the parameters have been modified in Machine Settings. If so, please revert or upgrade the firmware. You can also provide the current firmware version and Serial Number photo to customer service for confirmation and request the corresponding firmware. Alternatively, you can upgrade through AtomStack Studio and the AtomStack APP. For upgrade instructions, please refer to the software, firmware, and APP update tutorial videos.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._5_41b769a0-efe2-4bc8-bb48-0683201c70b7.png?v=1766565328:Fig. 5]
  (9) If the above methods do not solve the problem, it may be a motherboard malfunction. Please record a video of the troubleshooting steps and provide a photo of the Serial Number to customer service for processing. For motherboard replacement, refer to the Hurricane motherboard replacement video.<br/>

  `,
          video_url: [
            'https://youtu.be/_RqKuKrk7bU',
            'https://youtu.be/eLppYJ8egPc',
            'https://youtu.be/EnEi4nS6L7k',
            'https://youtu.be/MA4aSJu5edI',
          ],
        },
        {
          Q: `How to Troubleshoot Incomplete or Unclosed Engraving Lines on the Hurricane`,
          A: `(1) Confirm laser focal length: After changing to a different material thickness, refocusing is required. Press the autofocus button to complete this. Alternatively, manually measure the distance from the laser output port to the material to ensure it is 8mm.<br/>

    [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_2e0afe9c-0402-4dfc-bfaa-73ff92dcdd2d.png?v=1766566140:Fig. 1]
          
    (2) Confirm software power settings: If the engraving power setting is too low, increase the power or decrease the engraving speed.<br/>

    (3) Confirm constant power is enabled: AtomStack Studio, LightBurn.<br/>

    [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._3_2956f96d-4cb4-45bb-98bd-b19c4f1a10a6.png?v=1766566140:Fig. 3]
    [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_bd5fe672-9ca2-43ad-8468-636555f4eacc.png?v=1766566140:Fig. 2]
  (4) Modify minimum energy value: If constant power does not solve the problem, open the machine settings in LightBurn or LaserGRBL software, select $31, and modify its value, increasing it until the lines are closed. Note that if enabling constant power solves the problem, do not modify the $31 value.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._4_74235a4f-8157-416b-9ab9-daec9d458a69.png?v=1766566140:Fig. 4]`,
        },
        {
          Q: `How to Troubleshoot a Failed Reset on the Hurricane`,
          A: `(1) Confirm software prompts: If there is a prompt indicating maximum travel has been reached, the X-axis or Y-axis limit switch is faulty. Press the limit switch manually to see if it emits a beep to trigger a prompt. If there is no prompt, the limit switch is faulty; if there is a prompt, it is normal. Refer to the Hurricane limit switch replacement video. 
          [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_30863aa4-6e6e-4a08-bf48-ca2b79352b0f.png?v=1766566480:Fig. 1]
  (2) Confirm if a rotary device is used: If a rotary device is inserted, the reset will fail because it has no limit switch.
  (3) Confirm normal X-axis and Y-axis movement: Observe whether the X-axis and Y-axis can move during reset and return to their original positions. If the movement is abnormal, please check if the motor wiring is properly connected and if the step size has been modified. If the problem persists, please provide a fault video, software error message, and a photo of the Serial Number to customer service for assistance.
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_c70bfbb4-8357-4163-8344-52ebca212b91.png?v=1766566480:Fig. 2]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._3_f6cf1289-81cb-40a3-a326-edec414b7088.png?v=1766566479:Fig. 3]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._4_44689347-6608-41b1-8d7c-d892ba565e8c.png?v=1766566479:Fig. 4]`,
          video_url: ['https://youtu.be/Fz5ohRUYpd0 '],
        },
        {
          Q: `How to Troubleshoot the Hurricane Stopping During Engraving with a Red Panel Indicator Light`,
          A: `(1) Software prompts:<br/>

  ① Prompt for disconnection: Confirm if the TYPE-C cable is touched, if the mains voltage fluctuates excessively, try a different computer USB port, or try AtomStack Studio or LightBurn software. If none of these solutions work, try replacing the motherboard. For replacement instructions, please refer to the Hurricane motherboard replacement video.<br/>

  ② Prompt ALARM 1: Alarm 1 indicates that the limit switch has been triggered. Check if the size of the engraving file exceeds the engraving area and if there are other files outside the engraving area. If using AtomStack Studio software, it will directly indicate which axis triggered the alarm. If using LightBurn software, enter "?" after the alarm message to find out which axis's limit switch was triggered. Combine the alarm information with the machine's movement status to determine if the limit switch is the cause.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_6dbeda46-6ea6-455c-8f6d-884b15d23005.png?v=1766566755:Fig. 1]
  ③ ALARM 12: Flame alarm. Check if the engraving material is MDF or balsa wood, and whether there is smoke or fire. If it is not MDF, balsa wood, or similar materials, and there is no smoke or fire, it may be a false alarm. Refer to the solution in the section "Hurricane flame detection function is too sensitive, frequently triggering alarms even without fire."<br/>

  ③ Alarm 13: Door opening alarm. Check if the door is open or if the limit switch is malfunctioning (observe the door light strip color; if it's bright red, it's an alarm state. After opening the door, press both door limit switches and check if the door light strip returns to normal blue). Refer to the solution in the section "Hurricane door opening detection function failure, carving will not be interrupted when the door is open".<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_5bbaaee3-a837-4613-b1c2-87a150be0957.png?v=1766566755:Fig. 2]
  ③ Abnormal water temperature: Check if the water temperature is too low or too high (an alarm message will pop up and the door light strip will turn red). If it's too low, increase the indoor temperature; if it's too high, add water and lower the indoor temperature.<br/>


  (2) No software prompt: Unplug and replug the TYPE-C cable or replace the TYPE-C cable, try replacing the AtomStack Studio or LightBurn software, or try a different computer USB port. If the problem persists, re-flash the firmware (note that the same firmware cannot be flashed repeatedly; different versions of firmware are required; contact customer service for assistance). If the same fault still occurs, the motherboard is faulty and needs to be replaced. <br/>

  `,
          video_url: ['https://youtu.be/_RqKuKrk7bU'],
        },
        {
          Q: `How to Troubleshoot When the Hurricane Does Not Respond After Clicking "Start Engraving" in the Software`,
          A: `(1) Confirm all operations are normal: First check if the TYPE-C cable is connected correctly and if the door is closed properly.<br/>

  (2) Check for software prompts: First observe if the software has any relevant prompts. If there are prompts, troubleshoot according to the prompts, referring to the section "Possible Hurricane Error Codes and Handling Methods". If there are no prompts, restart the Hurricane power supply, restart the software, and reconnect.<br/>

  (3) Confirm other software is working properly: Try AtomStack Studio or LightBurn software. If neither software works properly, try changing the TYPE-C cable, changing the USB interface, or updating the driver.<br/>

  (4) If the above does not solve the problem, try flashing the firmware. Refer to the software, firmware, and APP update tutorial videos (note that the same firmware cannot be flashed repeatedly; please provide the current firmware version information to customer service). If reflashing the firmware also does not solve the problem, replace the motherboard. Please provide the engraving machine's Serial Number to customer service for processing.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_19e97e20-1e56-430f-9279-43e6cf4323df.png?v=1766567510:Fig. 1]`,
        },
        {
          Q: `How to Troubleshoot When the Laser Tube Does Not Emit Light During Hurricane Engraving`,
          A: `(1) Confirm that the laser tube is not damaged: Disconnect the power supply, remove the back cover, and carefully observe whether the laser tube is damaged and whether the internal water flow is normal (note that there is high-voltage current on the laser tube side, please do not touch it while the power is on). If there is damage, please provide clear photos of the damage and the serial number to customer service. Refer to the Hurricane laser tube replacement video for checking and replacing the laser tube.<br/>

  (2) Confirm that the positive and negative electrode wires of the laser tube are not loose or disconnected: After checking for damage, check the connecting wires on the laser tube. If they are loose or disconnected, please tighten the screws.<br/>

  (3) Confirm the laser power supply terminals: Disconnect the power supply, open the right side panel and the upper right cover, and check whether the laser power supply terminals are loose. Reconnect the power to the machine. The normal power supply status is as follows: In standby mode, the WF indicator light is yellow, and the TL light is off; in the light-emitting state, the WF light is yellow and the TL light is green. If the indicator light is abnormal, the laser power supply needs to be replaced. Refer to the Hurricane power supply replacement video.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_19e97e20-1e56-430f-9279-43e6cf4323df.png?v=1766567510:Fig. 1]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_c4d8cf34-aad0-4c4f-9d01-b3d2cb2e07b1.png?v=1766567510:Fig. 2]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._3_91489143-372c-49f1-9b95-c1291e37e40d.png?v=1766567510:Fig. 3]`,
          video_url: ['https://youtu.be/DgAUnWvRwb4', 'https://youtu.be/YiustdhrW9I'],
        },
        {
          Q: `How to Troubleshoot Hurricane Automatic Focusing Failures`,
          A: `(1) Confirm that the material has been placed: If no material is placed, the trigger rod may be inserted into the gap of the honeycomb board, preventing the lower limit switch from being triggered, resulting in focusing failure.<br/>

          (2) Confirm the correct firmware version: Check the firmware version through the AtomStack Studio software or mobile APP.<br/>

          [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_e5a1fd06-3578-4a94-b80a-f60e1086cc96.png?v=1766568031:Fig. 1]
  (3) Confirm that the automatic focusing function is enabled: Check whether the automatic focusing function is enabled in the AtomStack Studio software or mobile APP, as shown in Figure 57 (Atuto Focus).<br/>

  (4) Confirm and check whether the wires at the Z-axis adapter board are properly connected or broken: Carefully check the Z-axis connecting wires. If they are loose or disconnected, plug them back in. If they are broken, please provide clear photos of the broken part and the serial number to customer service for processing.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_d24740ed-e8a0-4fd0-b6e6-e32b601585a5.png?v=1766568034:Fig. 2]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._3_bd9adfc2-1a2c-4eab-ac2a-1fe54ffa654a.png?v=1766568033:Fig. 3]
  (5) Verify that the Z-axis limit switch or wiring is functioning correctly: First, carefully check that the wiring is not loose or broken. In standby mode, press the limit switch in the red box to see if it triggers an alarm (including a beeping sound and software prompt). If it doesn't trigger, the limit switch or adapter board may be damaged and needs to be replaced. Refer to the Hurricane limit switch replacement video.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._4_60b2805c-6247-48b9-9430-6881c6d8f3be.png?v=1766568033:Fig. 4]
  (6) Verify that the Z-axis moves up and down correctly when controlled by the software: Use the direction keys in the software (AtomStack Studio, LightBurn) to control the Z-axis movement and check if it operates normally. If it can only move up but not down, or only down but not up, and there is no obstruction during manual adjustment, the mainboard may be faulty and needs to be replaced. Refer to the Hurricane mainboard replacement video.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._5_3fdc47cb-6a20-44f3-98ca-f3155e0cec7d.png?v=1766568030:Fig. 5]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._6_9acfe571-4234-4b33-9ddc-1052714e0f96.png?v=1766568032:Fig. 6]`,
          video_url: ['https://youtu.be/Fz5ohRUYpd0', 'https://youtu.be/_RqKuKrk7bU'],
        },
        {
          Q: `How to Troubleshoot When the Hurricane Automatic Focusing Focal Length Is Not 8mm`,
          A: `(1) Confirm that the automatic focusing touches the material surface: If no material is placed, the trigger rod may not be triggered correctly, leading to focusing errors.<br/>

  (2) Confirm whether modifying the focus correction value solves the problem: If the automatic focusing focal length (Figure 63) is not 8mm, you can adjust the automatic focusing focal length by modifying the code in LightBurn or LaserGRBL software: The default value for the automatic focusing parameter is 1.5, and the correction value is 1.5 ± error value.  The calculation method for the correction value when the actual value is greater than 8mm is: 1.5 - (actual measured value - 8). The calculation method for the correction value when it is less than 8mm is: 1.5 + (8 - actual measured value). In the LightBurn [Console] interface, enter $autoFocus/depth_max_mm=correction value (1.5 ± error value), and then press Enter. For example, if the actual focal length of automatic focusing is 9mm, the correction value is 1.5 - 1 = 0.5. Refer to the "Hurricane Focal Length Adjustment" section.<br/>

  (3) If none of the above solutions resolve the problem, please send the fault video, the image of the modified focus correction value, and the actual focal length value after focusing to customer service.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_fd144ff5-a62b-4e40-a3dc-8432c11d71eb.png?v=1766569681:Fig. 1]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_4cd6f34a-21c6-41d5-82b3-58f32259eadb.png?v=1766569680:Fig. 2]`,
        },
        {
          Q: `How to Troubleshoot When the LED Light Strip Inside the Hurricane Machine Case Is Not Lit`,
          A: `(1) Confirm that the LED light strip's wiring connection is normal: Check if the wiring connection is loose or disconnected. You can try unplugging and replugging it. <br/>

  (2) Verify that the LED strip is receiving power correctly: Disconnect the terminal at the connector, and use a multimeter in DC voltage mode to measure the voltage across the two pins of the connector. The voltage should be between 20V and 25V. If it is 0V or less than 20V, there is a fault in the LED power cable.  Refer to the Hurricane LED power cable replacement video for instructions. If the voltage is normal, the LED strip is faulty and needs to be replaced. Refer to the Hurricane LED strip replacement video.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_35553b89-ef93-41e3-80cd-f4cb705ab4d5.png?v=1766569947:Fig. 1]`,
          video_url: ['https://youtu.be/Ahr0Lsk_ukg', 'https://youtu.be/bpndwH44EI4'],
        },
        {
          Q: `How to Troubleshoot When the RGB LED Strip on the Hurricane Door Handle Is Not Lighting Up`,
          A: `(1) Verify that the RGB LED strip's connector is properly connected: Remove the three screws on the LED cable protection cover and check if the connector is loose or disconnected. Try unplugging and replugging it.<br/>

  (2) Check if any of the RGB LED beads are lighting up: If none of them light up, the power cable may be faulty. Refer to the Hurricane RGB power cable replacement video for instructions. If some of the LED beads light up, the RGB LED strip is faulty and needs to be replaced. Refer to the Hurricane RGB LED strip replacement video.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_1715bacc-e225-473e-886c-126b1a62508d.png?v=1766570170:Fig. 1]`,
          video_url: ['https://youtu.be/4_-PbyT5Y5c'],
        },
        {
          Q: `How to Troubleshoot Smoke Not Being Discharged Properly from the Hurricane Enclosure`,
          A: `Check the purifier working status: If the purifier’s performance is weak, smoke exhaust will be affected. You can remove the exhaust hose and discharge the smoke directly outdoors to check whether the enclosure exhaust is normal. If direct exhaust works properly, the purifier may have insufficient performance or the filter cartridge needs replacement.<br/>

  Check that the enclosure fan is free of dust buildup: Excessive dust accumulation will reduce exhaust efficiency. Please refer to the Hurricane Enclosure Cleaning and Maintenance video to clean the enclosure and fan.<br/>

  If neither direct exhaust nor cleaning resolves the problem, the fan may be faulty. Please provide a clear photo of the Serial Number (see Fig. 1) to customer service, and refer to the Hurricane Enclosure Fan Replacement video.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_7091eef1-66ea-4e70-b361-30b654c625e0.png?v=1766570909:Fig. 1]`,
          video_url: ['https://youtu.be/bgNd-1hbwBg', 'https://youtu.be/vOiSigRbspM '],
        },
        {
          Q: `How to Troubleshoot Hurricane Flame Detection Failures When No Alarm Is Triggered`,
          A: `◆Check that the flame detection function is enabled in the software: In AtomStack Studio software or AtomStack APP, verify whether the “Flame Detection” function is turned on (see Fig. 1).<br/>

  ◆Check the flame detection sensitivity:<br/>

  In AtomStack Studio or AtomStack APP, reselect the flame detection sensitivity level (three levels: Low, Medium, High) as shown in Figure 68. Alternatively, in LightBurn or LaserGRBL, adjust the flame detection sensitivity via the Console command:<br/>

  $fire_alarm/overflow_value=15   // Adjusts the number of triggers exceeding the threshold<br/>

  $fire_alarm/threshold_value=74   // Flame threshold; higher values make triggering harder<br/>

  (see Fig. 2)<br/>

  If lowering the threshold to the minimum does not resolve the issue, the flame detection board may be faulty. Please refer to the Hurricane Flame Detection Board Replacement video for replacement.<br/>

  Note: While these adjustments can be useful, they do not replace careful operation. Always closely monitor the machine during operation; safety should always be your top priority.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_582bf2d4-6ba1-419e-8585-a27a7534c174.png?v=1766571114:Fig. 1]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_60ecaf82-3f61-46ef-847e-529def941c8b.png?v=1766571113:Fig. 2]`,
          video_url: ['https://youtu.be/HbQgo9z7gFI '],
        },
        {
          Q: `How to Troubleshoot Hurricane Flame Detection Being Too Sensitive`,
          A: `◆Confirm that the material is not MDF, balsa, or similar: <br/>

  When engraving or cutting MDF or balsa wood, it is recommended to turn off the flame detection function (see Figure 70). Note: Someone should always monitor the machine to prevent fire hazards.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_9322148c-b704-4730-8618-9391637ab852.png?v=1766571786:Fig. 1]
  ◆Check whether the cutting file lines are very dense:<br/>

  Dense line patterns can easily trigger the flame detection alarm. It is recommended to increase the cutting speed and perform multiple passes.<br/>

  ◆Test other materials to see if alarms are triggered:<br/>

  ①If cutting the same file on plywood does not trigger the flame alarm, you can disable the flame detection function in AtomStack Studio or the APP when cutting the current material (see Fig. 1).<br/>

  Note: Always closely monitor the machine during operation; safety should always be your top priority.<br/>

  ②If alarms are still triggered on plywood, you can reselect the flame detection sensitivity level in AtomStack Studio or the AtomStack APP (see Fig. 1). Alternatively, in LightBurn or LaserGRBL, adjust the flame detection sensitivity via the Console command:<br/>

  $fire_alarm/overflow_value=15  // Adjusts the number of triggers exceeding the threshold<br/>

  $fire_alarm/threshold_value=74 // Flame threshold; higher values make triggering harder(see Fig. 2)<br/>

  Note: While these adjustments can be useful, they do not replace careful operation. Always closely monitor the machine during operation; safety should always be your top priority.<br/>

  Note: Always closely monitor the machine during operation; safety should always be your top priority.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_80b84e9c-4281-4c6a-a96f-4a006ab93db7.png?v=1766571786:Fig. 2]`,
        },
        {
          Q: `How to Troubleshoot Hurricane Automatic Fire Extinguishing Not Activating After a Flame Alarm`,
          A: `◆Confirm that the automatic fire extinguishing function is enabled: In AtomStack Studio software or AtomStack APP, check whether the “Automatic Fire Extinguishing” function is turned on (see Fig. 1).<br/>

  ◆Confirm that an external water tank is connected: The automatic fire extinguishing function requires an external water tank. Connect the supplied hose to the machine’s active fire extinguishing water inlet (see Port No. 7 in the Hurricane Panel Introduction section).<br/>

  ◆If the above steps do not solve the issue, the automatic fire extinguishing pump may be faulty and needs replacement. Please refer to the Hurricane Automatic Fire Extinguishing Pump Replacement video.<br/>

  Note: After the automatic fire extinguishing function is triggered, it is necessary to clean the nozzle and the focusing lens (see Fig. 2). Please refer to the Hurricane Post-Fire-Extinguishing Cleaning video for guidance.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_92e0f268-d019-4373-b6d0-ae14cbe3b1cb.png?v=1766571916:Fig. 1]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_eb50065a-4e2d-4d8f-9f01-bbd16d32ec83.png?v=1766571919:Fig. 2]`,
          video_url: ['https://youtu.be/i_IY9cm-12U', 'https://youtu.be/jrDM2ElT9Rg '],
        },
        {
          Q: `How to Troubleshoot Hurricane Abnormal Water Temperature Alarms`,
          A: `◆Confirm that the software version is the latest: AtomStack Studio should be version 2.1.0.0 or above (see Fig. 1).<br/>

          [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_4774383e-732d-42bf-94ed-a299499199c4.png?v=1766627935:Fig. 1]
  ◆Confirm that the firmware version is correct: Please provide the current firmware version number along with a photo of the Serial Number (see Fig. 2) and send them to customer service for confirmation.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_63e8df21-d49a-4e52-8abf-630af3e8c44e.png?v=1766627936:Fig. 2]
  ◆Confirm that the water level is within the normal range: Check the scale on the water tank (see Fig. 3) to ensure the water level is above the minimum line. If the water level is close to or below the minimum line, refill the water tank.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._3_68703cb5-ca36-4eb7-931f-ab61e68bf953.png?v=1766627936:Fig. 3]
  ◆Confirm the room temperature: It is recommended to operate the device within a temperature range of 5°C to 35°C. Do not operate under freezing conditions.<br/>

  When the working environment temperature is below 5°C, antifreeze must be added to the water tank. Please refer to the section “Should antifreeze be added to the Hurricane water tank when the temperature is below 0°C?”.When the temperature is above 35°C, please cool down the indoor environment.<br/>

  ◆If both the room temperature and water level are normal, the water temperature sensor may be giving a false alarm. To confirm, insert the sensor into ice water and use AtomStack Studio software to monitor the real-time temperature changes. If the sensor is faulty, please refer to the Hurricane Temperature Sensor Replacement video for replacement.<br/>

  `,
          video_url: ['https://youtu.be/elV9U_s_jVk'],
        },
        {
          Q: `How to Troubleshoot Hurricane Lid Opening Detection Failures When Engraving Does Not Stop`,
          A: `◆Confirm that the lid opening detection function is enabled in the software:<br/>

  In LightBurn or LaserGRBL software, enter the following command in the Console:<br/>

  $door/enable=On   // Enable lid opening detection function<br/>

  $door/enable=Off  // Disable lid opening detection function<br/>

  (see Fig. 1).<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_38109a59-aac0-43a0-a239-35d6aaaf8166.png?v=1766628037:Fig. 1]
  ◆Confirm that the lid limit switch cable is properly connected: Carefully check whether the cable connector is loose, disconnected, or damaged. Unplug the terminal and reconnect it to test.<br/>

  ◆Confirm the voltage of the lid limit switch cable: After unplugging the connector, use a multimeter in DC mode to measure the voltage at the socket. The expected voltage should be 3.3V (see Fig. 2).<br/>

  If the voltage is normal (3.3V), the lid limit switch is faulty. If the voltage is 0V, the connection cable is faulty.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_b132e9fa-81d3-4893-9c68-41039dae1dc8.png?v=1766628037:Fig. 2]`,
        },
        {
          Q: `How to Troubleshoot Mirrored Engraving Results When Using the Hurricane Rotary Attachment`,
          A: `◆Confirm whether the engraving pattern itself is mirrored:<br/>

          [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_1a726801-f384-4094-bd4f-590b6c50f053.png?v=1766628537:Fig. 1]
          [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_2e079269-d98c-4b5b-b393-84f3854e338a.png?v=1766628537:Fig. 2]
  If it is mirrored, check the software settings to see whether the Mirror function is enabled. If it is enabled, disable it; if it is disabled, enable it. (AtomStack Studio: see Fig. 1; LightBurn: see Fig. 2).<br/>

  ◆Confirm whether the engraving pattern is reversed:<br/>

  If it is reversed, try enabling Y homing direction invert in the machine settings (see Fig. 3).<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._3_25bf95bf-9e3a-4b9d-b140-40ed6e1a4c1f.png?v=1766628537:Fig. 3]
  ◆If the above steps do not resolve the issue:<br/>

  If none of the above solutions can solve the problem, please upgrade the machine firmware through AtomStack Studio or AtomStack APP. If you cannot click the update button on the software, please provide a photo of the serial number (as shown in Fig.4) to the customer service staff to request the corresponding version of the firmware to be burned into the USB flash drive. For upgrade instructions, please refer to the software, firmware, and APP update tutorial videos.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._4_5e32e00b-17ae-4df9-a864-f5e9d0bf8c46.png?v=1766628537:Fig. 4]`,
          video_url: ['https://youtu.be/eLppYJ8egPc'],
        },
        {
          Q: `How to Troubleshoot Distorted Engraving Results When Using the Hurricane Rotary Attachment`,
          A: `◆Check the motor steps<br/>

  In LightBurn software, go to Edit → Machine Settings → Outputs Setup and check whether the value of $101 is 80 (see Fig. 1).<br/>

  Note: The Hurricane has an automatic detection feature, so normally there is no need to manually adjust the steps.<br/>

  ◆Confirm the object shape:<br/>

  If the material is an irregular circle, cylinder, or curved surface, the output may be distorted. Try engraving a regular-shaped object, such as a thermos, to verify.<br/>

  ◆Check parameter settings:<br/>

  Refer to the “Hurricane Rotary Attachment Application” section for recommended settings.<br/>

  If the above steps do not resolve the issue: The motor may be faulty and need replacement. Refer to the R6/R8/R8 PRO rotary motor replacement video.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_bde951fd-6b9f-465f-b323-a3f149c3cbf1.png?v=1766629378:Fig. 1]`,
          video_url: ['https://youtu.be/05TaEjoKVqM'],
        },
        {
          Q: `How to Troubleshoot When the Hurricane Cannot Recognize a USB Drive`,
          A: `◆Restart the machine:<br/>

  Reinsert the USB drive and restart the machine to try again.<br/>

  ◆Check whether the USB drive is damaged:<br/>

  Insert the USB drive into a computer to see if it can be read normally. If the files can be accessed, the USB drive is not faulty.<br/>

  ◆Ensure the USB drive is inserted into the correct port:<br/>

  Make sure the USB drive is plugged into the USB DRIVE port of the machine. Do not insert it into the USB KEY port.<br/>

  ◆Check whether the USB port is functional:<br/>

  Ensure the USB DRIVE port is intact and undamaged.<br/>

  ◆If all the above checks are normal but the issue persists:<br/>

  The motherboard may need to be replaced. Refer to the Hurricane motherboard replacement video.<br/>
`,
          video_url: ['https://youtu.be/_RqKuKrk7bU'],
        },
        {
          Q: `How to Troubleshoot Hurricane Firmware Upgrade Failures`,
          A: `◆Check the USB drive:<br/>

  Verify on a computer whether the USB drive can be read and written normally. If it cannot, the USB drive is faulty.<br/>

  ◆Check the file location:<br/>

  When copying the firmware, make sure it is placed in the root directory of the USB drive. Do not put it inside any folder.<br/>

  ◆ Upgrade through AtomStack software:<br/>

  please upgrade the machine firmware through AtomStack Studio or AtomStack APP. <br/>

  ◆Check whether the firmware is correct:<br/>

  The firmware file must have a .bin extension. For Hurricane models, depending on the Serial Number:<br/>

  Products with Serial Numbers earlier than 20250224 should use firmware C10-0162.bin.<br/>

  Products with Serial Numbers later than 20250224 should use firmware 16C10-0162.bin.<br/>

  If you are unsure, take a screenshot of the current firmware version (as shown in Fig. 1) and a photo of the Serial Number (as shown in Fig. 2) and send them to customer service for confirmation<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_e2f8ae59-ffa9-4b51-895a-8af64e1e59c8.png?v=1766629574:Fig. 1]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_edb3dbf1-5084-4175-9115-45ea4a835bdc.png?v=1766629573:Fig. 2]
  ◆If all the above steps show no issues:<br/>

  The problem is likely caused by a faulty mainboard. The mainboard needs to be replaced. Please refer to the Hurricane Mainboard Replacement Video.<br/>

  `,
          video_url: ['https://youtu.be/_RqKuKrk7bU', 'https://youtu.be/05TaEjoKVqM'],
        },
        {
          Q: `How to Troubleshoot the Hurricane Lid Not Being Centered (Shifted Left or Right)`,
          A: `◆Check the support rods for abnormalities: Inspect that the support rod screws are intact and not deformed.<br/>

  ◆Confirm support strength: Ensure the distances between the two support rods and the fixing parts are equal. If not, adjust by turning the support rod adjustment blocks as shown in Fig. 1.<br/>

  ◆Check that the acrylic glass on the lid is not skewed: Carefully observe that the acrylic glass aligns with the frame without tilt, as shown in Fig. 2.<br/>

  ◆If all the above are normal: Adjust the angle of the lid hinge to correct the alignment. Please refer to the Hurricane Lid Alignment Adjustment Video.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_39a140f8-5861-47ae-9c74-fa4309732aa5.png?v=1766631498:Fig. 1]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_0efc3a55-ee31-49a1-9d09-15b92ae65aba.png?v=1766631498:Fig. 2]`,
          video_url: ['https://youtu.be/hZj2zjqpmwg'],
        },
        {
          Q: `How to Troubleshoot a Broken Hurricane Lid Support Rod That Cannot Hold the Lid`,
          A: `If the lid support rod is broken and cannot support the lid, it must be replaced. Please provide a video of the malfunction and a photo of the Serial Number on the machine (as shown in Fig. 1) to the customer service team for assistance. Refer to the Hurricane Support Rod Replacement Video for guidance.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_50e747b8-b0e8-45ad-a707-19ccf1e8453e.png?v=1766631598:Fig. 1]`,
          video_url: ['https://youtu.be/gLb0nQ1_PO0'],
        },
        {
          Q: `How to Troubleshoot a Limit Switch Failing to Trigger When the Hurricane Bottom Tray Is Inserted`,
          A: `◆Check the appearance of the machine and tray: Inspect the machine and tray for any slight deformation caused during transport. If deformation is found, provide a photo of the Serial Number and the deformed area to customer service for assistance.<br/>

  ◆Inspect the limit switch: Examine the limit switch at the position shown in Fig. 1 for any visible damage. Press it by hand and temporarily secure it with tape, then reconnect to see if it operates normally. If it works with tape, the tray may not be fully inserted or there may be debris in the tray’s guide slot. Inspect carefully.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_046fec52-5729-4929-bf3e-87aba883ad49.png?v=1766632107:Fig. 1]
  ◆If the machine and tray appear fine but the limit switch still fails to trigger, the tray limit switch may be faulty.<br/>

  You can temporarily disable tray detection in LightBurn by entering command:<br/>

  $drawer_alarm/enable=off，as shown in Fig. 2.(To re-enable, use $drawer_alarm/enable=on).<br/>

  Provide a fault video and a photo of the Serial Number（see Fig. 3）on the machine to customer service for replacement. Refer to the Hurricane Limit Switch Replacement Video for guidance.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_a2d41db2-3c2d-44ae-8f1c-f765fa7a7e49.png?v=1766632106:Fig. 2]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._3_d6f4721e-eabd-4021-9b89-b62ed1cb0afd.png?v=1766632107:Fig. 3]`,
          video_url: ['https://youtu.be/Fz5ohRUYpd0 '],
        },
        {
          Q: `How to Troubleshoot When the Hurricane Lens Holder Cannot Be Tightened`,
          A: `Turn on the power and make sure the red positioning light is working properly. First, place the lens holder in the center of the round hole. Use one hand to hold the lens holder and push it upward so that it fits tightly against the frame, while using the other hand to tighten the lens holder nut. Please make sure to place the colored acrylic focusing plate (small mirror) on top of the lens holder for focusing, and keep the red positioning light spot centered at all times. When it can no longer be tightened by hand, use an open-end wrench to fully secure it. Please refer to the Hurricane lens holder installation video for guidance.<br/>
`,
          video_url: ['https://youtu.be/El7On8F8R_8'],
        },
        {
          Q: `How to Troubleshoot or Prevent the Hurricane Focusing Lens from Getting Dirty Easily`,
          A: `During engraving, please remove the air nozzle at the bottom of the lens holder (as shown in Fig.1). Please note that the air nozzle must be reinstalled when cutting.<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_136c8f54-c999-491b-a02f-2b1f339f1c3b.png?v=1766632537:Fig. 1]`,
        },
        {
          Q: `How to Handle Software Alarm Prompts and Their Solutions`,
          A: `[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_ec81be34-c3be-4e55-ab72-78acbea40aef.png?v=1766632729:Fig. 1]`,
        },
      ],
    ],
  },
  Atelier: {
    nav: [`pre-Sale Questions`, `Quick Start`, `Maintenance & Care`],
    nav_desc: [
      `What You Need to Know Before Buying`,
      `Your First Steps Made Simple(For Beginners) `,
      `Keep Your Machine in Top Shape`,
    ],
    quantions: [
      // 一、Pre-sales
      [
        {
          Q: `What is the engraving area of Atelier?`,
          A: `120 mm × 120 mm. Using the conveyor feeder, the area can be expanded to 350 mm × 120 mm.`,
          video_url: [],
        },
        {
          Q: `Can Atelier engrave metal?`,
          A: `Yes, it can engrave some metals such as stainless steel, iron, and black anodized aluminum.`,
          video_url: [],
        },
        {
          Q: `Can Atelier connect to a computer via WiFi?`,
          A: `Yes. You need to first connect Atelier for network setup using a Type-C cable.`,
          video_url: ['https://youtu.be/oO_HzHC1xNA'],
        },
        {
          Q: `What is the laser power of Atelier, and can it be replaced with another laser?`,
          A: `The standard configuration is a 10W diode laser (wavelength 455±5 nm). Currently, it cannot be used with other lasers.`,
          video_url: [],
        },
        {
          Q: `Can Atelier be used with a rotary device?`,
          A: `Yes. It supports R6, R8, and R8 PRO rotary accessories with auto-recognition.`,
          video_url: ['https://youtu.be/LYz6q0xJR4c'],
        },
        {
          Q: `Can the engraving area of Atelier be expanded?`,
          A: `Yes. Using the R4 conveyor feeder, the engraving area can be expanded to 350 mm × 120 mm.`,
          video_url: [],
        },
        {
          Q: `What software does Atelier use, and can LightBurn be used?`,
          A: `You can use the official AtomStack Studio (PC or mobile) or LightBurn software.<br/>
When using LightBurn, you can import the official configuration file to connect the device.<br/>
Select “L1-GALVO” as the controller (see Figure 12).<br/>
Alternatively, you can connect without importing the configuration file by following the connection steps.<br/>
Refer to the “Atelier Connection Tutorial” section for guidance.<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_12_faff6d50-c475-442d-a83d-84fc7c994c84.png?v=1770862276:Figure 12]`,
          video_url: [],
        },
        {
          Q: `What is the maximum engraving speed of Atelier?`,
          A: `The maximum speed can reach 240,000 mm/min. For actual engraving tasks, please follow the recommended parameters in the parameter table.`,
          video_url: [],
        },
        {
          Q: `Does Atelier have fixtures to secure materials？`,
          A: `Yes. Two positioning strips are provided, which can be secured to the baseplate using screws.<br/>
A roll of masking tape is also included for fixing thin or light materials to the baseplate.`,
          video_url: [],
        },
        {
          Q: `Does Atelier have safety features？`,
          A: `Yes. The machine is equipped with a power switch to turn off the device at any time, and a USB key to prevent unauthorized operation, protecting children or untrained users from accidents.`,
          video_url: [],
        },
        {
          Q: `What is the normal operating temperature of Atelier？`,
          A: `The recommended operating temperature is 0℃ to 35℃.`,
          video_url: [],
        },
        {
          Q: `What is the maximum material height that Atelier can engrave？`,
          A: `The machine can engrave materials up to 105 mm in height inside the enclosure.<br/>
With the baseplate removed, it can theoretically engrave objects of any height.`,
          video_url: [],
        },
        {
          Q: `How should Atelier be stored when not in use？`,
          A: `When the machine will not be used for an extended period, store it in a dry environment.<br/>
It is recommended to power on the machine for 5 minutes each month to maintain the lifespan of the electronic components.`,
          video_url: [],
        },
      ],

      // 二、Quick start
      [
        {
          Q: `Introduction to the Atelier Control Area`,
          A: `[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/1_2148a5b1-c245-4307-b071-410a9f55a9f0.png?v=1770862503:Control Area Image]<br/>
①Frame/Repeat：<br/>
◆ Short Press: Start edge tracing / Stop edge tracing (executes the most recent processing task from the APP).<br/>
◆ Long Press (3 seconds or more): Repeat engraving (executes the most recent processing task from the APP).<br/>
◆ Double Click: Cancel engraving.<br/>
②Start/Pause:<br/>
◆ Short Press: Start engraving / Pause engraving.<br/>
◆ Long Press (3 seconds or more): Enter Wi-Fi setup mode.<br/>
◆ Double Click: Clear fault status.<br/>
③Wi-Fi indicator<br/>
◆ Off: Not connected to the network.<br/>
◆ Flashing White: Wi-Fi configuration in progress.<br/>
◆ Steady Green: Wi-Fi connected.<br/>
④Status Indicator<br/>
◆ Steady White: Powered on, standby.<br/>
◆ Steady Green: Laser operating.<br/>
◆ Flashing Green: Paused.<br/>
◆ Steady Red: Alarm / Fault.<br/>
◆ Steady Blue: Accessory mode.<br/>
⑤ Focus Knob: Adjusts the height of the galvo platform for focusing.<br/>
⑥ Accessory Port: Connects accessories such as rollers or chucks.<br/>
⑦ USB Key: USB key slot. The machine can only start when the USB key is inserted (pre-installed at the factory).<br/>
The laser will not operate without the USB key.<br/>
⑧ Computer: Computer connection port, connects to the PC via a Type-C cable.<br/>
⑨ Power: Power input port.<br/>
⓪ Emergency: Emergency stop / Power on-off.`,
          video_url: [],
        },
        {
          Q: `Atelier Installation`,
          A: `Note:<br/>
◆ Install the exhaust pipe first.<br/>
◆ Install the positioning strip as needed according to usage requirements.`,
          video_url: ['https://youtu.be/ovEHZU1Rdb0'],
        },
        {
          Q: `Atelier Network Connection`,
          A: `Note:<br/>
◆ When using AtomStack Studio on PC or mobile, no additional setup is required;<br/>
the device is ready to use once connected.<br/>
◆ Atelier supports mobile Wi-Fi connection and mobile hotspot connection.<br/>
During file transfer, do not switch the APP to run in the background.<br/>
◆ When using LightBurn software, you must first import the configuration file or set the “Origin” to the top-left corner in “Device Settings.”<br/>
Otherwise, the engraving may appear mirrored (upside down). Make sure the baud rate is set to 460800, as shown in Figure 1.<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_1_e6b79b34-865e-4fc6-bf6c-11a7ea5c2b67.png?v=1770862535:Figure 1]<br/>
<br/>
◆ If the square image border appears curved during framing, recalibration is required.<br/>
Please refer to the Atelier Galvo Calibration Video.<br/>
◆ When engraving thin materials, ensure the object is securely fixed; otherwise, the internal fan may move the material.<br/>
You can use the provided masking tape to secure the edges or the provided positioning strip.<br/>
◆ When engraving edges, do not enable overscan. If a “border exceeded” warning appears when starting, adjust the position or check whether overscan is enabled.<br/>
If engraving results appear distorted or misaligned, also check for the “border exceeded” warning and whether overscan is enabled.`,
          video_url: ['https://youtu.be/zd5E25sBxwQ', 'https://youtu.be/oO_HzHC1xNA'],
        },
        {
          Q: `Atelier Galvo Calibration Tutorial`,
          A: `Note:<br/>
◆ Preparation: Follow the instructions in Chapter 7, Atelier Focus Adjustment Guide, to ensure correct focus and secure the material.<br/>
◆ Calibrating with AtomStack Studio (PC): Click “Settings” → “Calibration” (see Figure 2).<br/>
When setting the X-axis and Y-axis scale factors, first reset the scale factors to 1.000, click “Save Parameter” to save the settings, and then click “Update Data” before performing the calibration.<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_2_706e629a-1c6e-45e4-8ab2-2a3c9af5cdd2.png?v=1770862569:Figure 2]<br/>
<br/>
◆ Scaling: Click “Start”, then measure the actual side length of the engraved square border.<br/>
Enter the measured values into “Size Coefficient Calculation” to calculate the scale factor.<br/>
For example, the default engraving file size is 100 mm × 100 mm, but the actual engraved result is 112 mm × 117 mm.<br/>
After entering the values, the calculated X-axis scale factor is 0.893 (see Figure 3).<br/>
The Y-axis is adjusted in the same way.<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_3_0cde4161-89a1-4026-964c-9b35b8e2baf9.png?v=1770862595:Figure 3]<br/>
<br/>
Note: After entering the calibration data, click “Save Parameter”. If you need to modify the calibration parameters, click “Update Data”.<br/>
After calibration is complete, perform an engraving test and confirm whether the engraved pattern matches the size of the engraving file.<br/>
If the sizes do not match, please check the calibration parameters again.<br/>
◆ Curve: If the border appears curved when clicking “Frame” (see Figure 4), the curve parameter must be adjusted.For example, if the Y-axis curve value is 1.060, enter this value into the Y-axis curve setting.<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_4_cbb5d80f-665c-4839-a275-f161f0bf80dd.png?v=1770862629:Figure 4]`,
          video_url: ['https://youtu.be/JG4nHUhGzj0'],
        },
        {
          Q: `Atelier Rotary Operation Tutorial`,
          A: `Note:<br/>
◆ Rotary Selection:<br/>
①Atelier only has an expansion output port (with auto-recognition), so only R6, R8, and R8 PRO rotary accessories can be used.<br/>
②Threaded risers must be installed (see Figure 5).<br/>
③Use the provided USB cable (see Figure 6) to connect to the machine’s Accessory Port for automatic recognition.<br/>
④Not compatible with R1, R1 Pro, R2, R3 Pro, R1-B, or R2-B rotary accessories.<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_5_dbda708e-9c1e-472b-bb2b-05d1bd9f2dc7.png?v=1770862657:Figure 5]<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_6_9dd10060-f603-4f8b-8078-4ba381db892d.png?v=1770862827:Figure 6]<br/>
<br/>
◆ AtomStack Software settings: When using AtomStack Studio, parameters must be set for the detected device.<br/>
Roller (R6): No parameter setting required.<br/>
Chuck (R8): Set the material’s circumference or diameter (see Figure 7).<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_7_100944dc-d342-486d-ae07-3d46e6aa0f17.png?v=1770862859:Figure 7]<br/>
<br/>
◆ LightBurn Settings: When using LightBurn, rotary parameters need to be configured.<br/>
Rotary Type: Select Roller for R6, Chuck for R8. Rotary Axis: Select the Y-axis.<br/>
Parameter Settings: For R8 (Chuck), set the rotation speed to 160 mm per rotation (fixed).<br/>
Enter either the material diameter or circumference. For R6 (Roller): set the rotation speed to 50 mm per rotation (fixed), rotary diameter to 16 mm (fixed), and enter either the material diameter or circumference.<br/>
(See Figure 8)<br/>
◆ Focus adjustment: After placing the material, refocus is required. For focusing instructions, refer to the “Atelier Focusing” section.<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_8_a2880d6c-f18f-4a3f-93e6-aded2afd7e8b.png?v=1770862884:Figure 8]`,
          video_url: ['https://youtu.be/LYz6q0xJR4c'],
        },
        {
          Q: `Atelier Conveyor Feeder Operation`,
          A: `◆ When using, ensure the USB port of the conveyor feeder faces away from the user (toward the right side of the machine).<br/>
◆ The conveyor feeder must be placed horizontally, with the bottom groove aligned to the Atelier base.<br/>
Secure it with the provided screws to prevent vertical movement. Refer to the R4 manual (see Figure 9).<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_9_a5d0b454-998e-46a0-a152-7c7732a592e8.png?v=1770863006:Figure 9]<br/>
<br/>
◆ AtomStack Studio: The device will be automatically recognized after connection. Click OK to start using (see Figure 10).<br/>
◆ LightBurn: Manually set the engraving machine working size to 350 mm × 120 mm to use the conveyor feeder (see Figure 11).<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_10_b3dc56f8-774a-4b80-8508-480d456d9da1.png?v=1770863036:Figure 10]<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_11_f11923e2-d54b-47ff-93be-3784ae4c094e.png?v=1770863056:Figure 11]`,
          video_url: ['https://youtu.be/rnfUL5g5HSY'],
        },
        {
          Q: `Atelier Focusing`,
          A: `◆ The optimal focus is achieved when the two small red dots coincide (approximately 151 mm).`,
          video_url: ['https://youtu.be/lR7-7GcWdTs'],
        },
        {
          Q: `Software Engraving Parameter Test Tutorial`,
          A: `Note: This function requires a genuine LightBurn software (version 1.3.01 or above) or AtomStack Studio.`,
          video_url: ['https://youtu.be/dDkXqGKlZRM'],
        },
      ],

      // 三、Maintenance&Care
      [
        {
          Q: `Atelier Enclosure Cleaning`,
          A: `◆ Galvo Sealing Glass Cleaning: Use 99% anhydrous ethanol or a professional optical lens cleaner (avoid solvents containing ammonia or acetone).<br/>
Wipe gently in a single direction (e.g., spiral from center outward) using a lint-free cloth to prevent scratches from back-and-forth rubbing.<br/>
After cleaning, inspect the surface under strong light to ensure there are no water marks or fibers remaining.<br/>
High-frequency users: Clean once a week.<br/>
Low-frequency users: Clean once a month.<br/>
◆ Camera Cleaning: Use 99% anhydrous ethanol or a professional optical lens cleaner (avoid solvents containing ammonia or acetone).<br/>
Wipe gently in a single direction (e.g., spiral from center outward) using a lint-free cloth to avoid scratches.<br/>
◆ Frame Cleaning: Use a lint-free cloth with alcohol to wipe off dust from the frame.`,
          video_url: ['https://youtu.be/kSaJD2YV8AU'],
        },
        {
          Q: `Atelier Fan Cleaning`,
          A: `◆ Fan Disassembly: Open the machine door and raise the galvo platform to the highest position.<br/>
Remove the two screws of the fan cover and take off the cover.<br/>
Then remove the four screws securing the fan and take out the fan.<br/>
◆ Fan Cleaning: First, use a brush or similar tool to remove dust from the fan surface.<br/>
Then wipe with alcohol and a lint-free cloth. Do not use corrosive cleaning agents.<br/>
◆ Cleaning Frequency:<br/>
High-frequency users: Clean once a month.<br/>
Low-frequency users: Clean once every three months.`,
          video_url: ['https://youtu.be/hlp5k3olzEQ'],
        },
        {
          Q: `None of the indicator lights turn on after switching on the Atelier power.`,
          A: `Solution:<br/>
◆ Check the adapter output voltage: Use a multimeter to measure whether the power adapter’s output voltage is 24V (see Figure 13).<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure13.png?v=1770863151:Figure 13]<br/>
<br/>
◆ Check the power switch wiring: If the power adapter is functioning normally, open the top cover of the Atelier and check whether the power switch wiring is properly connected (see Figure 14).<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_14.png?v=1770863175:Figure 14]<br/>
<br/>
◆ Check the power switch:<br/>
If the switch wiring is properly connected, unplug the adapter and disconnect the power switch wiring.<br/>
Use a wire to short the switch terminals, then plug the adapter back in to see if the machine powers on.<br/>
If the machine turns on after shorting, the power switch is faulty.<br/>
If the problem persists, it may be a mainboard issue.<br/>
Please provide the device Serial Number (see Figure 15) and a troubleshooting video to customer support for assistance.<br/>
References: Atelier Power Switch Shorting Video<br/>
Atelier Mainboard Replacement Video<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure15.png?v=1770863331:Figure 15]`,
          video_url: ['https://youtu.be/9zmgnkasuN8', 'https://youtu.be/rKdxv6VTsoM'],
        },
        {
          Q: `After turning on the Atelier power switch, the status indicator light turns red.`,
          A: `Solution:<br/>
◆ Confirm that the USB key is inserted: Check whether the USB Key is plugged into the USB Key port on the back of Atelier.<br/>
If it is, gently touch it and check whether it makes a beep sound and the status indicator turns white.<br/>
If normal operation is restored by touching it, gently adjust the USB Key so that it is pressed close to the inner wall of the port.<br/>
If the above measures cannot resolve the poor contact issue, please provide the device Serial Number (as shown in Figure 16) and a fault video, and send them to customer service for further handling.<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_16_ee0ee9e4-766c-42ff-ba9a-0b4dca393b71.png?v=1770863379:Figure 16]<br/>
<br/>
◆ Confirm that the enclosure door is properly closed:<br/>
Open the enclosure door again and then close it, and check whether the status indicator returns to normal.<br/>
You can also turn off the “Door Detection” function in AtomStack Studio (PC version or mobile version), as shown in Figure 17.If the indicator returns to normal after disabling this function, it indicates a failure of the door limit switch (Hall sensor).<br/>
Please provide the device Serial Number and a fault video and send them to customer service for further handling.<br/>
Please refer to the Atelier Hall sensor replacement video.<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_17_bd6bbf03-6e12-4bee-a2d9-16293071c760.png?v=1770863426:Figure 17]<br/>
<br/>
◆ Try reflashing the firmware:<br/>
If there are no abnormalities with the USB dongle or the door limit switch, please provide the device Serial Number to customer service to request the latest Atelier firmware and try updating it to see if the issue can be resolved.<br/>
◆ If the above steps still cannot resolve the issue, replace the mainboard:<br/>
Please provide the device Serial Number, fault video, and the troubleshooting steps you have performed to customer service.<br/>
For replacement, please refer to the Atelier mainboard replacement video.`,
          video_url: ['https://youtu.be/9zmgnkasuN8', 'https://youtu.be/ug5x1HLtO2Q'],
        },
        {
          Q: `Atelier cannot connect to the network.`,
          A: `Solution:<br/>
◆ Check the machine power status:<br/>
-- After power-on, the status indicator lights up white — normal power-on state.<br/>
-- After power-on, the status indicator lights up red — alarm state, troubleshoot according to the section “Status indicator turns red after turning on the Atelier power switch”.<br/>
-- After power-on, the status indicator does not light up — abnormal power-on state, troubleshoot according to the section “Status indicator does not light up after turning on the Atelier power switch”.<br/>
◆ Confirm the baud rate setting:<br/>
When using AtomStack Studio, there is no need to set the baud rate manually.<br/>
When using LightBurn, you need to set the baud rate to 460800 (as shown in Figure 18), or directly import the configuration file in LightBurn.<br/>
Please refer to the guide for importing the Atelier configuration file into LightBurn, and make sure to select the L1-GALVO controller.<br/>
The use of LaserGRBL software is not recommended.<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_18.png?v=1770863476:Figure 18]<br/>
<br/>
◆ Confirm that the computer can recognize the serial port:<br/>
Go to the Device Manager on your computer and check whether the laser engraving machine’s serial port (CH340) appears (you can plug and unplug the Type-C cable to see the serial port appear or disappear).<br/>
If the serial port is not recognized, or if it appears with a warning sign, you can first install the driver.<br/>
The serial port should display as shown in Figure 19.<br/>
For driver installation, refer to the Atelier serial port driver video.<br/>
Driver download link:<br/>
---Windows driver download link:[link:https://asa.atomstack.com/downloadWindowsDrivers.do3]<br/>
---Mac driver download link: [link:https://asa.atomstack.com/downloadMacDrivers.do3]<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_19_56d7291d-5b97-4500-983b-d8c0b15e4be1.png?v=1770863519:Figure 19]<br/>
<br/>
◆ Check for other software occupying the port:<br/>
Check whether any other software is currently connected to the machine’s serial port. If so, please close them.<br/>
◆ Check the operating system:<br/>
On Windows OS, you can connect directly using the Type-C cable.<br/>
On Mac OS, due to serial port access permissions, you need to use a docking station to convert and connect via the A port of the Type-C cable supplied with the machine, as shown in Figure 20. Note that some Type-C cables are for charging only and cannot transmit data.<br/>
On Huawei computers, the C port also requires a docking station for conversion;<br/>
the A port can be connected directly to the engraving machine.<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_20_075f24fe-daf7-4f5e-b87d-545bb350d07a.png?v=1770863545:Figure 20]<br/>
<br/>
◆ Try using different software:<br/>
Try connecting the machine using AtomStack Studio or LightBurn.<br/>
◆ Confirm that the connection cable is functioning properly:<br/>
Try using a Type-C cable that supports data transmission. If the machine can connect after replacing the cable, the issue is with the Type-C cable.<br/>
Please provide a fault video and the device Serial Number (as shown in Figure 21) and send them to customer service for further handling.<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_21_1482627c-639b-4766-9866-027ebfa9014c.png?v=1770863589:Figure 21]<br/>
<br/>
◆ Try using a different computer:<br/>
Try connecting the machine to another computer to see if it can connect normally.<br/>
Note that for Windows 7, try multiple USB ports and ensure that the serial port driver is installed for each port.<br/>
◆ If all the above steps fail, it is considered a mainboard failure:<br/>
Please send the troubleshooting steps, fault video, and device Serial Number to customer service for further handling.<br/>
For replacement, please refer to the Atelier mainboard replacement guide.`,
          video_url: ['https://youtu.be/7ALKWXmGKM0', 'https://youtu.be/E1XWMmM23Eo'],
        },
        {
          Q: `The Atelier focusing lens is dirty or damaged.`,
          A: `Solution:<br/>
When there is a significant drop in power or a large change in the laser spot, the laser lens needs to be checked.<br/>
◆ Dirt/Contamination:<br/>
First, clean the lens using 99% pure anhydrous ethanol or a professional optical lens cleaner (avoid solvents containing ammonia or acetone).<br/>
When wiping, use a lint-free cloth and wipe in a single direction (e.g., from the center outward in a spiral), avoiding back-and-forth rubbing that could scratch the lens.<br/>
After cleaning, inspect the lens under strong side light to ensure no water stains or fibers remain.<br/>
Please refer to the Atelier laser lens cleaning guide.<br/>
◆ Damage:<br/>
If the lens is damaged, the entire laser module must be replaced because it is a sealed structure.<br/>
The probability of the focusing lens being damaged is very low.<br/>
Unless there is a significant change in the laser spot, it is not recommended to disassemble the laser to check the focusing lens.<br/>
Please refer to the Atelier laser replacement guide.`,
          video_url: ['https://youtu.be/qNJhnsqfoPw', 'https://youtu.be/boATg0ZkuuQ'],
        },
        {
          Q: `The Atelier laser cutting capability has significantly decreased.`,
          A: `Solution:<br/>
◆ Normal power attenuation:<br/>
As the laser is used over time, normal power attenuation will occur.<br/>
This can be compensated by increasing the power or reducing the cutting speed.<br/>
◆ Check the fixed focal distance of the laser:<br/>
Refocus the laser using the focusing knob on top of the machine so that the two red dots overlap on the surface of the material.<br/>
The fixed focal height is 151 mm (distance from the galvo platform to the material surface).<br/>
◆ Check parameter settings:<br/>
Confirm whether the parameters are correctly set according to the recommended parameter table.<br/>
Note that the speed unit must be mm/min.<br/>
How to view the Atelier parameter table:<br/>
① Scan the QR code on the machine to view it.<br/>
② Visit the official website: [link:https://atomstack.com/pages/product-support]<br/>
③ Request it from customer service.<br/>
◆ Confirm the S-value max setting in the software:<br/>
If you are using LightBurn, check whether the S-value max has been modified.Make sure it remains at 1000, as this value should not be changed (see Figure 22).<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_22_ed10fad9-0f48-4e40-b7c9-0cc3fbd60912.png?v=1770863633:Figure 22]<br/>
<br/>
◆ Check the sealed glass:<br/>
Check whether the sealed glass at the galvo scanner area is clean, as shown in Figure 23.<br/>
If there are stains, clean it with alcohol and a lint-free cloth.<br/>
Please refer to the “Enclosure Cleaning” section for the correct cleaning method.<br/>
If the glass has stains that cannot be cleaned or if it is damaged, it needs to be replaced.<br/>
Please refer to the Atelier sealed glass replacement guide.<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_23_5eb6993d-a0fd-4e32-88ba-d473b979c1a1.png?v=1770863701:Figure 23]<br/>
<br/>
◆ Test the power adapter output:<br/>
Use a multimeter set to DC mode to measure whether the adapter output is 24V.<br/>
If the output is abnormal, please provide a test video and the device Serial Number and send them to customer service for further handling.<br/>
◆ Test the laser module status:<br/>
Inspect the Laser—Open the top cover of the Atelier. Following the Atelier Laser Lens Cleaning Video, remove the laser, taking care to prevent dust from entering the galvanometer assembly.<br/>
If it does not cut through and there is no visible mark on the back of the plywood, the laser module needs to be checked.<br/>
Open the top cover of the Atelier and remove the laser module according to the Atelier laser lens cleaning video.<br/>
Be careful not to let dust enter the galvo scanner assembly.<br/>
--Check the laser lens:<br/>
Check whether the laser lens is clean.If it is dirty, clean it first using 99% pure anhydrous ethanol or a professional optical lens cleaner (avoid solvents containing ammonia or acetone).<br/>
When wiping, use a lint-free cloth and wipe in a single direction (e.g., spiral from the center outward), avoiding back-and-forth rubbing to prevent scratches.<br/>
After cleaning, inspect the lens under strong side lighting to make sure there is no remaining water stain or fiber.<br/>
If the lens is damaged, the laser module must be replaced.<br/>
Please provide clear photos of the damage and the device Serial Number to customer service.<br/>
--Test the laser spot:<br/>
If the lens is clean, point the laser module toward the ceiling and fire it to check whether the laser spot is diffused or shows other abnormalities.<br/>
If any abnormality is observed, please take clear photos of the laser spot and send them to customer service.<br/>
Please refer to the Atelier laser spot inspection guide.<br/>
◆ If none of the above shows any abnormalities, it is considered a laser module failure:<br/>
Please provide a cutting test video (clearly showing the parameter settings, cutting process, cutting result, and device Serial Number, as shown in Figure 24) and send it to customer service for further handling.<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_24_09418fe9-8822-4d03-8b8d-7459a7ac8dcc.png?v=1770863728:Figure 24]`,
          video_url: [
            'https://youtu.be/qNJhnsqfoPw',
            'https://youtu.be/m1rLu7p973o',
            'https://youtu.be/yE9WElqNGYs',
          ],
        },
        {
          Q: `Poor engraving quality on Atelier.`,
          A: `Solution:<br/>
◆ Check the fixed focal distance of the laser:<br/>
Refocus the laser using the focusing knob on top of the machine so that the two red dots overlap on the surface of the material.<br/>
The fixed focal height is 151 mm (distance from the galvo platform to the material surface).<br/>
◆ Check parameter settings:<br/>
Confirm whether the parameters are correctly set according to the recommended parameter table.<br/>
Note that the speed unit must be mm/min. How to view the Atelier parameter table:<br/>
① Scan the QR code on the machine to view it.<br/>
② Visit the official website: [link:https://atomstack.com/pages/product-support]<br/>
③ Request it from customer service.<br/>
◆ Confirm the S-value max setting in the software:<br/>
If you are using LightBurn, check whether the S-value max has been modified.<br/>
Make sure it remains at 1000, as this value should not be changed (see Figure 25).<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_25_4d2572ca-baa5-46db-94a6-d4e4aa5f5d93.png?v=1770863756:Figure 25]<br/>
<br/>
◆ Normal power attenuation:<br/>
As the laser is used over time, normal power attenuation will occur.<br/>
This can be compensated by increasing the power or reducing the cutting speed.<br/>
◆ Check the sealed glass:<br/>
Check whether the sealed glass at the galvo scanner area is clean, as shown in Figure 26.<br/>
If there are stains, clean it with alcohol and a lint-free cloth.<br/>
Please refer to the “Enclosure Cleaning” section for the correct cleaning method.<br/>
If the glass has stains that cannot be cleaned or if it is damaged, it needs to be replaced.<br/>
Please refer to the Atelier sealed glass replacement guide.<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_26_b865dc27-6950-40c7-b94d-413f3d0656f7.png?v=1770863789:Figure 26]<br/>
<br/>
◆ Check the material:<br/>
Make sure the material is suitable for engraving with a diode blue laser.<br/>
The surface of the material should have no coating or paint layer.<br/>
If there is a paint layer, try engraving it one more time.<br/>
◆ Test the laser module status:<br/>
Inspect the Laser—Open the top cover of the Atelier. Following the Atelier Laser Lens Cleaning Video, remove the laser, taking care to prevent dust from entering the galvanometer assembly.<br/>
If it does not cut through and there is no visible mark on the back of the plywood, the laser module needs to be checked.<br/>
Open the top cover of the Atelier and remove the laser module according to the Atelier laser lens cleaning video.<br/>
Be careful not to let dust enter the galvo scanner assembly.<br/>
--Check the laser lens:<br/>
Check whether the laser lens is clean.<br/>
If it is dirty, clean it first using 99% pure anhydrous ethanol or a professional optical lens cleaner (avoid solvents containing ammonia or acetone).<br/>
When wiping, use a lint-free cloth and wipe in a single direction (e.g., spiral from the center outward), avoiding back-and-forth rubbing to prevent scratches.<br/>
After cleaning, inspect the lens under strong side lighting to make sure there is no remaining water stain or fiber.<br/>
If the lens is damaged, the laser module must be replaced.<br/>
Please provide clear photos of the damage and the device Serial Number to customer service.<br/>
--Test the laser spot:<br/>
If the lens is clean, point the laser module toward the ceiling and fire it to check whether the laser spot is diffused or shows other abnormalities.<br/>
If any abnormality is observed, please take clear photos of the laser spot and send them to customer service.<br/>
Please refer to the Atelier laser spot inspection guide.<br/>
◆ If none of the above shows any abnormalities, it is considered a laser module failure:<br/>
Please provide a cutting test video (clearly showing the parameter settings, cutting process, cutting result, and device Serial Number, as shown in Figure 27) and send it to customer service for further handling.<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_27_2a56db95-37f9-4b5d-befd-7dc4d574da63.png?v=1770863814:Figure 27]`,
          video_url: [
            'https://youtu.be/qNJhnsqfoPw',
            'https://youtu.be/m1rLu7p973o',
            'https://youtu.be/yE9WElqNGYs',
            'https://youtu.be/boATg0ZkuuQ',
          ],
        },
        {
          Q: `The engraving result on the Atelier is distorted.`,
          A: `Solution:<br/>
◆ Confirm the material weight:<br/>
Lightweight materials can be blown by the strong suction of the Atelier exhaust fan.<br/>
When engraving lightweight materials, the material should be secured—you can use the provided masking tape to stick it to the base plate or use the supplied positioning strips to hold it down.<br/>
◆ Confirm that the galvo is calibrated:<br/>
Create a square file in the software and perform an engraving to check whether the result is correct.<br/>
If distortion is observed, follow the steps below to calibrate in AtomStack Studio or LightBurn.<br/>
--Calibration in AtomStack Studio:<br/>
Open the software, click “Settings” → “Calibration” to enter the calibration interface (see Figure 28).<br/>
Place the engraving material inside the machine and focus it properly.<br/>
Click “Start” to engrave a 100 mm × 100 mm square.<br/>
Measure the actual side lengths in the X-axis and Y-axis, then input these values into the “Galvo Calibration” interface in the red-framed section under “size coefficient calculation.”<br/>
For example, if the actual square measures 112 mm × 117 mm, input these values to obtain an X-axis ratio of 0.893 (see Figure 29).<br/>
Repeat the same for the Y-axis.<br/>
Please refer to the Atelier galvo calibration video.<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_28_a48c32b3-9165-4afa-a207-625453de0d73.png?v=1770863843:Figure 28]<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_29_8aaeb10b-0e64-459c-8898-f282d17ec641.png?v=1770863923:Figure 29]<br/>
<br/>
--Y-axis of the frame is curved:<br/>
In this case, the “Curve” parameter needs to be adjusted. The default Y-axis curve value is 1.060 (see Figure 28).<br/>
--Calibration in LightBurn:<br/>
Please refer to the Atelier galvo calibration video.<br/>
Note: When using LightBurn, go to “Device Settings” and set the “Origin” to the top-left corner (see Figure 30).<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_30_ef63a7b0-3306-4e94-aaf1-a5a6d39fbce9.png?v=1770864109:Figure 30]`,
          video_url: ['https://youtu.be/JG4nHUhGzj0'],
        },
        {
          Q: `Atelier door detection malfunction – the status indicator lights red even when the enclosure door is closed.`,
          A: `Solution:<br/>
◆ Confirm that the enclosure door is fully closed:<br/>
Check whether the door is being blocked by materials and cannot fully close.<br/>
◆ Check the Hall sensor:<br/>
In AtomStack Studio, go to Settings and turn off the “Door Detection” function (see Figure 31).<br/>
If the status indicator changes from red to solid green after disabling this function, it indicates a Hall sensor failure.<br/>
For replacement, please refer to the Atelier Hall sensor replacement video.<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_31_2f3fafa5-9f55-44f6-9a02-d238cdbff6ef.png?v=1770864146:Figure 31]<br/>
<br/>
◆ If the above steps do not sort the red light issue:<br/>
Please provide a photo of the Serial Number (as shown in Figure 32) and a fault video to customer service to request the Atelier firmware for updating the machine.<br/>
If the issue persists after updating the firmware, attempt a mainboard replacement.<br/>
For guidance on replacing the mainboard, please refer to the Atelier mainboard replacement video.<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_32_6479c466-cf02-4d34-8796-d4940809349a.png?v=1770864172:Figure 32]`,
          video_url: ['https://youtu.be/ug5x1HLtO2Q', 'https://youtu.be/9zmgnkasuN8'],
        },
        {
          Q: `Atelier suddenly stops during operation.`,
          A: `Solution:<br/>
◆ Test the power adapter output:<br/>
Use a multimeter set to DC mode to measure whether the adapter output is 24V, 3A.<br/>
If the output is abnormal, please provide a test video and the device Serial Number (as shown in Figure 33) and send them to customer service for further handling.<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_33_77d76766-6310-461c-bf20-5a6e6dace014.png?v=1770864276:Figure 33]<br/>
<br/>
◆ Check for alarm prompts:<br/>
Observe whether the status indicator lights red or whether the software displays an alarm.<br/>
--USB key not inserted prompt:<br/>
Check whether the USB key is properly inserted. Gently adjust it and see if the indicator light turns flashing green.<br/>
If it flashes green, press “Start/Pause” to continue the previous engraving.<br/>
If the USB key not inserted prompt persists, please provide a fault video and the device Serial Number to customer service for further handling.<br/>
--Connection lost prompt:<br/>
Confirm the Type-C cable is properly connected:<br/>
Turn off the machine, reconnect the cable, and power it on again.<br/>
On Mac, due to serial port access permissions, use a docking station to connect via the A port of the Type-C cable supplied with the machine (see Figure 34).<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_34_f3f6c28a-8470-46b8-b298-c524b5de42d9.png?v=1770864531:Figure 34]<br/>
<br/>
Check the port:<br/>
Try connecting to a different COM port on the computer and install the serial port driver.<br/>
Pay special attention to Windows 7, which has poor compatibility.<br/>
Driver download links:<br/>
Windows: [link:https://asa.atomstack.com/downloadWindowsDrivers.do3]<br/>
Mac: [link:https://asa.atomstack.com/downloadMacDrivers.do3]<br/>
Check the software:<br/>
Try using AtomStack Studio (PC or mobile) or LightBurn to see if the sudden stop occurs in all cases.<br/>
If none of the above resolves the connection lost issue:<br/>
Attempt a mainboard replacement.<br/>
Please provide the fault video, troubleshooting steps, and device Serial Number to customer service for further handling.<br/>
For guidance, refer to the Atelier mainboard replacement video.<br/>
--Prompt: $door/enable=On – enclosure detected as open:<br/>
Confirm that the enclosure door is fully closed:<br/>
Check whether the door is being blocked by materials and cannot fully close.<br/>
Check the Hall sensor:<br/>
In AtomStack Studio, go to Settings and turn off the “Door Detection” function (see Figure 35).<br/>
If the status indicator changes from red to solid green after disabling this function, it indicates a Hall sensor failure.<br/>
For replacement, please refer to the Atelier Hall sensor replacement video.<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_35_13c163d2-d798-4be5-96f8-2c22d65c1a1d.png?v=1770864570:Figure 35]<br/>
<br/>
◆ If none of the above resolves the issue:<br/>
Attempt a mainboard replacement.<br/>
Please provide the fault video, troubleshooting steps, and device Serial Number to customer service for further handling.<br/>
For guidance on replacing the mainboard, refer to the Atelier mainboard replacement video.`,
          video_url: ['https://youtu.be/ug5x1HLtO2Q', 'https://youtu.be/9zmgnkasuN8'],
        },
        {
          Q: `When processing lightweight materials on the Atelier, the output may show missing or distorted lines.`,
          A: `Solution:<br/>
The cause is that the strong airflow from the exhaust fan can move lightweight materials.<br/>
◆ Use the provided masking tape to secure the material to the base plate.<br/>
◆ Use the provided positioning strips to hold the material in place.<br/>
The positioning strips have limitations, so the method of securing should be determined based on the size of the material.`,
          video_url: [],
        },
        {
          Q: `Atelier cannot connect via WiFi.`,
          A: `Solution:<br/>
◆ Check the router:<br/>
The Atelier WiFi only supports 2.4 GHz. It cannot connect to a 5 GHz network.<br/>
Switch the router to 2.4 GHz and try again.<br/>
◆ Connect via mobile hotspot:<br/>
If there is no 2.4 GHz router or no WiFi network available, you can use a mobile hotspot to connect and control the Atelier.<br/>
For connection instructions, refer to the Atelier mobile connection video.<br/>
◆ Check the WiFi signal:<br/>
Use your phone to search for WiFi and see if a network named Atelier_*** **appears, and check the signal strength.<br/>
--WiFi signal is strong:<br/>
Try using another phone or turn off mobile data and attempt to connect again.<br/>
--WiFi network not found:<br/>
If the network cannot be found on any phone, please provide a fault video and the device Serial Number to customer service to request the corresponding firmware.<br/>
Reflash the firmware and try to connect again.<br/>
If it still cannot connect, contact customer service to arrange a mainboard replacement.<br/>
For guidance, refer to the Atelier mainboard replacement video.<br/>
--WiFi signal is weak:<br/>
Check the WiFi antenna by opening the top cover of the Atelier.<br/>
Ensure the WiFi antenna is properly connected to the mainboard.<br/>
Reconnect it if necessary.<br/>
If the signal remains weak after reconnecting, the WiFi antenna is faulty.<br/>
Please provide a fault video and the device Serial Number (see Figure 36) to customer service for further handling.<br/>
Refer to the Atelier WiFi antenna replacement video.<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_36_c122b3c4-ea4c-4532-8fe2-f336352953fc.png?v=1770864652:Figure 36]`,
          video_url: [
            'https://youtu.be/zd5E25sBxwQ',
            'https://youtu.be/9zmgnkasuN8',
            'https://youtu.be/uDOd9II1hM0',
          ],
        },
        {
          Q: `The Atelier does not close vector lines during engraving.`,
          A: `Solution:<br/>
◆ Check the engraving file:<br/>
Create a square or circular line file in the software and perform a test engraving.<br/>
If the lines close correctly, the issue is caused by the original engraving file.<br/>
◆ Check the focus:<br/>
Refocus the laser using the focusing knob on the side top of the laser so that the two red dots overlap on the material surface.<br/>
The fixed focal height is 151 mm (distance from the galvo platform to the material surface).<br/>
◆ Check the parameter settings:<br/>
Confirm whether the parameters are correctly set according to the recommended parameter table.<br/>
Note that the speed unit must be mm/min.<br/>
How to view the parameter table:<br/>
① Scan the QR code on the machine to view it.<br/>
② Visit the official website: [link:https://atomstack.com/pages/product-support]<br/>
③ Request it from customer service.<br/>
If the parameter settings are correct, try reducing the speed or increasing the power.<br/>
◆ Enable “Constant Power”:<br/>
In AtomStack Studio, see Figure 37; in LightBurn, see Figure 38.<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_37_44be103b-0474-42ba-8f83-07ae75eda279.png?v=1770864720:Figure 37]<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_38_820056db-4aac-4430-b18c-bff4f04c6240.png?v=1770864757:Figure 38]<br/>
<br/>
◆ Increase the $31 minimum power value:<br/>
Use AtomStack Studio or LightBurn to send the command $31=* (“* ”represents a specific value. You can gradually increase this value until the lines fully close).For example, if the lines do not close when $31 = 0, send $31 = 10. If the lines are still not closed as shown, continue increasing the value and send $31 = 20, and so on until the lines fully close.For the operation steps, Please refer to the Atelier tutorial video on adjusting the minimum power value.`,
          video_url: ['https://youtu.be/TTSdmaT2zQM'],
        },
        {
          Q: `The Atelier exhaust performance is poor, and the enclosure is filled with smoke.`,
          A: `Solution:<br/>
◆ Check the exhaust duct:<br/>
Carefully inspect the exhaust duct for kinks or blockages.<br/>
◆ Check the fan:<br/>
Open the enclosure and remove the fan cover by unscrewing the two screws on the fan partition.<br/>
--Fan is heavily dusty:<br/>
Clean the fan according to the Atelier fan cleaning video.<br/>
--Fan does not rotate:<br/>
Open the top cover of the Atelier and check whether the fan connector is properly plugged in. Reconnect if necessary.<br/>
If the fan still does not rotate, disconnect the fan connector and use two wires to connect the fan directly to the adapter (see Figure 39) to test whether it rotates normally.<br/>
If it still does not rotate, provide a troubleshooting video and the device Serial Number (see Figure 40) to customer service for further handling.<br/>
For fan replacement, refer to the Atelier fan replacement video.<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_39_e1fc50e8-3112-44b3-8926-8fc48b4e2fe7.png?v=1770864850:Figure 39]<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_40_8e1ec6f8-3901-4a8d-bca6-f2630a4783d9.png?v=1770864894:Figure 40]`,
          video_url: ['https://youtu.be/hlp5k3olzEQ', 'https://youtu.be/HFsPMotcA1A'],
        },
        {
          Q: `Mirror or reversed output when using a rotary with Atelier.`,
          A: `Solution:<br/>
◆ Check whether the engraving file is mirrored.<br/>
If yes, check whether the mirror function is enabled in the software settings. If it is enabled, please disable it.<br/>
If it is disabled, try enabling it. For reference: see Figure 41 in AtomStack Studio and Figure 42 in LightBurn.<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_41_aaf5a1a7-eb83-406e-b27f-7b60562d0552.png?v=1770865117:Figure 41]<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_42_3a6a44d5-40fd-4230-8a04-1e8e020cbfe9.png?v=1770865147:Figure 42]<br/>
<br/>
◆ Restore Factory Settings:<br/>
--To restore factory settings in AtomStack Studio:<br/>
In version 2.20 or above, click 7 times consecutively on the Version Number: V.2.20 (client version) to enter Developer Mode (see Figure 43).<br/>
Go back to the menu bar and open “Serial Port Log” in Developer Mode, then click “Reset” to restore factory settings (see Figure 44).<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_43_3eb70034-fe8c-4e05-b100-70b19b40dbd4.png?v=1770865182:Figure 43]<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_44_bfb80b37-1b7d-44c4-b388-94a377c08583.png?v=1770865330:Figure 44]<br/>
<br/>
--In LightBurn：<br/>
enter the command $RST=* in the console command input box to restore factory settings (see Figure 45)<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_45_d661adb5-0c64-408c-83ee-e12ae4e1a25b.png?v=1770865410:Figure 45]`,
          video_url: [],
        },
        {
          Q: `Atelier does not work properly after connecting the rotary attachment.`,
          A: `Solution:<br/>
◆ Check the connection:<br/>
Atelier only supports the R6 / R8 / R8 PRO rotary attachments, which must be connected via the supplied USB cable (see Figure 46).<br/>
Notice：Make sure not to plug into the wrong port — it must be connected to the Accessory port on the Atelier machine.<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_46_43116779-a3f6-4244-8027-aa40881de75e.png?v=1770865449:Figure 46]<br/>
<br/>
◆ Check the settings:<br/>
--When using LightBurn, configure the following:<br/>
Rotary type: For R6 select Roller, for R8 select Chuck.<br/>
Rotary axis: Select Y-axis.<br/>
Parameters:<br/>
R8: Speed = 160 mm/rev (fixed), enter either the material diameter or circumference.<br/>
R6: Speed = 50 mm/rev (fixed), rotary diameter = 16 mm (fixed), enter either the material diameter or circumference.(See Figure 47)<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_47_a9d294ce-3fa0-4914-9bb3-e266dc1669b4.png?v=1770865492:Figure 47]<br/>
<br/>
--When using AtomStack Studio:<br/>
Roller (R6): No parameter settings are required.<br/>
Chuck (R8): You need to enter either the material circumference or diameter (choose one) (see Figure 48).<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_48_c6ce5c97-5e03-4a1a-b623-8b4374768370.png?v=1770865593:Figure 48]`,
          video_url: [],
        },
        {
          Q: `Atelier cannot recognize USB drives or TF cards.`,
          A: `Solution:<br/>
◆ Test recognition function:<br/>
Since the USB drive or TF card is internally connected to the mainboard, you can only check its functionality through AtomStack Studio by navigating to File → Open Project to see if the storage function works properly .<br/>
Is the size of the storage space compatible with the available space on the USB drive or TF card?<br/>
(see Figure 49).<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_49_74b36bfd-66b9-44de-8170-975c1a331755.png?v=1770865631:Figure 49]<br/>
<br/>
◆ Reinsert the USB/TF card:<br/>
Turn off the machine, open the top cover, remove the USB drive or TF card, and then reinsert it.<br/>
Refer to the Atelier USB/TF card replacement video for guidance.<br/>
◆ Format the USB/TF card:<br/>
If reinserting does not resolve the issue, insert the USB drive or TF card into a computer and format it to FAT32.<br/>
◆ Replace the USB/TF card:<br/>
Try using another USB drive or TF card. If the new card works properly, the original is considered defective.<br/>
You can send a video of the fault along with the device Serial Number (see Figure 50) to customer service for assistance.<br/>
◆ Replace the mainboard if necessary:<br/>
If the USB drive or TF card can be recognized and read/written normally on a computer, and formatting does not resolve the issue, the mainboard needs to be replaced.<br/>
Please send a video of the fault, the troubleshooting steps taken, and the device Serial Number to customer service for assistance.<br/>
For replacement instructions, refer to the Atelier Mainboard Replacement video.<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_50_854a04a9-18a0-4681-89e9-83f76f516de4.png?v=1770865654:Figure 50]`,
          video_url: ['https://youtu.be/9zmgnkasuN8', 'https://youtu.be/21p5wdVDJG4'],
        },
        {
          Q: `Atelier firmware upgrade failed.`,
          A: `Solution:<br/>
If a new firmware update pushed by AtomStack Studio (PC or mobile version) fails, try the following steps:<br/>
◆ Atelier cannot recognize the USB/TF card:<br/>
Refer to the section “Atelier cannot recognize USB drives or TF cards” for troubleshooting.<br/>
◆ Cannot flash the same firmware repeatedly:<br/>
Check whether the firmware you are trying to flash is the same as the current firmware version on your Atelier.<br/>
If you are unsure, take a screenshot and send it to customer service for confirmation.<br/>
To check the firmware version, see Figure 51.<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_51_6795977e-5e44-442b-be59-ce1d7f09a082.png?v=1770866777:Figure 51]`,
          video_url: [],
        },
        {
          Q: `Atelier dual red lights do not overlap during focusing.`,
          A: `Solution:<br/>
◆ Check the focusing distance:<br/>
If the material has been placed but the distance has not been adjusted, readjust it.<br/>
Make sure the overlap point aligns with the center point on the same horizontal line (see Figure 52).<br/>
◆ Adjust the red light angles:<br/>
Set the galvanometer platform to a height of 151 mm from the base plate. Then:<br/>
Adjust the angle of one red light so that its red dot falls on the horizontal line to the right of the base plate center (recommended within 1–2 mm).<br/>
Lock the screw, then adjust the angle of the other red light so that it overlaps with the first red dot.<br/>
Refer to the Atelier Red Light Positioning Calibration video for guidance.<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_52_ec916623-fcb5-4b6e-bf3a-c3e76f838900.png?v=1770866866:Figure 52]`,
          video_url: ['https://youtu.be/kuKp-jB_18M'],
        },
        {
          Q: `Atelier camera misalignment.`,
          A: `Solution:<br/>
◆ Check the focusing distance:<br/>
After placing the material, readjust the distance so that the two red dots overlap on the material surface and align horizontally with the center point.<br/>
◆ Realign the camera:<br/>
The camera is factory-calibrated before shipment. When using AtomStack Studio, the user only needs to perform camera alignment.<br/>
Since there is no built-in illumination in the enclosure, use a flashlight or other light source to illuminate the interior during capture.<br/>
The smaller the captured values, the better.<br/>
When using LightBurn, follow its default procedure for camera calibration.<br/>
Refer to the Atelier AtomStack Studio Camera Calibration video and the Atelier LightBurn Camera Calibration video for guidance.`,
          video_url: ['https://youtu.be/uUKBUhv837Y', 'https://youtu.be/6BWuEGxefzY'],
        },
        {
          Q: `Atelier camera malfunction.`,
          A: `Solution:<br/>
◆ Check if the camera is disabled:<br/>
Open the Device Manager to see if the camera is restricted or disabled.<br/>
Remove any restrictions and enable permissions as needed (see Figure 53).<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_53_b22082de-42e1-475b-b039-b35a76fbe95b.png?v=1770866893:Figure 53]<br/>
<br/>
◆ Check the camera connection to the mainboard:<br/>
If the camera cannot capture images, check whether the camera cable is loose (see Figure 54).<br/>
Use tweezers or a similar tool to disconnect and reconnect the cable, then test the camera function again.<br/>
◆ Replace the camera if necessary:<br/>
If the above steps do not resolve the issue, the camera is considered faulty.<br/>
Replace the camera following the Atelier Camera Replacement video instructions.<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_54_ab23d953-1f2c-41e9-a735-c11b38361e70.png?v=1770866919:Figure 54]`,
          video_url: ['https://youtu.be/tkjkBDb5_pI'],
        },
      ],
    ],
  },
  Glacier: {
    nav: [`pre-Sale Questions`, `Quick Start`, `Maintenance & Care`],
    nav_desc: [
      `What You Need to Know Before Buying`,
      `Your First Steps Made Simple(For Beginners) `,
      `Keep Your Machine in Top Shape`,
    ],
    quantions: [
      // Category 1: Pre-Sale Questions (Part III)
      [
        {
          Q: `1. What is the working area of Glacier?`,
          A: `The working area is 800 mm × 800 mm.`,
          video_url: [],
        },
        {
          Q: `2. What is the laser power of Glacier?`,
          A: `It is available with 90W and 120W diode blue lasers, and a 4W infrared laser (the infrared laser needs to be purchased separately).`,
          video_url: [],
        },
        {
          Q: `3. Can the laser power of Glacier be adjusted?`,
          A: `Yes.<br/>
* 120W laser: selectable levels of 40W / 80W / 100W / 120W<br/>
* 90W laser: selectable levels of 35W / 70W / 90W`,
          video_url: [],
        },
        {
          Q: `4. Can Glacier engrave and cut metal materials?`,
          A: `It can engrave metal, but cutting metal is not recommended.<br/>
The 90W and 120W blue diode laser heads can engrave some metals such as stainless steel, iron, anodized aluminum, and brass.<br/>
The 4W infrared laser head can engrave most metals.`,
          video_url: [],
        },
        {
          Q: `5. Can Glacier connect to a computer via Wi-Fi?`,
          A: `Yes. You need to use the AtomStack Studio client. First connect the machine using a Type-C cable to configure the network. Once the connection is set up, you can use Wi-Fi mode for operation. Refer to the Glacier connection tutorial video.`,
          video_url: ['https://youtu.be/_VUVhREwP_8'],
        },
        {
          Q: `6. Can Glacier engrave thermos bottles or cups?`,
          A: `Yes. You need to use it with the R6 / R8 / R8 Pro rotary attachment. See the “Glacier Rotary Usage” section for details.`,
          video_url: [],
        },
        {
          Q: `7. Is there a protective enclosure available for Glacier?`,
          A: `Yes. The B4 protective enclosure is available. Please refer to the B4 enclosure installation video for setup instructions.`,
          video_url: ['https://youtu.be/0k7GQdiZ-Q4'],
        },
        {
          Q: `8. Is there a compatible honeycomb panel for Glacier?`,
          A: `Yes. You can use two F8 honeycomb panels combined together (F8 panels are designed to be connectable).`,
          video_url: [],
        },
        {
          Q: `9. Does Glacier come with an air assist? What are the airflow and noise levels?`,
          A: `: Yes, an air assist system is included.<br/>
* Airflow: 50 L/min<br/>
* Noise level: 73 dBA (measured when ambient noise is 48 dBA)`,
          video_url: [],
        },
        {
          Q: `10. Can Glacier use laser modules from other brands?`,
          A: `No. It is recommended to use the ATOMSTACK 4W infrared laser module.`,
          video_url: [],
        },
        {
          Q: `11. Can Glacier use rotary attachments?`,
          A: `Yes, it supports R6 / R8 / R8 Pro rotary attachments. Please refer to the “Glacier Rotary Usage” section.<br/>
Notes:<br/>
◆ When using the R8 chuck:<br/>
* Cylindrical objects: 0–80 mm diameter<br/>
* Spherical objects: 25–80 mm diameter<br/>
* Ring-shaped objects: 10–70 mm diameter<br/>
* Maximum supported weight: 1.5 kg`,
          video_url: [],
        },
        {
          Q: `12. Which control software can be used with Glacier?`,
          A: `It is recommended to use AtomStack Studio or the AtomStack App.<br/>
You can also use LightBurn, but you will need to import the configuration file. Refer to the “Glacier Connection” section.`,
          video_url: [],
        },
        {
          Q: `13. Does Glacier have safety features?`,
          A: `Yes.<br/>
◆ Emergency stop switch and power switch: Allows immediate power cutoff in emergency situations.<br/>
◆ Safety fuse: Automatically cuts off power if the current exceeds the rated value, protecting the machine from damage.<br/>
◆ Safety enclosure: The optional B4 protective enclosure helps prevent light pollution, smoke, and dust from affecting the working environment.`,
          video_url: [],
        },
        {
          Q: `14. What is the recommended operating temperature for Glacier?`,
          A: `The recommended working temperature is 10–35 °C.<br/>
If the temperature drops below 5 °C, antifreeze should be added to the chiller.`,
          video_url: [],
        },
        {
          Q: `15. What is the maximum Z-axis travel of Glacier?`,
          A: `90 mm`,
          video_url: [],
        },
        {
          Q: `16. What is the maximum engraving speed of Glacier?`,
          A: `The maximum engraving speed can reach 24,000 mm/min.<br/>
For detailed parameters:<br/>
① Scan the QR code on the machine.<br/>
② Visit the official website: https://atomstack.com/pages/product-support<br/>
③ Contact customer support for the parameter sheet.`,
          video_url: [],
        },
        {
          Q: `17. How should Glacier be stored when not in use?`,
          A: `If the engraver will not be used for a long time, place it in a dry environment. It is recommended to power on the machine and run it for about 5 minutes once a month to maintain the lifespan of the electronic components.`,
          video_url: [],
        },
      ],
      // Category 2: Quick Start (Part I)
      [
        {
          Q: `Glacier Control Interface Description`,
          A: `[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_1_217b4b2d-fbcd-470b-815f-3116d3e07b74.png?v=1785143121:Glacier]<br/>
1) Emergency Stop Switch:<br/>
In an emergency, press the emergency stop switch to cut off the power. The machine will stop operating to protect both personnel and equipment.<br/>
2) USB Key:<br/>
USB key port. The machine can only be used after the USB key is inserted (it is already inserted at the factory). If the USB key is not inserted, the machine cannot emit laser.<br/>
3) Auto Focus Button<br/>
◆ Press once to perform auto focus.<br/>
◆ Press and hold for more than 5 seconds to start Wi-Fi configuration.<br/>
4) Laser Temperature Indicator<br/>
◆ Solid green: Normal status, 16 °C ≤ laser temperature ≤ 40 °C.<br/>
◆ Solid yellow: Warning status, 40 °C ≤ laser temperature ≤ 50 °C.<br/>
◆ Flashing red: Alarm status, laser temperature < 16 °C or > 50 °C, accompanied by a buzzer alarm.<br/>
5) Chiller Startup Alarm Indicator<br/>
◆ Solid green: Normal startup.<br/>
◆ Flashing red: Alarm status, such as flow alarm or low water level alarm, accompanied by a buzzer alarm.<br/>
6) Wi-Fi Connection Indicator<br/>
◆ Solid green: Wi-Fi connected normally.<br/>
◆ Flashing blue: Wi-Fi pairing/configuration in progress.<br/>
◆ Flashing red: Wi-Fi connection failed, accompanied by a buzzer alarm.<br/>
7) Machine Status Indicator<br/>
◆ Solid green: Standby mode.<br/>
◆ Flashing green: Machine operating.<br/>
◆ Flashing red: Alarm status, such as abnormal laser temperature, chiller malfunction, flame detection alarm, limit switch alarm, etc., accompanied by a buzzer alarm.<br/>
8) USB DRIVE:<br/>
USB flash drive port.<br/>
9) COMPUTER:<br/>
Computer port. Connect to the computer via a Type-C cable.<br/>
10) ACCESSORY:<br/>
Expansion accessory port with automatic recognition function. Can connect accessories such as R6, R8, R8 Pro, R5, etc., that support auto recognition.<br/>
11) SCREEN:<br/>
Touchscreen port. Connect to the touchscreen via an HDMI cable.<br/>
12) AIR ASSIST:<br/>
Air assist power output port. It can automatically control the air assist on and off.<br/>
13) FIRE SAFETY:<br/>
Active fire extinguisher power output port. When a flame alarm occurs, if a fire-extinguishing pump is installed, the extinguishing function will be triggered and the pump will automatically extinguish the fire.<br/>
Note: The air assist included with the engraving machine does not have this function.<br/>
14) WATER COOLING:<br/>
Chiller port. Connect to the control box using a VGA cable.<br/>
15) Engraving Machine Power Switch:<br/>
Used to turn the engraving machine on or off.<br/>
16) Engraving Machine Fuse:<br/>
Automatically blows when the current in the circuit exceeds 15A.<br/>
17) Engraving Machine Power Cord Port:<br/>
Used to connect to the mains power supply. Ensure the voltage matches the equipment requirements.<br/>
18) Chiller Power Cord Port:<br/>
Used to connect to the mains power supply. Ensure the voltage matches the equipment requirements.<br/>
19) Chiller Fuse:<br/>
Automatically blows when the current exceeds 5A.<br/>
20) Chiller Power Switch:<br/>
Used to turn the chiller on or off.<br/>
21) ALARM:<br/>
Connection port for alarm devices.<br/>
22) DATA:<br/>
Communication interface between the chiller and the control box, connected via a VGA cable.<br/>
23) INLET:<br/>
Return water port for circulation.<br/>
24) OUTLET:<br/>
Water outlet port for circulation.<br/>
25) Water Filling Port:<br/>
Water inlet for the chiller tank.<br/>
26) Water Level Indicator:<br/>
Window for observing the chiller water level. Ensure the water level does not fall below the minimum mark.<br/>
27) Tank Drain Port:<br/>
Drain outlet for the chiller tank.<br/>
28) Rotary Knob Switch:<br/>
Used to turn on the air assist and adjust the airflow level.`,
          video_url: [],
        },
        {
          Q: `2. Glacier Unboxing Video`,
          A: `Please refer to the Glacier unboxing video or the user manual.<br/>
Before powering on the machine, please confirm the following:<br/>
◆ Voltage compatibility:<br/>
Before connecting the power supply, please confirm that the voltage specification of the received machine matches the local power supply voltage. Glacier supports two voltage specifications: 230V and 115V.<br/>
If the machine you received is set to 115V, but your local voltage is 220V, please adjust the voltage selector as follows: use a screwdriver or tweezers to move the switch left or right to the appropriate voltage position, as shown in Figure 1.<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_2_48ba89ec-45da-4fc6-83cc-e1f578e8273f.png?v=1785143122:Figure 1]<br/>
◆ Water connections:<br/>
There is no specific requirement for connecting the laser inlet and outlet water ports. However, the chiller inlet and outlet must be connected according to the port labels.<br/>
◆ Filling the chiller:<br/>
Before powering on, please fill the water chiller with distilled water, purified water, or high-purity water. The water level must be above the minimum water level mark, as indicated on the chiller scale.<br/>
◆ Water hose inspection:<br/>
Ensure that the chiller water hoses are not bent, damaged, or leaking. Do not add corrosive liquids to the system.<br/>
◆ Working environment:<br/>
Ensure that the working environment is well ventilated and that no flammable materials are accumulated in the work area.<br/>
◆ Machine placement:<br/>
During operation, the machine must be placed horizontally. Tilting, flipping, or placing the machine upside down is strictly prohibited.<br/>
◆ USB Key:<br/>
Ensure that the USB Key is inserted.<br/>
◆ Laser safety:<br/>
Never look directly at the laser without protection. Laser safety goggles must be worn during operation, and do not leave the machine unattended while it is running.`,
          video_url: ['https://youtu.be/Ym8gOrVkKls'],
        },
        {
          Q: `3、Glacier Connection and Operation`,
          A: `Please refer to the Glacier connection tutorial video.<br/>
Notes:<br/>
◆ CH340 driver installation:<br/>
When using the machine for the first time, the computer needs to install the CH340 serial port driver<br/>
◆ Using AtomStack Studio:<br/>
When using AtomStack Studio, the machine can be connected and used directly without any additional settings.<br/>
◆ Using LightBurn:<br/>
When using LightBurn, please ensure the baud rate is set to 460800, as shown in Figure 2, or import the machine configuration file.<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_3_37cbd55a-1320-483a-ac00-5c271d40e635.png?v=1785143121:Figuer 2]<br/>
◆ Wi-Fi connection:<br/>
To enable Wi-Fi connection, press and hold the Auto Focus button for more than 5 seconds to start Wi-Fi pairing, as shown in Figure 3。<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_4_901a6cfa-bb16-4ad6-ad41-6c7b0c9addb6.png?v=1785143121:Figure 3]`,
          video_url: ['https://youtu.be/_VUVhREwP_8'],
        },
        {
          Q: `4. Glacier Laser Power Switching`,
          A: `Please refer to the Glacier laser power switching tutorial video.<br/>
Notes:<br/>
◆ 120W laser module:<br/>
Under normal mode, the 120W laser can switch between 100W, 80W, and 40W.<br/>
To reach 120W, Overclock Mode must be enabled. However, long-term use of overclock mode is not recommended.<br/>
◆ 90W laser module:<br/>
Under normal mode, the 90W laser can switch between 70W and 35W.<br/>
To reach 90W, Overclock Mode must be enabled. However, long-term use of overclock mode is not recommended.<br/>
◆ Software operation:<br/>
Laser power switching for the Glacier laser must be performed within the software.<br/>
Power switching in AtomStack Studio is shown in Figure 4, and in LightBurn is shown in Figure 5.<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_5_0954cc22-3b09-40bc-9bf3-d849d773c1c4.png?v=1785143121:Figure 4]<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_5_1217b2e2-50b4-4c02-8404-5c5ee5f6acdc.png?v=1785144369:Figure 5]`,
          video_url: ['https://youtu.be/B4427uS23xM'],
        },
        {
          Q: `5. Glacier Auto Focus and Manual Focus`,
          A: `Please refer to the Glacier auto focus and manual focus tutorial video.<br/>
Notes:<br/>
◆ Auto focus:<br/>
When using auto focus, press the focus button once briefly to start the process. Do not press and hold the focus button.<br/>
◆ Manual focus:<br/>
When using manual focus, place the 20 mm focus piece between the processing material and the bottom edge of the laser module frame.<br/>
The recommended cutting focal distance is 16 mm, and the minimum (extreme) cutting focal distance is 4 mm.`,
          video_url: ['https://youtu.be/k8c02BDPcAY'],
        },
        {
          Q: `6. Adding Antifreeze to Glacier`,
          A: `Please refer to the Glacier antifreeze filling tutorial video.<br/>
Notes:<br/>
When the ambient temperature is above 5 °C, antifreeze is not required.<br/>
The recommended mixing ratio of ambient temperature, antifreeze, and cooling water is as follows:<br/>
[table:antifreeze_ratio]`,
          tables: {
            antifreeze_ratio: {
              headers: [
                'Minimum Annual Ambient Temperature',
                'Recommended Mixing Ratio (Antifreeze Concentrate : Purified Water)',
                'Antifreeze Concentrate',
                'Cooling Water',
              ],
              rows: [
                ['Ambient Temperature＞5', '0', '0', '1800'],
                ['-10≤Ambient Temperature＜5', '2:8', '360', '1440'],
                ['-20≤Ambient Temperature＜-10', '3:7', '540', '1260'],
                ['-30≤Ambient Temperature＜-20', '4:6', '720', '1080'],
                ['-40≤Ambient Temperature＜-30', '5:5', '900', '900'],
                ['-50≤Ambient Temperature＜-40', '6:4', '1080', '720'],
              ],
            },
          },
          video_url: ['https://youtu.be/g-ykAcasOUs'],
        },
        {
          Q: `7. Using the Glacier Rotary Attachment`,
          A: `Please refer to the Glacier rotary attachment tutorial video.<br/>
Notes:<br/>
◆ The Glacier control box includes an “ACCESSORY” port, so it is compatible with all rotary accessories from AtomStack. However, due to compatibility with risers, only the AtomStack R6, AtomStack R8, and AtomStack R8 Pro rotary devices are recommended (appropriate risers must be purchased separately).<br/>
◆ Use the included USB connection cable (as shown in Figure 6) to connect the R6, R8, or R8 Pro rotary attachment.<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_6_4aafc00a-72ff-45e6-8548-8e15d2f7886b.png?v=1785144897:Figure 6]<br/>
◆ AtomStack Software Configuration：<br/>
When using AtomStack Studio, select the detected device in the software.<br/>
* Roller (R6): No parameter configuration is required.<br/>
* Chuck (R8): You need to set the circumference or diameter of the material, as shown in Figure 7.<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_7_9375ec8f-a162-418d-b862-42ae88e95d7b.png?v=1785144897:Figure 7]<br/>
◆ LightBurn Configuration：When using LightBurn, the rotary parameters must be configured manually.<br/>
Required settings:<br/>
* Rotary type（R6: Roller type   R8: Chuck type）<br/>
* Rotary axis（Select Y-axis）<br/>
Parameter settings<br/>
R8 (Chuck):<br/>
* Steps per rotation: 160 mm per rotation (fixed value)<br/>
* Enter either the diameter or circumference of the material<br/>
R6 (Roller):<br/>
* Steps per rotation: 50 mm per rotation (fixed value)<br/>
* Rotation diameter: 16 mm (fixed value)<br/>
* Enter either the diameter or circumference of the material<br/>
See Figure 8.<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_8_9f35988e-1324-4e6b-b4f6-2a8163d30c5c.png?v=1785144897:Figure 8]<br/>
Notes<br/>
◆ When using the R8 chuck, the supported cylindrical object diameter range is 0–80 mm.<br/>
◆ When using the R8 chuck, the supported spherical object diameter range is 25–80 mm.<br/>
◆ When using the R8 chuck, the supported circular object diameter range is 10–70 mm.<br/>
◆ The maximum load capacity of the R8 chuck is 1.5 kg.`,
          video_url: ['https://youtu.be/fG3qm02Cg0A'],
        },
        {
          Q: `8. Glacier Origin Setting and Positioning`,
          A: `Please refer to Glacier origin setting and positioning tutorial video.<br/>
Notes:<br/>
◆ When setting the origin, first click Home to return the machine to the 0,0 coordinate.<br/>
◆ After the machine has returned to 0,0, do not move the machine by hand. All movements must be controlled through the software, otherwise the machine will not be able to accurately recognize the coordinates.<br/>
◆ If the machine is accidentally moved by hand, it must be homed again before positioning.`,
          video_url: ['https://youtu.be/QiqDjgCAbRQ'],
        },
        {
          Q: `9. Introduction to the Glacier Software Coordinate System`,
          A: `◆ Current Position:<br/>
The current position of the laser module is used as the starting point for processing. You can manually move the laser module to the desired processing position.<br/>
◆ User Origin:<br/>
The user-defined origin is a starting position set by the user for the laser to begin operation. Please refer to the Glacier origin setting and positioning tutorial video.<br/>
◆ Absolute Coordinates:<br/>
Uses the 0,0 position after homing as the starting point, and the coordinates of the processing object determine where the laser begins operation.`,
          video_url: ['https://youtu.be/QiqDjgCAbRQ'],
        },
        {
          Q: `10. Glacier Engraving Parameter Test in Software`,
          A: `Please refer to the Glacier engraving parameter test tutorial video.<br/>
Note:<br/>
◆ This function is available only in LightBurn (version 1.3.01 or later, licensed version) or AtomStack Studio.`,
          video_url: ['https://youtu.be/78ntKGyes_g'],
        },
        {
          Q: `11. Precautions for Long-Term Use of Glacier`,
          A: `When using the machine for extended periods, it is recommended to pause the operation for 5–10 minutes after every 2 hours of use. This allows the cooling system to recover and return to its optimal operating condition.`,
          video_url: [],
        },
        {
          Q: `12. Materials Prohibited for Processing with Glacier`,
          A: `Prohibited materials:<br/>
* PVC (releases chlorine gas when processed)<br/>
* Chlorine-containing plastics<br/>
* Metals with unknown coatings<br/>
* Highly reflective mirror-like materials (reflected laser may damage the laser module)<br/>
Note:<br/>
Before processing unknown materials, it is recommended to perform a low-power test first.`,
          video_url: [],
        },
      ],
      // Category 3: Maintenance & Care (Part II + Part IV)
      [
        {
          Q: `1、Maintenance Schedule Overview`,
          A: `[table:maintenance_schedule]`,
          tables: {
            maintenance_schedule: {
              headers: ['Item', 'Recommended Cleaning Frequency'],
              rows: [
                [
                  'Window Lens Cleaning',
                  'For heavy users: clean once per day. For light users: clean once per week.',
                ],
                [
                  'Air Assist Inlet',
                  'For heavy users: clean once every half month. For light users: clean once per month.',
                ],
                ['Chiller Filter', 'Clean every 20–25 days.'],
                ['Cooling Water Replacement', 'Replace every 45 days.'],
                ['Profile Guide Rail', 'Clean every 500 hours of operation.'],
              ],
            },
          },
          video_url: [],
        },
        {
          Q: `2. Cleaning the Glacier Laser Protective Window and Focusing Lens`,
          A: `Please refer to the Glacier laser lens cleaning tutorial video.<br/>
Notes:<br/>
◆ Risks of not cleaning:<br/>
A contaminated protective window can block laser energy, resulting in reduced engraving power. Heat buildup on the window may damage the protective window and may also lead to damage to the focusing lens.<br/>
◆ Recommended cleaning tools:<br/>
Use a lint-free cloth or optical-grade lint-free swabs for cleaning (avoid regular cotton swabs that may shed fibers).<br/>
Use 99% anhydrous ethanol or a professional optical lens cleaner. Avoid solvents containing ammonia or acetone.<br/>
◆ Cleaning method:<br/>
Apply 99% anhydrous ethanol or a professional optical lens cleaner.<br/>
When wiping, use a lint-free cloth and wipe in a single direction (for example, spiraling from the center outward) to avoid scratches caused by repeated back-and-forth rubbing.<br/>
◆ Cleaning inspection:<br/>
After cleaning, inspect the lens under strong side lighting to ensure there are no water marks or fiber residues.<br/>
◆ Cleaning frequency:<br/>
For heavy users, it is recommended to clean once after each day of use.<br/>
For light users, it is recommended to clean once per week.<br/>
◆ Important notice:<br/>
The focusing lens is not removable. Do not attempt to pry it open or disassemble it. Unauthorized disassembly may damage the sealing structure of the laser module, and the warranty will be voided.<br/>
After unscrewing the protective window, the focusing lens will be visible, as shown in Figure 9.<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_9_3ac5f1c9-6fc6-4a3e-a0f2-42d6a4054a74.png?v=1785145364:Figure 9]`,
          video_url: ['https://youtu.be/I0t0Q8YmpPc'],
        },
        {
          Q: `3. Glacier Air Assist Cleaning`,
          A: `Refer to the Glacier Air Assist cleaning video for guidance.<br/>
Notes:<br/>
◆ Cleaning Tools: Lint-free cloth, anhydrous ethanol.<br/>
◆ Cleaning Frequency: If the working environment is dusty, it is recommended to clean once every two weeks to prevent overheating or damage caused by blockage of the air pump intake.<br/>
◆ Cleaning Method:<br/>
First, use a lint-free cloth with anhydrous ethanol to wipe the dust from the air intake on the Air Assist housing.<br/>
Then open the housing and clean the dust inside the casing and the air inlet of the pump itself.<br/>
◆ Precautions:<br/>
If the air pump power connector has been unplugged, make sure to distinguish the positive and negative terminals when reconnecting.<br/>
The side marked with a red dot indicates the positive terminal, as shown in Figure 10.<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_10_85f5002a-0ba0-440f-a54a-603865d10182.png?v=1785145364:Figure 10]`,
          video_url: ['https://youtu.be/WgsUUTQJX64'],
        },
        {
          Q: `4. Glacier Chiller Cleaning`,
          A: `Refer to the Glacier Chiller cleaning video for guidance.<br/>
Notes:<br/>
◆ Compatible Cooling Water: Purified water, distilled water, or high-purity water.<br/>
◆ Cleaning Frequency:<br/>
* Clean the filter screen every 20–25 days.<br/>
* Replace the cooling water every 45 days.<br/>
◆ Cleaning Tools: Lint-free cloth, anhydrous ethanol.<br/>
◆ Cleaning Method:<br/>
First, use a lint-free cloth with anhydrous ethanol to gently wipe dust and stains from the chiller housing. After cleaning the exterior, remove the filter screens on both sides and thoroughly clean all dust and debris. Finally, remove the two rear fans and clean them.<br/>
◆ Precautions:<br/>
-- Do not use corrosive liquids for cleaning, and do not add corrosive substances to the cooling water.<br/>
-- Tap water is not recommended for long-term use (it may cause scaling), which could lead to water channel blockage over time.<br/>
-- If the temperature is below 5 °C and the unit will not be used for a long period, drain all water from the chiller to prevent freezing and cracking.`,
          video_url: ['https://youtu.be/GaQ6QaJoQR8'],
        },
        {
          Q: `5. Glacier Machine Frame Cleaning`,
          A: `Refer to the Glacier machine frame cleaning video for guidance.<br/>
Notes:<br/>
◆ Cleaning Tools:<br/>
99% anhydrous ethanol, lint-free cloth, and grease.<br/>
(For grease selection, it is recommended to use NLGI Grade 2 or 3:<br/>
* Use Grade 2 for environments below 15 °C.<br/>
* Use Grade 3 for environments above 15 °C.)<br/>
◆ Cleaning Frequency:<br/>
Cleaning is recommended every 500 hours of operation.<br/>
◆ Cleaning Method:<br/>
Use a lint-free cloth with 99% anhydrous ethanol to gently wipe dust from the machine frame. After cleaning the linear shafts and bearing steel surfaces, apply an even layer of grease to them.<br/>
◆ Precautions:<br/>
Do not use corrosive liquids for cleaning. After wiping, the linear shafts and bearing steel surfaces must be evenly lubricated with grease.`,
          video_url: ['https://youtu.be/NNuQZsqwEXI'],
        },
        {
          Q: `1、Quick Fault Diagnosis Table`,
          A: `[table:fault_diagnosis]`,
          tables: {
            fault_diagnosis: {
              headers: ['Symptom', 'Priority Checks'],
              rows: [
                [
                  'Power attenuation',
                  'Protective window, focusing lens, software parameter settings, maximum S value in software',
                ],
                [
                  'Laser not emitting',
                  'Laser wiring connections, software output settings, software power settings, status of the indicator light on top of the laser on top of the laser',
                ],
                [
                  'Connection failure',
                  'Baud rate, Type-C cable port, computer USB port, CH340 driver',
                ],
                [
                  'Stops during engraving',
                  'Type-C cable, computer USB port, inability of Windows 11 to run in background, try different software',
                ],
                [
                  'engraving',
                  'Material, flame detection board, wiring connections, engraving line density',
                ],
                [
                  'Flame alarm',
                  'Correct laser installation, Z-axis motor wiring, upper/lower limit switches, limit switch wiring, motor operation status',
                ],
                [
                  'Distorted engraving output',
                  'Frame structure, X-axis alignment, X/Y axis step settings, check BOM wheels, check couplings',
                ],
                [
                  'APP connection failure',
                  'WiFi mode enabled, WiFi name detected, turn off mobile data, try another phone',
                ],
              ],
            },
          },
          video_url: [],
        },
        {
          Q: `2. Contamination or damage to the focusing lens or protective window of the Glacier laser module`,
          A: `Solution:<br/>
Contamination:<br/>
First, clean according to the section “Cleaning the Protective Window and Focusing Lens of the Glacier Laser.” If the stain cannot be removed, the protective window glass can be replaced (the machine includes two additional spare protective window glass).<br/>
Damage:<br/>
If the protective window glass is damaged, it can be replaced (the machine includes two additional spare protective window glass). If the focusing lens is damaged, the entire laser module must be replaced. Therefore, determine the cleaning frequency of the protective window based on usage to avoid damage to the focusing lens caused by contamination or damage to the window.`,
          video_url: [],
        },
        {
          Q: `3. Significant decline in the cutting performance of the Glacier laser module`,
          A: `Solution:<br/>
1) Normal power attenuation:<br/>
After a period of use, the laser module may experience normal power degradation. This can be compensated by increasing the power or reducing the speed.<br/>
2) Check the laser focal distance:<br/>
Use a ruler or similar tool to measure the distance between the bottom of the laser module and the material surface. It should be 16 mm or 4 mm.<br/>
3) Check the laser power level:<br/>
The Glacier laser module supports multiple power levels (refer to the “Glacier Laser Power Switching Guide”). Confirm the cutting capability corresponding to the selected power level based on the parameter table.<br/>
4) Check parameter settings:<br/>
Verify whether the current parameters match the material according to the parameter table and selected power level. Note that the speed unit is mm/min.<br/>
How to access the Glacier parameter table:<br/>
① Scan the QR code on the machine body.<br/>
② Visit the official website: https://atomstack.com/pages/product-support<br/>
③ Contact customer service to request it.<br/>
5) Confirm S-value MAX:<br/>
When using LightBurn software, ensure that the S-value MAX has not been modified (see Figure 11).<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_11_70335b12-39ab-4833-a973-423e37377365.png?v=1785146838:Figure 11]<br/>
6) Check laser module status:<br/>
Cut a 3 mm basswood board at 1200 mm/min speed and 100% power to verify performance.<br/>
* If it cuts through in one pass, the power is normal.<br/>
* If it cannot cut through, follow the steps below:<br/>
◆ Check the laser lens:<br/>
Power off the device and remove the laser module. Inspect the protective window glass and focusing lens for contamination or damage.<br/>
* For contamination, refer to the “Cleaning the Protective Window and Focusing Lens of the Glacier Laser” section.<br/>
* If stains cannot be removed or if there is damage, replace the protective window (two spare pieces are included).<br/>
* If the focusing lens is damaged, the entire laser module must be replaced.<br/>
Provide clear photos and the laser module’s engraved code (see Figure 12) to customer service for assistance.<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_12_36f064d9-e032-4f4e-94af-6879a649dcff.png?v=1785146838:Figure 12]<br/>
◆ Check the laser spot:<br/>
If the lens is clean, point the laser at a ceiling or a wall 2–3 meters away and briefly activate it to observe the spot.<br/>
Check whether the spot is scattered or abnormal. Take a clear photo of the spot (see Figure 13) and send it to customer service for confirmation. Refer to the “Glacier Laser Spot Inspection” guide.<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_13_8b6ec425-886f-4ba1-92b5-e47b16344cf9.png?v=1785146838:Figure 13]<br/>
7) If no issues are found above:<br/>
Record a video showing the cutting of a 3 mm basswood board at 1200 mm/min and 100% power, clearly including:<br/>
* Software parameter settings<br/>
* Cutting process<br/>
* Cutting result<br/>
* Troubleshooting steps already performed<br/>
Submit the video along with the laser module’s engraved code to customer service for further support.`,
          video_url: [],
        },
        {
          Q: `4. The laser module moves during engraving, but no laser is emitted`,
          A: `Solution:<br/>
1) Check the laser wiring:<br/>
Power off the machine, unplug the laser cable, and plug it back in to see if it returns to normal.<br/>
2) Check software parameter settings:<br/>
Set the parameters according to the parameter table. Make sure the “Output” option next to the layer is enabled (it must not be turned off), as shown in Figure 14.<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_14_ca3cbf7c-8651-41b7-8c88-bb7787af18cd.png?v=1785146838:Figure 14]<br/>
3) Check the laser indicator lights:<br/>
Carefully observe whether both indicator lights on top of the laser module are on during engraving or cutting (see Figure 15).<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_15_d533c52e-ae95-4f1d-b729-6d61d4a5842e.png?v=1785146839:Figure 15]<br/>
◆ Both lights on:<br/>
If both the red and green indicator lights are on, this indicates a failure of the internal laser module (laser diode).<br/>
◆ Both lights off:<br/>
This indicates a fault with the mainboard or the connection cable.<br/>
◆ Only the red light is on:<br/>
If only the red light is on and the green light is off, open the laser module housing and unplug the three diode connection cables on the driver board (see Figure 16). Then connect the two water-cooling tubes and run the engraving program to check whether the green indicator light turns on.<br/>
* If the green light turns on after unplugging the diode cables, the diode is faulty.<br/>
* If it still does not turn on, the issue is with the driver board or the mainboard connection cable.<br/>
Please provide a troubleshooting video along with the machine’s Serial Number (see Figure 17) and the laser module’s engraved code (see Figure 18) to customer service for assistance.For replacement procedures (mainboard connection cable, driver board, laser module), refer to the following guides:<br/>
* Glacier Mainboard Connection Cable Replacement Video<br/>
* Glacier Driver Board Replacement Video<br/>
* Glacier Laser Module Replacement Video<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_16_4065ec84-e508-4cd4-bf2b-d10c5b308676.png?v=1785146839:Figure 16]<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_17_286f0c87-e33d-4329-91f1-76b4979adaf8.png?v=1785146839:Figure 17]<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_18_68909cb3-090c-4402-b8c3-149f65145cdd.png?v=1785146838:Figure 18]`,
          video_url: ['https://youtu.be/-8kWd_oX3oo', 'https://youtu.be/G9NPYDo0aTg', 'https://youtu.be/-nmgscPGeKM'],
        },
        {
          Q: `5. Glacier cannot connect to a computer`,
          A: `Solution:<br/>
1) Confirm the control box is powered on properly:<br/>
Check whether three indicator lights on the front of the control box are on (see Figure 19).<br/>
If only the power switch light is on and the front indicator lights are off, check whether the emergency stop button is pressed and not released. Press it down, turn it clockwise, and release it.<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_19_ee71e195-f959-4db6-8f19-d5265014ec7b.png?v=1785147594:Figure 19]<br/>
2) Check the selected serial port:<br/>
* When using AtomStack Studio, no selection is required.<br/>
* When using LightBurn, make sure the correct serial port is selected. You can check which COM port the CH340 is assigned to in the computer’s Device Manager (see Figure 20).<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_20_1d6e8fc8-8fce-4e06-abb2-7fe2e989d3c7.png?v=1785147594:Figure 20]<br/>
3) Check the computer operating system:<br/>
* On Windows, you can directly use a Type-C to USB-A or USB-C connection.<br/>
* On macOS or HarmonyOS, you need to use a hub/docking station (see Figure 21) to connect the Type-C cable’s USB-A port.<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_21_a6d56c4a-ace0-4f12-9310-915044d59ae8.png?v=1785147593:Figure 21]<br/>
4) Ensure no other software is occupying the connection:<br/>
Make sure no other software is currently connected to the engraver.<br/>
5) Check the baud rate:<br/>
* Not required for AtomStack Studio.<br/>
* For LightBurn, ensure the baud rate is set to 460800 (see Figure 22).<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_22_56cb8b94-b6f2-4679-bbcb-d906083f549a.png?v=1785147593:Figure 22]<br/>
6) Check the serial driver:<br/>
In Device Manager, check whether a CH340 serial port is present.<br/>
* If not, install the driver using the links below:<br/>
* Windows driver: [https://asa.atomstack.com/downloadWindowsDrivers.do3](https://asa.atomstack.com/downloadWindowsDrivers.do3)<br/>
* Mac driver: [https://asa.atomstack.com/downloadMacDrivers.do3](https://asa.atomstack.com/downloadMacDrivers.do3)<br/>
You can also refer to the serial driver installation tutorial video.<br/>
7) Check the controller setup:<br/>
* Not required for AtomStack Studio.<br/>
* For LightBurn, make sure a GRBL controller is added (see Figure 23), or import the Glacier factory configuration file (refer to the Glacier connection tutorial video).<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_23_4c00b783-0452-4315-a3da-bb7ebe71fdd8.png?v=1785147593:Figure 23]<br/>
8) Check cables and ports:<br/>
Try replacing the Type-C cable or using a different USB port on the computer.<br/>
9) Try different software or computer:<br/>
Try using AtomStack Studio or LightBurn, or test with another computer.<br/>
10) If the issue persists:<br/>
Provide a fault video, troubleshooting steps performed, and the machine’s Serial Number (see Figure 24) to customer service for assistance.<br/>
For mainboard replacement, refer to the Glacier mainboard replacement video.<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_24_493d1e07-f798-41d8-9900-9be4171485f0.png?v=1785147594:Figure 24]`,
          video_url: ['https://youtu.be/_VUVhREwP_8', 'https://youtu.be/BZloFqfgtCE', 'https://youtu.be/G9NPYDo0aTg'],
        },
        {
          Q: `6. Glacier cannot connect to a mobile phone`,
          A: `Solution:<br/>
1) Confirm WiFi mode is enabled:<br/>
Press and hold the auto-focus button for more than 5 seconds to enter WiFi mode. Check whether the WiFi status indicator is flashing blue normally (see Figure 25).<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_25_ad4b51d8-2217-48e2-9b5c-0bb4aaf6dd53.png?v=1785147594:Figure 25]<br/>
2) Confirm the correct APP is used:<br/>
Download the AtomStack APP. You can download it from the official AtomStack website or by scanning the QR code on the machine. For iOS devices, you can search for “AtomStack” directly in the App Store.<br/>
3) Turn off mobile data:<br/>
Disable mobile data on your phone and try reconnecting.<br/>
4) Try another phone:<br/>
If another phone can connect successfully, provide the brand and operating system of the phone that cannot connect to customer service for further assistance.<br/>
5) Send APP logs:<br/>
Go to “Profile” → “Improvement suggestions”, check “Upload log”, and submit (see Figure 26).<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_26_edfac542-0597-4ede-9b5c-48fe5351b884.png?v=1785147594:Figure 26]`,
          video_url: [],
        },
        {
          Q: `7. Glacier suddenly stops during engraving and can only reconnect after restarting`,
          A: `Solution:<br/>
1) Check the Type-C cable connection:<br/>
Unplug and reconnect the Type-C cable, then try again.<br/>
2) Confirm the operating system:<br/>
Are you using Windows 11? If so, make sure the software is not running in the background. Switching it to the background may cause the machine to stop or operate at low power due to control issues.<br/>
3) Try using AtomStack Studio:<br/>
Download from the official website:https://atomstack.com/pages/atomstack-studio-software<br/>
4) Check software status:<br/>
When the machine stops, check whether the progress bar in the software is still running.<br/>
* If it is still running, the issue may be caused by a poor connection or disconnection.<br/>
Try cleaning the ports (USB port on the control box), replacing the Type-C cable, or using a different USB port on the computer.<br/>
5) Reflash the firmware:<br/>
Provide the machine’s Serial Number (see Figure 27) to customer service to obtain the correct firmware. Load the firmware using a USB drive and try again.<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_27_6e34e8c8-a940-4512-a70e-cbdb95f4a29f.png?v=1785147594:Figure 27]<br/>
6) If the issue persists:<br/>
The mainboard may need to be replaced.<br/>
Please provide your troubleshooting steps, a fault video, and the machine’s Serial Number to customer service for assistance.<br/>
Refer to the Glacier mainboard replacement video for guidance.`,
          video_url: ['https://youtu.be/G9NPYDo0aTg'],
        },
        {
          Q: `8. Glacier Z-axis auto-focus failure`,
          A: `Solution:<br/>
1) Confirm correct laser module installation:<br/>
When triggering auto-focus, check whether the bottom of the laser module can reach the material surface.<br/>
* If the laser cannot reach the material even when the Z-axis is at its lowest position:<br/>
* Manually adjust the Z-axis slider upward to a mid position using the adjustment knob.<br/>
* Loosen the laser module mounting screws.<br/>
* Move the laser module downward.<br/>
* Retighten the mounting screws.<br/>
Refer to the Glacier laser installation height adjustment video for guidance.<br/>
2) Check whether the Z-axis can move properly:<br/>
In AtomStack Studio or LightBurn, use the Z-axis up/down control buttons (see Figures 28 and 29) and observe whether the Z-axis moves in the correct direction.<br/>
* If there is abnormal noise and no movement:<br/>
* Check whether the motor wiring is properly connected.<br/>
* Unplug and reconnect the motor cable to see if the issue is resolved.<br/>
* If the issue persists, the mainboard, mainboard connection cable, or Z-axis motor may need to be replaced.<br/>
Please record a clear video of the issue and provide it along with the machine’s Serial Number (see Figure 30) to customer service for assistance.<br/>
For replacement procedures, refer to:<br/>
* Glacier mainboard replacement video<br/>
* Glacier mainboard connection cable replacement video<br/>
* Glacier Z-axis motor replacement video<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_28_9815e7d1-8464-4409-b803-eed0fa10e14a.png?v=1785147593:Figure 28]<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_29_04e27f83-b22b-409a-bd5b-e9bc42fd5411.png?v=1785147593:Figure 29]<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_30_0563f109-c50c-4379-a1bf-7c60bb1a7343.png?v=1785147594:Figure 30]<br/>
3）Check the upper and lower limit switches:<br/>
Observe the auto-focus process. If the Z-axis reaches the highest or lowest position and continues moving without reversing or stopping, the issue may be caused by a faulty limit switch.<br/>
Manually press the upper limit switch of the Z-axis (see Figure 31) and the lower limit switch on the laser module (see Figure 32) to check whether an alarm is triggered.<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_31_1e14c2a0-583b-4fd8-93c7-bd80907f5481.png?v=1785201370:Figure 31]<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_32_d536004e-83d1-4499-a206-74daafd86319.png?v=1785201370:Figure 32]<br/>
◆ No response from the upper limit switch:<br/>
* If the trigger lever does not spring back when pressed, the limit switch is defective.<br/>
Please provide a short video and the Serial Number to customer service for assistance.<br/>
* Unplug and reconnect the limit switch cable.<br/>
* If the issue persists after the above steps, replace the mainboard, mainboard connection cable, or Z-axis upper limit switch.<br/>
◆ No response from the lower limit switch:<br/>
* If the trigger lever does not spring back when pressed, the limit switch is defective.<br/>
Please record a fault video and provide the Serial Number to customer service.<br/>
* If engraving works normally but the limit switch cannot be triggered:<br/>
* Check whether the laser module cable is damaged.<br/>
* Unplug the connector at the back of the control box and inspect for bent or broken pins (see Figure 33).<br/>
* If no issues are found, the lower limit switch board is likely faulty and should be replaced.<br/>
Refer to the Glacier laser module lower limit switch replacement video for instructions.<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_33_763adacb-fdd4-441d-800e-996418c30c19.png?v=1785201370:Figure 33]`,
          video_url: ['https://youtu.be/snlP-YrBWtc', 'https://youtu.be/G9NPYDo0aTg', 'https://youtu.be/-8kWd_oX3oo'],
        },
        {
          Q: `9. Abnormal movement or sharp noise from the X-axis or Y-axis of Glacier`,
          A: `Solution:<br/>
1) Check the machine structure:<br/>
◆ X-axis parallelism check:<br/>
Use a ruler to measure the distance between both ends of the X-axis and the lower crossbeam. If the distances are inconsistent, the X-axis is not parallel to the frame, which may cause the X-axis support to tilt and increase friction with the Y-axis rails, hindering movement.<br/>
◆ Check Y-axis timing belts:<br/>
Press the two Y-axis belts with your fingers to check whether they have proper elasticity and tension.<br/>
* If they feel loose, loosen the two fixing screws of the belt idler pulley on both sides near the upper crossbeam.<br/>
* Pull the idler block to tighten the belt, then retighten the screws (see Figure 34).<br/>
◆ If only the X-axis has abnormal movement or noise:<br/>
Adjust the eccentric wheels of the X-axis guide rail sliders according to the Glacier structural adjustment video (see Figure 35).<br/>
◆ If the friction noise occurs at both ends of the guide shaft:<br/>
Ensure that the couplers at the ends of the shaft are not too close to the shaft supports.<br/>
* If they are too close, adjust the spacing accordingly (see Figure 36).<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_34_503d1392-9774-4342-b5e7-ed7c7b0fbb16.png?v=1785201369:Figure 34]<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_35_412b1b40-3857-4ff1-bb50-329172982e28.png?v=1785201370:Figure 35]<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_36_aa584dad-6952-4026-b5af-190d23dec7fd.png?v=1785201482:Figure 36]<br/>
2) Check motor wiring:<br/>
Unplug and reconnect the motor cables to see if the issue is resolved.<br/>
3) Check frame condition:<br/>
Carefully inspect the X-axis and Y-axis profiles for deformation, rust, or foreign objects.<br/>
* If deformation or rust is found, take clear photos and provide them along with the machine’s Serial Number to customer service for assistance.<br/>
* Refer to the Glacier unboxing video for profile replacement instructions.<br/>
4) If the issue persists:<br/>
Record a fault video and provide it along with the machine’s Serial Number (see Figure 37) to customer service for further support.<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_37_1de2ff80-2e71-40ff-939e-89eaf1f1e8bc.png?v=1785201482:Figure 37]`,
          video_url: ['https://youtu.be/JwJ4aAmCTPA', 'https://youtu.be/Ym8gOrVkKls'],
        },
        {
          Q: `10. Distorted engraving output from Glacier`,
          A: `Solution:<br/>
Confirm the type of distortion:<br/>
Engrave a circle and check whether it is fully closed.<br/>
◆ Fully closed but appears as an ellipse:<br/>
This may be caused by incorrect step settings of the machine.<br/>
* First, restore the factory settings through the software.<br/>
* In LightBurn or LaserGRBL, go to the machine settings and check whether the values of $100 and $101 are set to 100.<br/>
* If not, change both values to 100 (see Figure 38).<br/>
◆ Open shapes, misalignment, or wavy lines: These issues may be caused by machine structural problems. Please refer to the following structural adjustment methods.<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_38_355a6e36-aada-4b6d-9716-a10e936a4a88.png?v=1785201482:Figure 38]<br/>
Check the machine structure:<br/>
Refer to the Glacier structure adjustment video.<br/>
◆ X-axis parallelism check: Use a ruler to measure whether the distances from both ends of the X-axis to the lower crossbeam are the same, in order to determine whether the X-axis is parallel to the upper and lower crossbeams. If not parallel, the X-axis support frame may tilt, increasing friction with the Y-axis guide rails and hindering movement. The adjustment method is as follows:<br/>
-- Required tool: L2.0 hex (Allen) wrench<br/>
-- Steps:<br/>
Near the lower crossbeam, locate the Y-axis motor and the two linear shafts. Use an L2.0 hex wrench to loosen the set screws of the two shaft couplings on the linear shafts that are farther from the motor (see Figure 39).<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_39_50f4943b-9b6d-4836-a812-3252ea87e32f.png?v=1785201482:Figure 39]<br/>
② Move the X-axis to the top so that the X-axis cable chain is flush against the upper crossbeam (if the chain cannot stay in place, you can secure it with a string). Then tighten the previously loosened set screws on the shaft couplings.<br/>
③ After completing the operation, measure whether the distances from both ends of the X-axis to the upper or lower crossbeam are equal. If not, repeat the above steps.<br/>
◆ Check timing pulleys and coupling screws: Use an L2.0 hex (Allen) wrench to check whether the set screws on the couplings and timing pulleys are loose.<br/>
◆ Check Y-axis timing belts: Press the two Y-axis timing belts with two fingers to feel whether they have good elasticity and proper tension. If they feel loose, adjustment is required. The method is as follows:<br/>
-- Required tool: L2.5 hex (Allen) wrench<br/>
-- Steps:<br/>
① On the sides of the two Y-axes near the upper crossbeam end, use an L2.5 hex wrench to loosen the two screws on the timing belt tensioner (see Figure 40).<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_40_075d5b20-89e6-4131-bec8-e28940c7fe97.png?v=1785201482:Figure 40]<br/>
② Pull the timing belt tensioner by hand toward the upper crossbeam to tighten the belt until it has proper tension and elasticity, then tighten the two fixing screws on the tensioner.<br/>
③ Apply the same adjustment method to the other Y-axis.<br/>
◆ Check X-axis timing belt: Press the X-axis timing belt with two fingers to check whether it has good elasticity and proper tension. If it feels loose, adjustment is required. The method is as follows:<br/>
-- Required tools: L2.0 and L3.0 hex (Allen) wrenches<br/>
-- Steps:<br/>
① Locate the timing belt tensioner at the upper right side of the X-axis (see Figure 41). Use an L2.0 hex wrench to loosen the two set screws on the top.<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_41_32a1a5b5-b716-4546-a420-e754124e1720.png?v=1785204756:Figure 41]<br/>
② Use an L3.0 hex wrench to turn the side screw to tighten or loosen the timing belt.<br/>
◆ Check the X-axis guide rail slider: Gently shake the laser module by hand to check for any play. If it wobbles or if the X-axis movement is difficult, the eccentric wheels on the X-axis guide rail slider need to be adjusted.<br/>
-- Required tools: L2.0 hex (Allen) wrench, needle-nose pliers or similar tool<br/>
-- Steps:<br/>
① Loosen the side fixing screws to remove the laser module.<br/>
② Turn the Z-axis manual adjustment knob to move the Z-axis slider to the highest position. You will see two circular eccentric wheels (see Figure 42).<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_42_6b8ab935-00f0-45f0-92e1-2b58759fbd30.png?v=1785204757:Figure 42]<br/>
③ Use an L2.0 hex wrench to remove the set screws securing the eccentric wheels (see Figure 43).<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_43_937ed9f1-265e-4728-858d-a9c2e4859228.png?v=1785204756:Figure 43]<br/>
④ Use needle-nose pliers or a similar tool to insert into the two holes of the eccentric wheel and rotate it for adjustment (clockwise to tighten, counterclockwise to loosen). First loosen it, then gently move the Z-axis by hand to let it naturally align. After that, tighten the eccentric wheel clockwise, and finally reinstall the set screws.<br/>
⑤ After reinstalling the screws, move the Z-axis left and right by hand to check whether the movement is smooth, without wobbling or sticking. If any abnormality is found, readjust.<br/>
⑥ After adjustment is complete, reinstall the laser module.`,
          video_url: ['https://youtu.be/JwJ4aAmCTPA', ''],
        },
        {
          Q: `11. Glacier frequently triggers flame alarms during processing.`,
          A: `Solutions:<br/>
1）Check the material:<br/>
If the material is flammable (such as MDF, balsa wood, etc.), it may cause false flame alarms. You can disable the flame detection function via the touchscreen, mobile app, or AtomStack Studio software (see Figure 44). When cutting, it is recommended to appropriately increase the cutting speed and use multiple passes when processing thick materials.<br/>
Note: After disabling the flame detection function, close supervision by an operator is required.<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_44_42861e58-6505-4e14-9fb1-6f8c08a20f39.png?v=1785204756:Figure 44]<br/>
2）Check the engraving file:<br/>
If the processed pattern has very dense lines when the flame alarm is triggered, false alarms may occur. You should increase the speed, increase the number of passes, or disable the flame detection function.<br/>
Note: Close supervision by an operator is required during operation.<br/>
3）Check the flame detection board:<br/>
Perform processing at a lower power level. If the flame alarm is still frequently triggered at low power, the flame detection board may be faulty and should be replaced. Refer to the Glacier flame detection board replacement video for guidance.`,
          video_url: ['https://youtu.be/AFZaVnvNV5I'],
        },
        {
          Q: `12. Glacier collides with the frame during boundary tracing or engraving.`,
          A: `Solutions:<br/>
1）Check the file size:<br/>
The size of the engraving file imported into the software must not exceed Glacier’s working area, and the file must not contain negative coordinates. You can reopen the software and use its drawing tools to create a small test pattern to check whether the issue persists.<br/>
2）Check for software issues:<br/>
Try connecting and operating the machine using AtomStack Studio to see if the same problem occurs. Make sure to use a licensed version of LightBurn.<br/>
3）Verify movement:<br/>
Use the directional controls (up, down, left, right) in the software to check whether the movement distance and direction of the engraver are correct. If abnormal movement occurs, carefully inspect whether any cables are damaged and whether the motor connectors are properly plugged in.<br/>
4）Restore factory settings:<br/>
Perform a factory reset in AtomStack Studio or LightBurn. The steps are as follows:<br/>
◆ Factory reset in AtomStack Studio: For version 2.20 and above, tap “Version Number: V2.20” (client version number) seven times consecutively to enter Developer Mode. Return to the menu bar, open “Serial Port Log” (Developer Mode), and click “Reset” to restore factory settings. Refer to the AtomStack Studio factory reset video for guidance.<br/>
◆ Factory reset in LightBurn: Enter the command \`$RST=*\` in the “Console” to restore factory settings (see Figure 45).<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_45_ccd64f20-81d8-4ef4-a373-2e1d3fa17aab.png?v=1785204756:Figure 45]`,
          video_url: ['https://youtu.be/aYFFaF1ds4Q'],
        },
        {
          Q: `13. The Glacier laser module mounting bracket is loose.`,
          A: `Solution:<br/>
Adjust the eccentric wheels on the X-axis guide rail slider.<br/>
1）Required tools: L2.0 hex (Allen) wrench, needle-nose pliers or similar tool<br/>
2）Steps:<br/>
◆ Loosen the side fixing screws to remove the laser module.<br/>
◆ Turn the Z-axis manual adjustment knob to move the Z-axis slider to the highest position. You will see two circular eccentric wheels (see Figure 46).<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_46_4062a245-79e0-4fc4-87af-1e6ad571de09.png?v=1785205822:Figure 46]<br/>
◆ Use an L2.0 hex wrench to remove the set screws securing the eccentric wheels (see Figure 47).<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_47_4f424350-a03b-4721-89c4-af6a284005e0.png?v=1785205822:Figure 47]<br/>
◆ Use needle-nose pliers or a similar tool to insert into the two holes of the eccentric wheel and rotate it for adjustment (clockwise to tighten, counterclockwise to loosen). First loosen it, then gently move the Z-axis by hand to allow it to naturally align. After that, tighten the eccentric wheel clockwise, and finally reinstall the set screws.<br/>
◆ After reinstalling the screws, move the Z-axis left and right by hand to check whether the movement is smooth, without wobbling or sticking. If any abnormality is found, readjust.<br/>
◆ After adjustment is complete, reinstall the laser module.`,
          video_url: [],
        },
        {
          Q: `14. When engraving via the mobile app, Glacier prompts that no USB drive is inserted.`,
          A: `Solutions:<br/>
1) Restart the machine: Turn off the power and close the mobile app. Restart both the machine and the app, then try again.<br/>
2) Try another phone: Use a different mobile device to test. If the other phone works normally, please provide the phone model and upload the logs to our system (see Figure 48).<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_48_f5414ecb-219a-4475-ba3c-2f64c5b9d33c.png?v=1785205822:Figure 48]<br/>
3) Check the USB drive: Remove the USB drive from the control box and insert it into a computer to check whether data can be read and written properly.<br/>
◆ If data can be read normally: Replace it with another USB drive (32 GB or less) and insert it into the machine’s control box to test. If engraving works normally after replacement, the original USB drive is faulty.<br/>
◆ If data cannot be read normally: Format the USB drive on a computer to FAT32, then reinsert it into the control box and test again. If the issue persists, try another USB drive (32 GB or less).<br/>
◆ If data can be read normally, but replacing with another USB drive (32 GB or less) still does not resolve the issue, the motherboard USB port may be faulty. Please provide detailed troubleshooting steps, a video, and the machine’s Serial Number (see Figure 49), and send them to customer support for assistance. For motherboard replacement, refer to the Glacier motherboard replacement video.<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_49_f08fa36c-0d32-44d1-bfb5-907f6de16255.png?v=1785205821:Figure 49]`,
          video_url: ['https://youtu.be/G9NPYDo0aTg'],
        },
        {
          Q: `15. After connecting, Glacier continuously prompts that no USB key is inserted.`,
          A: `Solutions:<br/>
1) Reconnect the USB key: Turn off the machine, remove the USB key, then reinsert it. Power on the machine and check whether it works normally.<br/>
2) Use the spare USB key: Turn off the machine, remove the current USB key, and insert the provided spare USB key to check whether it works properly.<br/>
3) If the issue persists with the spare USB key: If the alarm continues, the motherboard may be faulty. Please provide the troubleshooting steps performed, a video of the issue, and the machine’s Serial Number (see Figure 50), and send them to customer support for assistance. For motherboard replacement, refer to the Glacier motherboard replacement video.<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_50_0dc483ae-dde6-4176-bf33-9bfabd753f40.png?v=1785205821:Figure 50]`,
          video_url: ['https://youtu.be/G9NPYDo0aTg'],
        },
        {
          Q: `16. After powering on, the Glacier laser module cannot be moved by hand to the desired engraving position.`,
          A: `Solutions:<br/>
Check the “Power-off Resume” function: After connecting via AtomStack Studio or the mobile app, tap the icon in the upper right corner to enter the device information. Check whether the “Power-off Resume” function is enabled (when this function is enabled, the laser head must be moved using the directional controls in the software) (see Figure 51).<br/>
If it is enabled, please disable it. After disabling, you will be able to manually move the laser module to the desired engraving position while the machine is powered on.<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_51_bee2632b-2752-4695-b6a4-fb74729eb9a8.png?v=1785205992:Figure 51]<br/>
2) If the “Power-off Resume” function is not enabled and the laser module still cannot be moved by hand after powering on, the motherboard may be faulty. Please provide a video of the issue (the video should include the troubleshooting steps described in item (1)), along with the machine’s Serial Number (see Figure 52), and send them to customer support for assistance. For motherboard replacement, refer to the Glacier motherboard replacement video.<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_52_83a13642-dd84-4b80-8cd8-9771dbbe6af9.png?v=1785205992:Figure 52]`,
          video_url: ['https://youtu.be/G9NPYDo0aTg'],
        },
        {
          Q: `17. Glacier air assist malfunction.`,
          A: `Solutions:<br/>
1) Confirm the engraver is running: If the air assist is connected to the AIR ASSIST port on the motherboard, it will only activate during engraving or cutting operations.<br/>
2) Check the knob switch: Make sure the air assist knob switch is turned on. Note that rotating the knob clockwise turns on the air assist and adjusts the airflow rate.<br/>
3) Check the power supply: Use a DC 24V power supply to power the air assist directly and check whether it can start normally.<br/>
If it does not start when powered by the motherboard during engraving or cutting, but can start when powered directly by a DC 24V supply, the issue may be with the motherboard or the air pump power cable. You can use a multimeter to test the continuity of the air pump power cable and send the results to customer support for further assistance.<br/>
4) Check the operating status after startup: After starting engraving or supplying power to the air assist separately, turn the knob switch to check whether the air assist vibrates.<br/>
◆ No response at all: The knob switch may be faulty. Please send a video of the issue along with the machine’s Serial Number (see Figure 53) to customer support. For replacement, refer to the air assist knob switch replacement video.<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_53_55f46b4e-2f8b-4a9d-a1e7-b103b445faf6.png?v=1785205992:Figure 53]<br/>
◆ Vibration present but no airflow or very weak airflow: The air pump may be faulty and needs to be replaced. Please send a video of the issue along with the machine’s Serial Number to customer support. For replacement, refer to the air assist pump replacement video.`,
          video_url: ['https://youtu.be/BZh7FTwe9tw', 'https://youtu.be/qG9kFGDaoMU'],
        },
        {
          Q: `18. Glacier chiller display screen is cracked.`,
          A: `Solution:<br/>
If the chiller display screen is damaged, the screen assembly must be replaced. Please provide photos of the packaging, photos of the damage, and the machine’s Serial Number (see Figure 54), and send them to customer support for assistance. For replacement, refer to the Glacier chiller display screen replacement video.<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_54_85ba8926-6e5d-46e7-a0e5-6f5d00752a62.png?v=1785205992:Figure 54]`,
          video_url: ['https://youtu.be/22_egYEreCs'],
        },
        {
          Q: `19. When using the rotary attachment with Glacier, it continuously rotates upon startup.`,
          A: `Solution:<br/>
This behavior is typically caused by the homing function in LightBurn. Please open “Device Settings”, and under “Other Options”, disable the “Auto-home on startup” function (see Figure 55).<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_55_b42e3eff-bbaf-49dc-88c4-206ed4360a46.png?v=1785205992:Figure 55]`,
          video_url: [],
        },
        {
          Q: `20. Glacier firmware upgrade.`,
          A: `Solution:<br/>
Please refer to the Glacier firmware upgrade video.<br/>
1) Upgrade via USB drive / TF card: Copy the Glacier firmware file (in .bin format) to the root directory of a USB drive or TF card, then insert it into the control box to perform an automatic upgrade.<br/>
Note: The same firmware version cannot be upgraded repeatedly, and firmware files with different names will not trigger automatic upgrading.<br/>
2) Upgrade via AtomStack Studio: After a successful connection, click the menu icon (three lines) in the upper right corner of the software to enter Device Information. At the bottom, you can check the current firmware version.<br/>
If it shows that the version is already the latest, no upgrade is needed. If it shows “Update” (see Figure 56), a firmware upgrade is available. Insert a USB drive or TF card, then click “Update” and wait for the process to complete.<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_56_375c4b6f-1552-4aab-9a7d-b094b4e36083.png?v=1785205992:Figure 56]<br/>
3) Upgrade via mobile app: After connecting via the mobile app, a prompt will automatically appear if a new firmware version is available. To update, insert a USB drive or TF card and tap “Update”, then wait for completion.`,
          video_url: ['https://youtu.be/Gt8WUiWozO0'],
        },
        {
          Q: `21、Possible alarm codes for Glacier.`,
          A: `[table:alarm_codes]`,
          tables: {
            alarm_codes: {
              headers: ['Alarm Name', 'Description', 'Solution'],
              rows: [
                [
                  'Alarm 1',
                  'Hard limit alarm',
                  '1. Check whether a limit switch has been triggered.<br/>2. Manually press the limit switch to verify proper triggering.<br/>3. Disconnect the limit switch cable and check whether the alarm still occurs.',
                ],
                [
                  'Alarm 2',
                  'Soft limit alarm',
                  'This alarm generally does not occur under normal conditions.',
                ],
                ['Alarm 3', 'Abort Cycle', 'Normal, no action required.'],
                [
                  'Alarm 4',
                  'Probe Fail Initial',
                  'Manually press the limit switch to verify whether it can be triggered properly.',
                ],
                [
                  'Alarm 5',
                  'Probe Fail Contact',
                  'The probe was not triggered within the travel range during auto focus.',
                ],
                [
                  'Alarm 6',
                  'Homing Fail Reset',
                  'Homing failed, possibly due to a triggered limit switch.',
                ],
                [
                  'Alarm 7',
                  'Homing Fail Door',
                  'The enclosure door was opened during the homing process.',
                ],
                [
                  'Alarm 8',
                  'Homing Fail Pulloff',
                  'Check the limit switches. This often occurs due to autofocus errors. First manually verify that all limit switches can be triggered.',
                ],
                [
                  'Alarm 9',
                  'Homing Fail Approach',
                  'No limit switch was detected within the search distance. Manually verify that all limit switches function properly.',
                ],
                [
                  'Alarm 11',
                  'Machine Tilt Alarm',
                  'The machine tilt protection has been triggered.',
                ],
                [
                  'Alarm 12',
                  'Flame Detected',
                  'Flame detected. Check whether the material is flammable (e.g., MDF, balsa wood), whether the pattern is too dense, or whether direct sunlight is causing a false alarm.',
                ],
                [
                  'Alarm 14',
                  'Safe Lock',
                  'USB key is not inserted or has poor contact.',
                ],
                [
                  'Alarm 17',
                  'Bluetooth enabled',
                  'The device is in network configuration mode; all other operations are disabled.',
                ],
                [
                  'Alarm 19',
                  'Over temperature alarm',
                  'Laser temperature exceeds the limit. Check the cooling system.',
                ],
                [
                  'Alarm 20',
                  'Chiller alarm',
                  'Chiller alarm triggered. Check the chiller error code.',
                ],
              ],
            },
          },
          video_url: [],
        },
      ],
    ],
  },
};
